// src/utils/tick-util.ts
import BN3 from "bn.js";

// src/constants/errors.ts
var MathErrorCode = /* @__PURE__ */ ((MathErrorCode2) => {
  MathErrorCode2["IntegerDowncastOverflow"] = `IntegerDowncastOverflow`;
  MathErrorCode2["MulOverflow"] = `MultiplicationOverflow`;
  MathErrorCode2["MulDivOverflow"] = `MulDivOverflow`;
  MathErrorCode2["MulShiftRightOverflow"] = `MulShiftRightOverflow`;
  MathErrorCode2["MulShiftLeftOverflow"] = `MulShiftLeftOverflow`;
  MathErrorCode2["DivideByZero"] = `DivideByZero`;
  MathErrorCode2["UnsignedIntegerOverflow"] = `UnsignedIntegerOverflow`;
  MathErrorCode2["InvalidCoinAmount"] = `InvalidCoinAmount`;
  MathErrorCode2["InvalidLiquidityAmount"] = `InvalidLiquidityAmount`;
  MathErrorCode2["InvalidReserveAmount"] = `InvalidReserveAmount`;
  MathErrorCode2["InvalidSqrtPrice"] = `InvalidSqrtPrice`;
  MathErrorCode2["NotSupportedThisCoin"] = `NotSupportedThisCoin`;
  MathErrorCode2["InvalidTwoTickIndex"] = `InvalidTwoTickIndex`;
  return MathErrorCode2;
})(MathErrorCode || {});
var CoinErrorCode = /* @__PURE__ */ ((CoinErrorCode2) => {
  CoinErrorCode2["CoinAmountMaxExceeded"] = `CoinAmountMaxExceeded`;
  CoinErrorCode2["CoinAmountMinSubceeded"] = `CoinAmountMinSubceeded `;
  CoinErrorCode2["SqrtPriceOutOfBounds"] = `SqrtPriceOutOfBounds`;
  CoinErrorCode2["InvalidCoinFields"] = `InvalidCoinFields`;
  return CoinErrorCode2;
})(CoinErrorCode || {});
var SwapErrorCode = /* @__PURE__ */ ((SwapErrorCode2) => {
  SwapErrorCode2["InvalidSqrtPriceLimitDirection"] = `InvalidSqrtPriceLimitDirection`;
  SwapErrorCode2["ZeroTradableAmount"] = `ZeroTradableAmount`;
  SwapErrorCode2["AmountOutBelowMinimum"] = `AmountOutBelowMinimum`;
  SwapErrorCode2["AmountInAboveMaximum"] = `AmountInAboveMaximum`;
  SwapErrorCode2["NextTickNotFound"] = `NextTickNoutFound`;
  SwapErrorCode2["TickArraySequenceInvalid"] = `TickArraySequenceInvalid`;
  SwapErrorCode2["TickArrayCrossingAboveMax"] = `TickArrayCrossingAboveMax`;
  SwapErrorCode2["TickArrayIndexNotInitialized"] = `TickArrayIndexNotInitialized`;
  SwapErrorCode2["ParamsLengthNotEqual"] = `ParamsLengthNotEqual`;
  return SwapErrorCode2;
})(SwapErrorCode || {});
var PositionErrorCode = /* @__PURE__ */ ((PositionErrorCode2) => {
  PositionErrorCode2["InvalidTickEvent"] = `InvalidTickEvent`;
  PositionErrorCode2["InvalidPositionObject"] = `InvalidPositionObject`;
  PositionErrorCode2["InvalidPositionRewardObject"] = `InvalidPositionRewardObject`;
  return PositionErrorCode2;
})(PositionErrorCode || {});
var PoolErrorCode = /* @__PURE__ */ ((PoolErrorCode2) => {
  PoolErrorCode2["InvalidCoinTypeSequence"] = `InvalidCoinTypeSequence`;
  PoolErrorCode2["InvalidTickIndex"] = `InvalidTickIndex`;
  PoolErrorCode2["InvalidPoolObject"] = `InvalidPoolObject`;
  PoolErrorCode2["InvalidTickObjectId"] = `InvalidTickObjectId`;
  PoolErrorCode2["InvalidTickObject"] = `InvalidTickObject`;
  PoolErrorCode2["InvalidTickFields"] = `InvalidTickFields`;
  PoolErrorCode2["PoolsNotFound"] = `PoolsNotFound`;
  return PoolErrorCode2;
})(PoolErrorCode || {});
var PartnerErrorCode = /* @__PURE__ */ ((PartnerErrorCode2) => {
  PartnerErrorCode2["NotFoundPartnerObject"] = `NotFoundPartnerObject`;
  PartnerErrorCode2["InvalidParnterRefFeeFields"] = `InvalidParnterRefFeeFields`;
  return PartnerErrorCode2;
})(PartnerErrorCode || {});
var ConfigErrorCode = /* @__PURE__ */ ((ConfigErrorCode2) => {
  ConfigErrorCode2["InvalidConfig"] = `InvalidConfig`;
  ConfigErrorCode2["InvalidConfigHandle"] = `InvalidConfigHandle`;
  ConfigErrorCode2["InvalidSimulateAccount"] = `InvalidSimulateAccount`;
  return ConfigErrorCode2;
})(ConfigErrorCode || {});
var UtilsErrorCode = /* @__PURE__ */ ((UtilsErrorCode2) => {
  UtilsErrorCode2["InvalidSendAddress"] = `InvalidSendAddress`;
  UtilsErrorCode2["InvalidRecipientAddress"] = `InvalidRecipientAddress`;
  UtilsErrorCode2["InvalidRecipientAndAmountLength"] = `InvalidRecipientAndAmountLength`;
  UtilsErrorCode2["InsufficientBalance"] = `InsufficientBalance`;
  UtilsErrorCode2["InvalidTarget"] = `InvalidTarget`;
  UtilsErrorCode2["InvalidTransactionBuilder"] = `InvalidTransactionBuilder`;
  return UtilsErrorCode2;
})(UtilsErrorCode || {});
var RouterErrorCode = /* @__PURE__ */ ((RouterErrorCode2) => {
  RouterErrorCode2["InvalidCoin"] = `InvalidCoin`;
  RouterErrorCode2["NotFoundPath"] = `NotFoundPath`;
  RouterErrorCode2["NoDowngradeNeedParams"] = `NoDowngradeNeedParams`;
  RouterErrorCode2["InvalidSwapCountUrl"] = `InvalidSwapCountUrl`;
  RouterErrorCode2["InvalidTransactionBuilder"] = `InvalidTransactionBuilder`;
  RouterErrorCode2["InvalidServerResponse"] = `InvalidServerResponse`;
  return RouterErrorCode2;
})(RouterErrorCode || {});
var TypesErrorCode = /* @__PURE__ */ ((TypesErrorCode2) => {
  TypesErrorCode2["InvalidType"] = `InvalidType`;
  return TypesErrorCode2;
})(TypesErrorCode || {});
var ClmmpoolsError = class _ClmmpoolsError extends Error {
  message;
  errorCode;
  constructor(message, errorCode) {
    super(message);
    this.message = message;
    this.errorCode = errorCode;
  }
  static isClmmpoolsErrorCode(e, code) {
    return e instanceof _ClmmpoolsError && e.errorCode === code;
  }
};

// src/constants/tick.ts
import BN from "bn.js";
var MAX_TICK_INDEX = 443636;
var MIN_TICK_INDEX = -443636;
var MAX_SQRT_PRICE = "79226673515401279992447579055";
var TICK_ARRAY_SIZE = 64;
var MIN_SQRT_PRICE = "4295048016";
var FEE_RATE_DENOMINATOR = new BN(1e6);

// src/constants/modules.ts
var ClmmPartnerModule = "partner";
var ClmmIntegratePoolModule = "pool_facade";
var ClmmIntegrateRouterModule = "router";
var ClmmIntegrateRouterWithPartnerModule = "router_with_partner";
var ClmmFetcherModule = "fetcher";
var ClmmExpectSwapModule = "expect_swap";
var ClmmIntegrateCoinUtilsModule = "coin_utils";
var DeepbookCustodianV2Moudle = "custodian_v2";
var DeepbookClobV2Moudle = "clob_v2";
var DeepbookEndpointsV2Moudle = "endpoints_v2";

// src/constants/addresses.ts
var CLOCK_ADDRESS = "0x0000000000000000000000000000000000000000000000000000000000000006";
var CoinInfoAddress = "0x1::coin::CoinInfo";
var CoinStoreAddress = "0x1::coin::CoinStore";

// src/constants/swap.ts
var SwapDirection = /* @__PURE__ */ ((SwapDirection2) => {
  SwapDirection2["A2B"] = "a2b";
  SwapDirection2["B2A"] = "b2a";
  return SwapDirection2;
})(SwapDirection || {});
var SplitSwapUnit = /* @__PURE__ */ ((SplitSwapUnit2) => {
  SplitSwapUnit2[SplitSwapUnit2["FIVE"] = 5] = "FIVE";
  SplitSwapUnit2[SplitSwapUnit2["TEN"] = 10] = "TEN";
  SplitSwapUnit2[SplitSwapUnit2["TWENTY"] = 20] = "TWENTY";
  SplitSwapUnit2[SplitSwapUnit2["TWENTY_FIVE"] = 25] = "TWENTY_FIVE";
  SplitSwapUnit2[SplitSwapUnit2["FIVETY"] = 50] = "FIVETY";
  SplitSwapUnit2[SplitSwapUnit2["HUNDRED"] = 100] = "HUNDRED";
  return SplitSwapUnit2;
})(SplitSwapUnit || {});

// src/constants/gas.ts
var DEFAULT_GAS_BUDGET_FOR_SPLIT = 1e3;
var DEFAULT_GAS_BUDGET_FOR_MERGE = 500;
var DEFAULT_GAS_BUDGET_FOR_TRANSFER = 100;
var DEFAULT_GAS_BUDGET_FOR_TRANSFER_SUI = 100;
var DEFAULT_GAS_BUDGET_FOR_STAKE = 1e3;
var GAS_TYPE_ARG = "0x2::sui::SUI";
var GAS_TYPE_ARG_LONG = "0x0000000000000000000000000000000000000000000000000000000000000002::sui::SUI";
var GAS_SYMBOL = "SUI";
var DEFAULT_NFT_TRANSFER_GAS_FEE = 450;
var SUI_SYSTEM_STATE_OBJECT_ID = "0x0000000000000000000000000000000000000005";

// src/utils/math-util.ts
import BN2 from "bn.js";
import Decimal from "decimal.js";
var ZERO = new BN2(0);
var ONE = new BN2(1);
var TWO = new BN2(2);
var U128 = TWO.pow(new BN2(128));
var U64_MAX = TWO.pow(new BN2(64)).sub(ONE);
var U128_MAX = TWO.pow(new BN2(128)).sub(ONE);
Decimal.config({
  precision: 64,
  rounding: Decimal.ROUND_DOWN,
  toExpNeg: -64,
  toExpPos: 64
});
var MathUtil = class {
  static toX64_BN(num) {
    return num.mul(new BN2(2).pow(new BN2(64)));
  }
  static toX64_Decimal(num) {
    return num.mul(Decimal.pow(2, 64));
  }
  static toX64(num) {
    return new BN2(num.mul(Decimal.pow(2, 64)).floor().toFixed());
  }
  static fromX64(num) {
    return new Decimal(num.toString()).mul(Decimal.pow(2, -64));
  }
  static fromX64_Decimal(num) {
    return num.mul(Decimal.pow(2, -64));
  }
  static fromX64_BN(num) {
    return num.div(new BN2(2).pow(new BN2(64)));
  }
  static shiftRightRoundUp(n) {
    let result = n.shrn(64);
    if (n.mod(U64_MAX).gt(ZERO)) {
      result = result.add(ONE);
    }
    return result;
  }
  static divRoundUp(n0, n1) {
    const hasRemainder = !n0.mod(n1).eq(ZERO);
    if (hasRemainder) {
      return n0.div(n1).add(new BN2(1));
    }
    return n0.div(n1);
  }
  static subUnderflowU128(n0, n1) {
    if (n0.lt(n1)) {
      return n0.sub(n1).add(U128_MAX);
    }
    return n0.sub(n1);
  }
  static checkUnsignedSub(n0, n1) {
    const n = n0.sub(n1);
    if (n.isNeg()) {
      throw new ClmmpoolsError(
        "Unsigned integer sub overflow",
        "UnsignedIntegerOverflow" /* UnsignedIntegerOverflow */
      );
    }
    return n;
  }
  static checkMul(n0, n1, limit) {
    const n = n0.mul(n1);
    if (this.isOverflow(n, limit)) {
      throw new ClmmpoolsError("Multiplication overflow", "MultiplicationOverflow" /* MulOverflow */);
    }
    return n;
  }
  static checkMulDivFloor(n0, n1, denom, limit) {
    if (denom.eq(ZERO)) {
      throw new ClmmpoolsError("Devide by zero", "DivideByZero" /* DivideByZero */);
    }
    const n = n0.mul(n1).div(denom);
    if (this.isOverflow(n, limit)) {
      throw new ClmmpoolsError("Multiplication div overflow", "MulDivOverflow" /* MulDivOverflow */);
    }
    return n;
  }
  static checkMulDivCeil(n0, n1, denom, limit) {
    if (denom.eq(ZERO)) {
      throw new ClmmpoolsError("Devide by zero", "DivideByZero" /* DivideByZero */);
    }
    const n = n0.mul(n1).add(denom.sub(ONE)).div(denom);
    if (this.isOverflow(n, limit)) {
      throw new ClmmpoolsError("Multiplication div overflow", "MulDivOverflow" /* MulDivOverflow */);
    }
    return n;
  }
  static checkMulDivRound(n0, n1, denom, limit) {
    if (denom.eq(ZERO)) {
      throw new ClmmpoolsError("Devide by zero", "DivideByZero" /* DivideByZero */);
    }
    const n = n0.mul(n1.add(denom.shrn(1))).div(denom);
    if (this.isOverflow(n, limit)) {
      throw new ClmmpoolsError("Multiplication div overflow", "MulDivOverflow" /* MulDivOverflow */);
    }
    return n;
  }
  static checkMulShiftRight(n0, n1, shift, limit) {
    const n = n0.mul(n1).div(new BN2(2).pow(new BN2(shift)));
    if (this.isOverflow(n, limit)) {
      throw new ClmmpoolsError(
        "Multiplication shift right overflow",
        "MulShiftRightOverflow" /* MulShiftRightOverflow */
      );
    }
    return n;
  }
  static checkMulShiftRight64RoundUpIf(n0, n1, limit, roundUp) {
    const p = n0.mul(n1);
    const shoudRoundUp = roundUp && p.and(U64_MAX).gt(ZERO);
    const result = shoudRoundUp ? p.shrn(64).add(ONE) : p.shrn(64);
    if (this.isOverflow(result, limit)) {
      throw new ClmmpoolsError(
        "Multiplication shift right overflow",
        "MulShiftRightOverflow" /* MulShiftRightOverflow */
      );
    }
    return result;
  }
  static checkMulShiftLeft(n0, n1, shift, limit) {
    const n = n0.mul(n1).shln(shift);
    if (this.isOverflow(n, limit)) {
      throw new ClmmpoolsError(
        "Multiplication shift left overflow",
        "MulShiftLeftOverflow" /* MulShiftLeftOverflow */
      );
    }
    return n;
  }
  static checkDivRoundUpIf(n0, n1, roundUp) {
    if (n1.eq(ZERO)) {
      throw new ClmmpoolsError("Devide by zero", "DivideByZero" /* DivideByZero */);
    }
    if (roundUp) {
      return this.divRoundUp(n0, n1);
    }
    return n0.div(n1);
  }
  static isOverflow(n, bit) {
    return n.gte(TWO.pow(new BN2(bit)));
  }
  static sign(v) {
    const signBit = v.testn(127) ? 1 : 0;
    return signBit;
  }
  static is_neg(v) {
    return this.sign(v) === 1;
  }
  static abs_u128(v) {
    if (v.gt(ZERO)) {
      return v;
    }
    return this.u128_neg(v.subn(1));
  }
  static u128_neg(v) {
    return v.uxor(new BN2("ffffffffffffffffffffffffffffffff", 16));
  }
  static neg(v) {
    if (this.is_neg(v)) {
      return v.abs();
    }
    return this.neg_from(v);
  }
  static abs(v) {
    if (this.sign(v) === 0) {
      return v;
    }
    return this.u128_neg(v.sub(new BN2(1)));
  }
  static neg_from(v) {
    if (v.eq(ZERO)) {
      return v;
    }
    return this.u128_neg(v).add(new BN2(1)).or(new BN2(1).shln(127));
  }
  /**
   * Converts an amount in decimals to its corresponding numerical value.
   * @param {number|string} amount - The amount to convert.
   * @param {number|string} decimals - The number of decimal places used in the amount.
   * @returns {number} - Returns the converted numerical value.
   */
  static fromDecimalsAmount(amount, decimals) {
    return new Decimal(amount).div(Decimal.pow(10, decimals)).toNumber();
  }
  /**
   * Converts an amount to a decimal value, based on the number of decimals specified.
   * @param  {number | string} amount - The amount to convert to decimal.
   * @param  {number | string} decimals - The number of decimals to use in the conversion.
   * @returns {number} - Returns the converted amount as a number.
   */
  static toDecimalsAmount(amount, decimals) {
    return new Decimal(amount).mul(Decimal.pow(10, decimals)).toNumber();
  }
  /**
   * Converts a bigint to an unsigned integer of the specified number of bits.
   * @param {bigint} int - The bigint to convert.
   * @param {number} bits - The number of bits to use in the conversion. Defaults to 32 bits.
   * @returns {string} - Returns the converted unsigned integer as a string.
   */
  static asUintN(int, bits = 32) {
    return BigInt.asUintN(bits, BigInt(int)).toString();
  }
  /**
   * Converts a bigint to a signed integer of the specified number of bits.
   * @param {bigint} int - The bigint to convert.
   * @param {number} bits - The number of bits to use in the conversion. Defaults to 32 bits.
   * @returns {number} - Returns the converted signed integer as a number.
   */
  static asIntN(int, bits = 32) {
    return Number(BigInt.asIntN(bits, BigInt(int)));
  }
  static toDecimal(value) {
    if (Decimal.isDecimal(value)) return value;
    if (BN2.isBN(value)) return new Decimal(value.toString());
    return new Decimal(value === void 0 ? 0 : value);
  }
};

// src/utils/sui-util.ts
import { normalizeSuiObjectId } from "@mysten/sui/utils";
var SuiUtil = class {
  static getSuiObjectData(resp) {
    return resp.data;
  }
  static getObjectDeletedResponse(resp) {
    if (resp.error && "object_id" in resp.error && "version" in resp.error && "digest" in resp.error) {
      const { error } = resp;
      return {
        objectId: error.object_id,
        version: error.version,
        digest: error.digest
      };
    }
    return void 0;
  }
  static getObjectNotExistsResponse(resp) {
    if (resp.error && "object_id" in resp.error && !("version" in resp.error) && !("digest" in resp.error)) {
      return resp.error.object_id;
    }
    return void 0;
  }
  static getObjectReference(resp) {
    if ("reference" in resp) {
      return resp.reference;
    }
    const exists = this.getSuiObjectData(resp);
    if (exists) {
      return {
        objectId: exists.objectId,
        version: exists.version,
        digest: exists.digest
      };
    }
    return this.getObjectDeletedResponse(resp);
  }
  static getObjectId(data) {
    if ("objectId" in data) {
      return data.objectId;
    }
    return this.getObjectReference(data)?.objectId ?? this.getObjectNotExistsResponse(data);
  }
  static getObjectVersion(data) {
    if ("version" in data) {
      return data.version;
    }
    return this.getObjectReference(data)?.version;
  }
  static isSuiObjectResponse(resp) {
    return resp.data !== void 0;
  }
  static isSuiObjectDataWithContent(data) {
    return data.content !== void 0;
  }
  static getMovePackageContent(data) {
    const suiObject = this.getSuiObjectData(data);
    if (suiObject?.content?.dataType !== "package") {
      return void 0;
    }
    return suiObject.content.disassembled;
  }
  static getMoveObject(data) {
    const suiObject = "data" in data ? this.getSuiObjectData(data) : data;
    if (!suiObject || !this.isSuiObjectDataWithContent(suiObject) || suiObject.content.dataType !== "moveObject") {
      return void 0;
    }
    return suiObject.content;
  }
  static getMoveObjectType(resp) {
    return this.getMoveObject(resp)?.type;
  }
  /**
   * Deriving the object type from the object response
   * @returns 'package' if the object is a package, move object type(e.g., 0x2::coin::Coin<0x2::sui::SUI>)
   * if the object is a move object
   */
  static getObjectType(resp) {
    const data = this.isSuiObjectResponse(resp) ? resp.data : resp;
    if (!data?.type && "data" in resp) {
      if (data?.content?.dataType === "package") {
        return "package";
      }
      return this.getMoveObjectType(resp);
    }
    return data?.type;
  }
  static getObjectPreviousTransactionDigest(resp) {
    return this.getSuiObjectData(resp)?.previousTransaction;
  }
  static getObjectOwner(resp) {
    return this.getSuiObjectData(resp)?.owner;
  }
  static getObjectDisplay(resp) {
    const display = this.getSuiObjectData(resp)?.display;
    if (!display) {
      return { data: null, error: null };
    }
    return display;
  }
  /**
   * Get the fields of a sui object response or data. The dataType of the object must be moveObject.
   * @param {SuiObjectResponse | SuiObjectData}object The object to get the fields from.
   * @returns {any} The fields of the object.
   */
  static getObjectFields(object) {
    const fields = this.getMoveObject(object)?.fields;
    if (fields) {
      if ("fields" in fields) {
        return fields.fields;
      }
      return fields;
    }
    return void 0;
  }
  /**
   * Return hasPublicTransfer of a move object.
   * @param {SuiObjectResponse | SuiObjectData}data
   * @returns
   */
  static hasPublicTransfer(data) {
    return this.getMoveObject(data)?.hasPublicTransfer ?? false;
  }
  /**
   * Recursively traverses the given data object and patches any string values that represent Sui object IDs.
   *
   * @param {any} data - The data object to be patched.
   */
  static patchFixSuiObjectId(data) {
    for (const key in data) {
      const type = typeof data[key];
      if (type === "object") {
        this.patchFixSuiObjectId(data[key]);
      } else if (type === "string") {
        const value = data[key];
        if (value && !value.includes("::")) {
          data[key] = this.fixSuiObjectId(value);
        }
      }
    }
  }
  static fixSuiObjectId(value) {
    if (value.toLowerCase().startsWith("0x")) {
      return normalizeSuiObjectId(value);
    }
    return value;
  }
};

// src/utils/tick-util.ts
var TickUtil = class {
  static isValidIndex(tickIndex) {
    return MIN_TICK_INDEX < tickIndex && tickIndex < MAX_TICK_INDEX;
  }
  /**
   * Get min tick index.
   * @param tick_spacing tick spacing
   * @returns min tick index
   */
  static getMinIndex(tickSpacing) {
    return MIN_TICK_INDEX + Math.abs(MIN_TICK_INDEX) % tickSpacing;
  }
  /**
   * Get max tick index.
   * @param tick_spacing - tick spacing
   * @returns max tick index
   */
  // eslint-disable-next-line camelcase
  static getMaxIndex(tickSpacing) {
    return MAX_TICK_INDEX - MAX_TICK_INDEX % tickSpacing;
  }
  /**
   * Get nearest tick by current tick.
   *
   * @param tickIndex
   * @param tickSpacing
   * @returns
   */
  static getNearestTickByTick(tickIndex, tickSpacing) {
    const mod = Math.abs(tickIndex) % tickSpacing;
    if (tickIndex > 0) {
      if (mod > tickSpacing / 2) {
        return tickIndex + tickSpacing - mod;
      }
      return tickIndex - mod;
    }
    if (mod > tickSpacing / 2) {
      return tickIndex - tickSpacing + mod;
    }
    return tickIndex + mod;
  }
  /**
   * Calculate reward amount in tick range.
   * @param {PoolStruct}pool Pool object.
   * @param {TickData}tickLower Tick lower data.
   * @param {TickData}tickUpper Tick upper data.
   * @param {number}tickLowerIndex Tick lower index.
   * @param {number}tickUpperIndex Tick upper index.
   * @param {BN[]}growthGlobal
   * @returns
   */
  static getRewardInTickRange(pool, tickLower, tickUpper, tickLowerIndex, tickUpperIndex, growthGlobal) {
    const rewarderInfos = pool.rewarder_infos;
    const rewarderGrowthInside = [];
    for (let i = 0; i < rewarderInfos.length; i += 1) {
      let rewarder_growth_below = growthGlobal[i];
      if (tickLower !== null) {
        if (pool.current_tick_index < tickLowerIndex) {
          rewarder_growth_below = growthGlobal[i].sub(
            new BN3(tickLower.rewarders_growth_outside[i])
          );
        } else {
          rewarder_growth_below = tickLower.rewarders_growth_outside[i];
        }
      }
      let rewarder_growth_above = new BN3(0);
      if (tickUpper !== null) {
        if (pool.current_tick_index >= tickUpperIndex) {
          rewarder_growth_above = growthGlobal[i].sub(
            new BN3(tickUpper.rewarders_growth_outside[i])
          );
        } else {
          rewarder_growth_above = tickUpper.rewarders_growth_outside[i];
        }
      }
      const rewGrowthInside = MathUtil.subUnderflowU128(
        MathUtil.subUnderflowU128(new BN3(growthGlobal[i]), new BN3(rewarder_growth_below)),
        new BN3(rewarder_growth_above)
      );
      rewarderGrowthInside.push(rewGrowthInside);
    }
    return rewarderGrowthInside;
  }
  /**
   * Builds a TickData object based on a response containing information about tick data.
   * It must check if the response contains the required fields.
   * @param {SuiObjectResponse} objects - The response containing information about tick data.
   * @returns {TickData} - The built TickData object.
   */
  static buildTickData(objects) {
    if (objects.error != null || objects.data?.content?.dataType !== "moveObject") {
      throw new ClmmpoolsError(
        `Tick not exists. Get tick data error:${objects.error}`,
        "InvalidTickObject" /* InvalidTickObject */
      );
    }
    const fields = SuiUtil.getObjectFields(objects);
    const valueItem = fields.value.fields.value.fields;
    const position = {
      object_id: SuiUtil.getObjectId(objects),
      index: MathUtil.asIntN(BigInt(valueItem.index.fields.bits)),
      sqrt_price: new BN3(valueItem.sqrt_price),
      liquidity_net: new BN3(valueItem.liquidity_net.fields.bits),
      liquidity_gross: new BN3(valueItem.liquidity_gross),
      fee_growth_outside_a: new BN3(valueItem.fee_growth_outside_a),
      fee_growth_outside_b: new BN3(valueItem.fee_growth_outside_b),
      rewarders_growth_outside: (valueItem.rewards_growth_outside || []).map(
        (value) => new BN3(value)
      )
    };
    return position;
  }
  /**
   * Builds a TickData object based on a given event's fields.
   * @param {any} fields - The fields of an event.
   * @returns {TickData} - The built TickData object.
   * @throws {Error} If any required field is missing.
   */
  static buildTickDataByEvent(fields) {
    if (!fields || !fields.index || !fields.sqrt_price || !fields.liquidity_net || !fields.liquidity_gross || !fields.fee_growth_outside_a || !fields.fee_growth_outside_b) {
      throw new ClmmpoolsError(`Invalid tick fields.`, "InvalidTickFields" /* InvalidTickFields */);
    }
    const index = MathUtil.asIntN(BigInt(fields.index.bits));
    const sqrtPrice = new BN3(fields.sqrt_price);
    const liquidityNet = new BN3(fields.liquidity_net.bits);
    const liquidityGross = new BN3(fields.liquidity_gross);
    const feeGrowthOutsideA = new BN3(fields.fee_growth_outside_a);
    const feeGrowthOutsideB = new BN3(fields.fee_growth_outside_b);
    const rewardersGrowthOutside = (fields.rewards_growth_outside || []).map(
      (value) => new BN3(value)
    );
    const tick = {
      object_id: "",
      index,
      sqrt_price: sqrtPrice,
      liquidity_net: liquidityNet,
      liquidity_gross: liquidityGross,
      fee_growth_outside_a: feeGrowthOutsideA,
      fee_growth_outside_b: feeGrowthOutsideB,
      rewarders_growth_outside: rewardersGrowthOutside
    };
    return tick;
  }
};

// src/utils/transaction-util.ts
import BN10 from "bn.js";
import Decimal4 from "decimal.js";
import {
  Transaction
} from "@mysten/sui/transactions";

// src/utils/coin-util.ts
import { normalizeSuiAddress } from "@mysten/sui/utils";
var CoinUtil = class _CoinUtil {
  /**
   * Get the total balance of a list of CoinAsset objects for a given coin address.
   *
   * @param objs The list of CoinAsset objects to get the total balance for.
   * @param coinAddress The coin address to get the total balance for.
   * @returns The total balance of the CoinAsset objects for the given coin address.
   */
  static totalBalance(objs, coinAddress) {
    let balanceTotal = BigInt(0);
    objs.forEach((obj) => {
      if (coinAddress === obj.coin_address) {
        balanceTotal += BigInt(obj.balance);
      }
    });
    return balanceTotal;
  }
  /**
   * Get the CoinAsset objects for a given coin type.
   *
   * @param coinType The coin type to get the CoinAsset objects for.
   * @param allSuiObjects The list of all SuiMoveObjects.
   * @returns The CoinAsset objects for the given coin type.
   */
  static getCoinAssets(coinType, allSuiObjects) {
    const coins = [];
    allSuiObjects.forEach((anObj) => {
      if (this.normalizeCoinType(anObj.coin_address) === this.normalizeCoinType(coinType)) {
        coins.push(anObj);
      }
    });
    return coins;
  }
  /**
   * Get whether a coin address is a SUI coin.
   *
   * @param coinType The coin address to check.
   * @returns Whether the coin address is a SUI coin.
   */
  static isSuiCoin(coinType) {
    return this.normalizeCoinType(coinType) === GAS_TYPE_ARG;
  }
  /**
   * Select the CoinAsset objects from a list of CoinAsset objects that have a balance greater than or equal to a given amount.
   *
   * @param coins The list of CoinAsset objects to select from.
   * @param amount The amount to select CoinAsset objects with a balance greater than or equal to.
   * @param exclude A list of CoinAsset objects to exclude from the selection.
   * @returns The CoinAsset objects that have a balance greater than or equal to the given amount.
   */
  static selectCoinAssetGreaterThanOrEqual(coins, amount, exclude = []) {
    const sortedCoins = _CoinUtil.sortByBalance(
      coins.filter((c) => !exclude.includes(c.coin_object_id))
    );
    const total = _CoinUtil.calculateTotalBalance(sortedCoins);
    if (total < amount) {
      return { selected: [], remaining: sortedCoins };
    }
    if (total === amount) {
      return { selected: sortedCoins, remaining: [] };
    }
    let sum = BigInt(0);
    const selectedCoins = [];
    const remainingCoins = [...sortedCoins];
    while (sum < total) {
      const target = amount - sum;
      const coinWithSmallestSufficientBalanceIndex = remainingCoins.findIndex(
        (c) => c.balance >= target
      );
      if (coinWithSmallestSufficientBalanceIndex !== -1) {
        selectedCoins.push(remainingCoins[coinWithSmallestSufficientBalanceIndex]);
        remainingCoins.splice(coinWithSmallestSufficientBalanceIndex, 1);
        break;
      }
      const coinWithLargestBalance = remainingCoins.pop();
      if (coinWithLargestBalance.balance > 0) {
        selectedCoins.push(coinWithLargestBalance);
        sum += coinWithLargestBalance.balance;
      }
    }
    return {
      selected: _CoinUtil.sortByBalance(selectedCoins),
      remaining: _CoinUtil.sortByBalance(remainingCoins)
    };
  }
  /**
   * Sort the CoinAsset objects by their balance.
   *
   * @param coins The CoinAsset objects to sort.
   * @returns The sorted CoinAsset objects.
   */
  static sortByBalance(coins) {
    return coins.sort((a, b) => a.balance < b.balance ? -1 : a.balance > b.balance ? 1 : 0);
  }
  static sortByBalanceDes(coins) {
    return coins.sort((a, b) => a.balance > b.balance ? -1 : a.balance < b.balance ? 0 : 1);
  }
  /**
   * Calculate the total balance of a list of CoinAsset objects.
   *
   * @param coins The list of CoinAsset objects to calculate the total balance for.
   * @returns The total balance of the CoinAsset objects.
   */
  static calculateTotalBalance(coins) {
    return coins.reduce((partialSum, c) => partialSum + c.balance, BigInt(0));
  }
  /**
   * Fixes and normalizes a coin type by removing or keeping the prefix.
   *
   * @param {string} coinType - The coin type to be fixed.
   * @param {boolean} remove0x - Whether to remove the prefix or not (default: `false`).
   * @returns {string} - The fixed and normalized coin type.
   */
  static normalizeCoinType(coinType, remove0x = false) {
    const [address, ...rest] = coinType.split("::");
    let normalizedAddress = normalizeSuiAddress(address);
    if (normalizedAddress === "0x0000000000000000000000000000000000000000000000000000000000000002") {
      normalizedAddress = "0x2";
    }
    if (remove0x) {
      normalizedAddress = normalizedAddress.slice(2);
    }
    return `${normalizedAddress}::${rest.join("::")}`;
  }
  static buildCoinInfo(fields) {
    if (!fields || !fields.coin_type || !fields.name || !fields.symbol || !fields.decimals) {
      throw new ClmmpoolsError(`Invalid coin fields.`, "InvalidCoinFields" /* InvalidCoinFields */);
    }
    const coinInfo = {
      name: fields.name,
      symbol: fields.symbol,
      coingecko_id: fields.coingecko_id,
      decimals: fields.decimals,
      project_url: fields.project_url,
      icon_url: fields.icon_url,
      coin_type: this.normalizeCoinType(fields.coin_type),
      description: fields.description,
      pyth_id: fields.pyth_id,
      flag: Number(fields.flag),
      from_bonding_curve: Boolean(fields.from_bonding_curve),
      sort: Number(fields.sort),
      extension_fields: {}
    };
    return coinInfo;
  }
};

// src/types/clmm.type.ts
import "bn.js";
var ClmmPositionStatus = /* @__PURE__ */ ((ClmmPositionStatus2) => {
  ClmmPositionStatus2["Deleted"] = "Deleted";
  ClmmPositionStatus2["Exists"] = "Exists";
  ClmmPositionStatus2["NotExists"] = "NotExists";
  return ClmmPositionStatus2;
})(ClmmPositionStatus || {});

// src/utils/pool-util.ts
import BN7 from "bn.js";
import Decimal3 from "decimal.js";

// src/utils/swap-util.ts
import BN5 from "bn.js";
var SwapUtil = class {
  /**
   * Get the default sqrt price limit for a swap.
   *
   * @param a2b - true if the swap is A to B, false if the swap is B to A.
   * @returns The default sqrt price limit for the swap.
   */
  static getDefaultSqrtPriceLimit(a2b) {
    return new BN5(a2b ? MIN_SQRT_PRICE : MAX_SQRT_PRICE);
  }
  /**
   * Get the default values for the otherAmountThreshold in a swap.
   *
   * @param amountSpecifiedIsInput - The direction of a swap
   * @returns The default values for the otherAmountThreshold parameter in a swap.
   */
  static getDefaultOtherAmountThreshold(amountSpecifiedIsInput) {
    return amountSpecifiedIsInput ? ZERO : U64_MAX;
  }
  /**
   * Get lower sqrt price from token A.
   *
   * @param amount - The amount of tokens the user wanted to swap from.
   * @param liquidity - The liquidity of the pool.
   * @param sqrtPriceX64 - The sqrt price of the pool.
   * @returns LowesqrtPriceX64
   */
  static getLowerSqrtPriceFromCoinA(amount, liquidity, sqrtPriceX64) {
    const numerator = liquidity.mul(sqrtPriceX64).shln(64);
    const denominator = liquidity.shln(64).add(amount.mul(sqrtPriceX64));
    return MathUtil.divRoundUp(numerator, denominator);
  }
  /**
   * Get upper sqrt price from token A.
   *
   * @param amount - The amount of tokens the user wanted to swap from.
   * @param liquidity - The liquidity of the pool.
   * @param sqrtPriceX64 - The sqrt price of the pool.
   * @returns LowesqrtPriceX64
   */
  static getUpperSqrtPriceFromCoinA(amount, liquidity, sqrtPriceX64) {
    const numerator = liquidity.mul(sqrtPriceX64).shln(64);
    const denominator = liquidity.shln(64).sub(amount.mul(sqrtPriceX64));
    return MathUtil.divRoundUp(numerator, denominator);
  }
  /**
   * Get lower sqrt price from coin B.
   *
   * @param amount - The amount of coins the user wanted to swap from.
   * @param liquidity - The liquidity of the pool.
   * @param sqrtPriceX64 - The sqrt price of the pool.
   * @returns LowesqrtPriceX64
   */
  static getLowerSqrtPriceFromCoinB(amount, liquidity, sqrtPriceX64) {
    return sqrtPriceX64.sub(MathUtil.divRoundUp(amount.shln(64), liquidity));
  }
  /**
   * Get upper sqrt price from coin B.
   *
   * @param amount - The amount of coins the user wanted to swap from.
   * @param liquidity - The liquidity of the pool.
   * @param sqrtPriceX64 - The sqrt price of the pool.
   * @returns LowesqrtPriceX64
   */
  static getUpperSqrtPriceFromCoinB(amount, liquidity, sqrtPriceX64) {
    return sqrtPriceX64.add(amount.shln(64).div(liquidity));
  }
};

// src/utils/tick-math.ts
import BN6 from "bn.js";
import Decimal2 from "decimal.js";
var BIT_PRECISION = 14;
var LOG_B_2_X32 = "59543866431248";
var LOG_B_P_ERR_MARGIN_LOWER_X64 = "184467440737095516";
var LOG_B_P_ERR_MARGIN_UPPER_X64 = "15793534762490258745";
var TICK_BOUND = 443636;
var TickMath = class _TickMath {
  static priceToSqrtPriceX64(price, decimalsA, decimalsB) {
    return MathUtil.toX64(price.mul(Decimal2.pow(10, decimalsB - decimalsA)).sqrt());
  }
  static sqrtPriceX64ToPrice(sqrtPriceX64, decimalsA, decimalsB) {
    return MathUtil.fromX64(sqrtPriceX64).pow(2).mul(Decimal2.pow(10, decimalsA - decimalsB));
  }
  static tickIndexToSqrtPriceX64(tickIndex) {
    if (tickIndex > 0) {
      return new BN6(this.tickIndexToSqrtPricePositive(tickIndex));
    }
    return new BN6(this.tickIndexToSqrtPriceNegative(tickIndex));
  }
  static sqrtPriceX64ToTickIndex(sqrtPriceX64) {
    if (sqrtPriceX64.gt(new BN6(MAX_SQRT_PRICE)) || sqrtPriceX64.lt(new BN6(MIN_SQRT_PRICE))) {
      throw new ClmmpoolsError(
        "Provided sqrtPrice is not within the supported sqrtPrice range.",
        "InvalidSqrtPrice" /* InvalidSqrtPrice */
      );
    }
    const msb = sqrtPriceX64.bitLength() - 1;
    const adjustedMsb = new BN6(msb - 64);
    const log2pIntegerX32 = this.signedShiftLeft(adjustedMsb, 32, 128);
    let bit = new BN6("8000000000000000", "hex");
    let precision = 0;
    let log2pFractionX64 = new BN6(0);
    let r = msb >= 64 ? sqrtPriceX64.shrn(msb - 63) : sqrtPriceX64.shln(63 - msb);
    while (bit.gt(new BN6(0)) && precision < BIT_PRECISION) {
      r = r.mul(r);
      const rMoreThanTwo = r.shrn(127);
      r = r.shrn(63 + rMoreThanTwo.toNumber());
      log2pFractionX64 = log2pFractionX64.add(bit.mul(rMoreThanTwo));
      bit = bit.shrn(1);
      precision += 1;
    }
    const log2pFractionX32 = log2pFractionX64.shrn(32);
    const log2pX32 = log2pIntegerX32.add(log2pFractionX32);
    const logbpX64 = log2pX32.mul(new BN6(LOG_B_2_X32));
    const tickLow = this.signedShiftRight(
      logbpX64.sub(new BN6(LOG_B_P_ERR_MARGIN_LOWER_X64)),
      64,
      128
    ).toNumber();
    const tickHigh = this.signedShiftRight(
      logbpX64.add(new BN6(LOG_B_P_ERR_MARGIN_UPPER_X64)),
      64,
      128
    ).toNumber();
    if (tickLow === tickHigh) {
      return tickLow;
    }
    const derivedTickHighSqrtPriceX64 = _TickMath.tickIndexToSqrtPriceX64(tickHigh);
    if (derivedTickHighSqrtPriceX64.lte(sqrtPriceX64)) {
      return tickHigh;
    }
    return tickLow;
  }
  static tickIndexToPrice(tickIndex, decimalsA, decimalsB) {
    return _TickMath.sqrtPriceX64ToPrice(
      _TickMath.tickIndexToSqrtPriceX64(tickIndex),
      decimalsA,
      decimalsB
    );
  }
  static priceToTickIndex(price, decimalsA, decimalsB) {
    return _TickMath.sqrtPriceX64ToTickIndex(
      _TickMath.priceToSqrtPriceX64(price, decimalsA, decimalsB)
    );
  }
  static priceToInitializableTickIndex(price, decimalsA, decimalsB, tickSpacing) {
    return _TickMath.getInitializableTickIndex(
      _TickMath.priceToTickIndex(price, decimalsA, decimalsB),
      tickSpacing
    );
  }
  static getInitializableTickIndex(tickIndex, tickSpacing) {
    return tickIndex - tickIndex % tickSpacing;
  }
  /**
   *
   * @param tickIndex
   * @param tickSpacing
   * @returns
   */
  static getNextInitializableTickIndex(tickIndex, tickSpacing) {
    return _TickMath.getInitializableTickIndex(tickIndex, tickSpacing) + tickSpacing;
  }
  static getPrevInitializableTickIndex(tickIndex, tickSpacing) {
    return _TickMath.getInitializableTickIndex(tickIndex, tickSpacing) - tickSpacing;
  }
  static getTickDataFromUrlData(ticks) {
    const tickdatas = [];
    for (const tick of ticks) {
      const td = {
        objectId: tick.objectId,
        index: Number(MathUtil.asIntN(BigInt(tick.index)).toString()),
        sqrtPrice: tick.sqrtPrice,
        liquidityNet: new BN6(
          BigInt.asIntN(128, BigInt(BigInt(tick.liquidityNet.toString()))).toString()
        ),
        liquidityGross: tick.liquidityGross,
        feeGrowthOutsideA: tick.feeGrowthOutsideA,
        feeGrowthOutsideB: tick.feeGrowthOutsideB,
        rewardersGrowthOutside: [
          new BN6(tick.rewardersGrowthOutside[0]),
          new BN6(tick.rewardersGrowthOutside[1]),
          new BN6(tick.rewardersGrowthOutside[2])
        ]
      };
      tickdatas.push(td);
    }
    return tickdatas;
  }
  static tickScore(tickIndex) {
    return MathUtil.toDecimal(tickIndex).add(MathUtil.toDecimal(TICK_BOUND));
  }
  static signedShiftLeft(n0, shiftBy, bitWidth) {
    const twosN0 = n0.toTwos(bitWidth).shln(shiftBy);
    twosN0.imaskn(bitWidth + 1);
    return twosN0.fromTwos(bitWidth);
  }
  static signedShiftRight(n0, shiftBy, bitWidth) {
    const twoN0 = n0.toTwos(bitWidth).shrn(shiftBy);
    twoN0.imaskn(bitWidth - shiftBy + 1);
    return twoN0.fromTwos(bitWidth - shiftBy);
  }
  static tickIndexToSqrtPricePositive(tick) {
    let ratio;
    if ((tick & 1) !== 0) {
      ratio = new BN6("79232123823359799118286999567");
    } else {
      ratio = new BN6("79228162514264337593543950336");
    }
    if ((tick & 2) !== 0) {
      ratio = this.signedShiftRight(ratio.mul(new BN6("79236085330515764027303304731")), 96, 256);
    }
    if ((tick & 4) !== 0) {
      ratio = this.signedShiftRight(ratio.mul(new BN6("79244008939048815603706035061")), 96, 256);
    }
    if ((tick & 8) !== 0) {
      ratio = this.signedShiftRight(ratio.mul(new BN6("79259858533276714757314932305")), 96, 256);
    }
    if ((tick & 16) !== 0) {
      ratio = this.signedShiftRight(ratio.mul(new BN6("79291567232598584799939703904")), 96, 256);
    }
    if ((tick & 32) !== 0) {
      ratio = this.signedShiftRight(ratio.mul(new BN6("79355022692464371645785046466")), 96, 256);
    }
    if ((tick & 64) !== 0) {
      ratio = this.signedShiftRight(ratio.mul(new BN6("79482085999252804386437311141")), 96, 256);
    }
    if ((tick & 128) !== 0) {
      ratio = this.signedShiftRight(ratio.mul(new BN6("79736823300114093921829183326")), 96, 256);
    }
    if ((tick & 256) !== 0) {
      ratio = this.signedShiftRight(ratio.mul(new BN6("80248749790819932309965073892")), 96, 256);
    }
    if ((tick & 512) !== 0) {
      ratio = this.signedShiftRight(ratio.mul(new BN6("81282483887344747381513967011")), 96, 256);
    }
    if ((tick & 1024) !== 0) {
      ratio = this.signedShiftRight(ratio.mul(new BN6("83390072131320151908154831281")), 96, 256);
    }
    if ((tick & 2048) !== 0) {
      ratio = this.signedShiftRight(ratio.mul(new BN6("87770609709833776024991924138")), 96, 256);
    }
    if ((tick & 4096) !== 0) {
      ratio = this.signedShiftRight(ratio.mul(new BN6("97234110755111693312479820773")), 96, 256);
    }
    if ((tick & 8192) !== 0) {
      ratio = this.signedShiftRight(ratio.mul(new BN6("119332217159966728226237229890")), 96, 256);
    }
    if ((tick & 16384) !== 0) {
      ratio = this.signedShiftRight(ratio.mul(new BN6("179736315981702064433883588727")), 96, 256);
    }
    if ((tick & 32768) !== 0) {
      ratio = this.signedShiftRight(ratio.mul(new BN6("407748233172238350107850275304")), 96, 256);
    }
    if ((tick & 65536) !== 0) {
      ratio = this.signedShiftRight(ratio.mul(new BN6("2098478828474011932436660412517")), 96, 256);
    }
    if ((tick & 131072) !== 0) {
      ratio = this.signedShiftRight(ratio.mul(new BN6("55581415166113811149459800483533")), 96, 256);
    }
    if ((tick & 262144) !== 0) {
      ratio = this.signedShiftRight(
        ratio.mul(new BN6("38992368544603139932233054999993551")),
        96,
        256
      );
    }
    return this.signedShiftRight(ratio, 32, 256);
  }
  static tickIndexToSqrtPriceNegative(tickIndex) {
    const tick = Math.abs(tickIndex);
    let ratio;
    if ((tick & 1) !== 0) {
      ratio = new BN6("18445821805675392311");
    } else {
      ratio = new BN6("18446744073709551616");
    }
    if ((tick & 2) !== 0) {
      ratio = this.signedShiftRight(ratio.mul(new BN6("18444899583751176498")), 64, 256);
    }
    if ((tick & 4) !== 0) {
      ratio = this.signedShiftRight(ratio.mul(new BN6("18443055278223354162")), 64, 256);
    }
    if ((tick & 8) !== 0) {
      ratio = this.signedShiftRight(ratio.mul(new BN6("18439367220385604838")), 64, 256);
    }
    if ((tick & 16) !== 0) {
      ratio = this.signedShiftRight(ratio.mul(new BN6("18431993317065449817")), 64, 256);
    }
    if ((tick & 32) !== 0) {
      ratio = this.signedShiftRight(ratio.mul(new BN6("18417254355718160513")), 64, 256);
    }
    if ((tick & 64) !== 0) {
      ratio = this.signedShiftRight(ratio.mul(new BN6("18387811781193591352")), 64, 256);
    }
    if ((tick & 128) !== 0) {
      ratio = this.signedShiftRight(ratio.mul(new BN6("18329067761203520168")), 64, 256);
    }
    if ((tick & 256) !== 0) {
      ratio = this.signedShiftRight(ratio.mul(new BN6("18212142134806087854")), 64, 256);
    }
    if ((tick & 512) !== 0) {
      ratio = this.signedShiftRight(ratio.mul(new BN6("17980523815641551639")), 64, 256);
    }
    if ((tick & 1024) !== 0) {
      ratio = this.signedShiftRight(ratio.mul(new BN6("17526086738831147013")), 64, 256);
    }
    if ((tick & 2048) !== 0) {
      ratio = this.signedShiftRight(ratio.mul(new BN6("16651378430235024244")), 64, 256);
    }
    if ((tick & 4096) !== 0) {
      ratio = this.signedShiftRight(ratio.mul(new BN6("15030750278693429944")), 64, 256);
    }
    if ((tick & 8192) !== 0) {
      ratio = this.signedShiftRight(ratio.mul(new BN6("12247334978882834399")), 64, 256);
    }
    if ((tick & 16384) !== 0) {
      ratio = this.signedShiftRight(ratio.mul(new BN6("8131365268884726200")), 64, 256);
    }
    if ((tick & 32768) !== 0) {
      ratio = this.signedShiftRight(ratio.mul(new BN6("3584323654723342297")), 64, 256);
    }
    if ((tick & 65536) !== 0) {
      ratio = this.signedShiftRight(ratio.mul(new BN6("696457651847595233")), 64, 256);
    }
    if ((tick & 131072) !== 0) {
      ratio = this.signedShiftRight(ratio.mul(new BN6("26294789957452057")), 64, 256);
    }
    if ((tick & 262144) !== 0) {
      ratio = this.signedShiftRight(ratio.mul(new BN6("37481735321082")), 64, 256);
    }
    return ratio;
  }
};

// src/utils/pool-util.ts
import { normalizeStructTag, parseStructTag } from "@mysten/sui/utils";
var PoolUtil = class {
  /**
   * Transforms a Pool object into ClmmpoolData format.
   * @param {PoolStruct} pool - The liquidity pool object to transform.
   * @returns {ClmmPoolData} The transformed ClmmpoolData object.
   */
  static transClmmpoolDataWithoutTicks(pool) {
    const poolData = {
      coin_a: pool.coin_type_a,
      coin_b: pool.coin_type_b,
      current_sqrt_price: new BN7(pool.current_sqrt_price),
      current_tick_index: pool.current_tick_index,
      fee_growth_global_a: new BN7(pool.fee_growth_global_a),
      fee_growth_global_b: new BN7(pool.fee_growth_global_b),
      fee_protocol_coin_a: new BN7(pool.fee_protocol_coin_a),
      fee_protocol_coin_b: new BN7(pool.fee_protocol_coin_b),
      fee_rate: new BN7(pool.fee_rate),
      liquidity: new BN7(pool.liquidity),
      tick_indexes: [],
      tick_spacing: Number(pool.tick_spacing),
      ticks: [],
      collection_name: ""
    };
    return poolData;
  }
  static toCoinAmount(a, b) {
    return {
      coin_a: new BN7(a.toString()),
      coin_b: new BN7(b.toString())
    };
  }
  /**
   * Get the amount A delta about two prices, for give amount of liquidity.
   * `delta_a = (liquidity * delta_sqrt_price) / sqrt_price_upper * sqrt_price_lower)`
   *
   * @param sqrtPrice0 - A sqrt price
   * @param sqrtPrice1 - Another sqrt price
   * @param liquidity - The amount of usable liquidity
   * @param roundUp - Whether to round the amount up or down
   * @returns
   */
  static getDeltaA(sqrtPrice0, sqrtPrice1, liquidity, roundUp) {
    const sqrtPriceDiff = sqrtPrice0.gt(sqrtPrice1) ? sqrtPrice0.sub(sqrtPrice1) : sqrtPrice1.sub(sqrtPrice0);
    const numberator = liquidity.mul(sqrtPriceDiff).shln(64);
    const denomminator = sqrtPrice0.mul(sqrtPrice1);
    const quotient = numberator.div(denomminator);
    const remainder = numberator.mod(denomminator);
    const result = roundUp && !remainder.eq(ZERO) ? quotient.add(new BN7(1)) : quotient;
    return result;
  }
  /**
   * Get the amount B delta about two prices, for give amount of liquidity.
   * `delta_a = (liquidity * delta_sqrt_price) / sqrt_price_upper * sqrt_price_lower)`
   *
   * @param sqrtPrice0 - A sqrt price
   * @param sqrtPrice1 - Another sqrt price
   * @param liquidity - The amount of usable liquidity
   * @param roundUp - Whether to round the amount up or down
   * @returns
   */
  static getDeltaB(sqrtPrice0, sqrtPrice1, liquidity, roundUp) {
    const sqrtPriceDiff = sqrtPrice0.gt(sqrtPrice1) ? sqrtPrice0.sub(sqrtPrice1) : sqrtPrice1.sub(sqrtPrice0);
    if (liquidity.eq(ZERO) || sqrtPriceDiff.eq(ZERO)) {
      return ZERO;
    }
    const p = liquidity.mul(sqrtPriceDiff);
    const shoudRoundUp = roundUp && p.and(U64_MAX).gt(ZERO);
    const result = shoudRoundUp ? p.shrn(64).add(ONE) : p.shrn(64);
    if (MathUtil.isOverflow(result, 64)) {
      throw new ClmmpoolsError("Result large than u64 max", "IntegerDowncastOverflow" /* IntegerDowncastOverflow */);
    }
    return result;
  }
  /**
   * Get the next sqrt price from give a delta of token_a.
   * `new_sqrt_price = (sqrt_price * liquidity) / (liquidity +/- amount * sqrt_price)`
   *
   * @param sqrtPrice - The start sqrt price
   * @param liquidity - The amount of usable liquidity
   * @param amount - The amount of token_a
   * @param byAmountIn - Weather to fixed input
   */
  static getNextSqrtPriceAUp(sqrtPrice, liquidity, amount, byAmountIn) {
    if (amount.eq(ZERO)) {
      return sqrtPrice;
    }
    const numberator = MathUtil.checkMulShiftLeft(sqrtPrice, liquidity, 64, 256);
    const liquidityShl64 = liquidity.shln(64);
    const product = MathUtil.checkMul(sqrtPrice, amount, 256);
    if (!byAmountIn && liquidityShl64.lte(product)) {
      throw new ClmmpoolsError(
        "getNextSqrtPriceAUp - Unable to divide liquidityShl64 by product",
        "DivideByZero" /* DivideByZero */
      );
    }
    const nextSqrtPrice = byAmountIn ? MathUtil.checkDivRoundUpIf(numberator, liquidityShl64.add(product), true) : MathUtil.checkDivRoundUpIf(numberator, liquidityShl64.sub(product), true);
    if (nextSqrtPrice.lt(new BN7(MIN_SQRT_PRICE))) {
      throw new ClmmpoolsError(
        "getNextSqrtPriceAUp - Next sqrt price less than min sqrt price",
        "CoinAmountMinSubceeded " /* CoinAmountMinSubceeded */
      );
    }
    if (nextSqrtPrice.gt(new BN7(MAX_SQRT_PRICE))) {
      throw new ClmmpoolsError(
        "getNextSqrtPriceAUp - Next sqrt price greater than max sqrt price",
        "CoinAmountMaxExceeded" /* CoinAmountMaxExceeded */
      );
    }
    return nextSqrtPrice;
  }
  /**
   * Get the next sqrt price from give a delta of token_b.
   * `new_sqrt_price = (sqrt_price +(delta_b / liquidity)`
   *
   * @param sqrtPrice - The start sqrt price
   * @param liquidity - The amount of usable liquidity
   * @param amount - The amount of token_a
   * @param byAmountIn - Weather to fixed input
   */
  static getNextSqrtPriceBDown(sqrtPrice, liquidity, amount, byAmountIn) {
    const deltaSqrtPrice = MathUtil.checkDivRoundUpIf(amount.shln(64), liquidity, !byAmountIn);
    const nextSqrtPrice = byAmountIn ? sqrtPrice.add(deltaSqrtPrice) : sqrtPrice.sub(deltaSqrtPrice);
    if (nextSqrtPrice.lt(new BN7(MIN_SQRT_PRICE)) || nextSqrtPrice.gt(new BN7(MAX_SQRT_PRICE))) {
      throw new ClmmpoolsError(
        "getNextSqrtPriceAUp - Next sqrt price out of bounds",
        "SqrtPriceOutOfBounds" /* SqrtPriceOutOfBounds */
      );
    }
    return nextSqrtPrice;
  }
  /**
   * Get next sqrt price from input parameter.
   *
   * @param sqrtPrice
   * @param liquidity
   * @param amount
   * @param a2b
   * @returns
   */
  static getNextSqrtPriceFromInput(sqrtPrice, liquidity, amount, a2b) {
    return a2b ? this.getNextSqrtPriceAUp(sqrtPrice, liquidity, amount, true) : this.getNextSqrtPriceBDown(sqrtPrice, liquidity, amount, true);
  }
  /**
   * Get the next sqrt price from output parameters.
   *
   * @param sqrtPrice
   * @param liquidity
   * @param amount
   * @param a2b
   * @returns
   */
  static getNextSqrtPriceFromOutput(sqrtPrice, liquidity, amount, a2b) {
    return a2b ? this.getNextSqrtPriceBDown(sqrtPrice, liquidity, amount, false) : this.getNextSqrtPriceAUp(sqrtPrice, liquidity, amount, false);
  }
  /**
   * Get the amount of delta_a or delta_b from input parameters, and round up result.
   *
   * @param currentSqrtPrice
   * @param targetSqrtPrice
   * @param liquidity
   * @param a2b
   * @returns
   */
  static getDeltaUpFromInput(currentSqrtPrice, targetSqrtPrice, liquidity, a2b) {
    const sqrtPriceDiff = currentSqrtPrice.gt(targetSqrtPrice) ? currentSqrtPrice.sub(targetSqrtPrice) : targetSqrtPrice.sub(currentSqrtPrice);
    if (liquidity.lte(ZERO) || sqrtPriceDiff.eq(ZERO)) {
      return ZERO;
    }
    let result;
    if (a2b) {
      const numberator = new BN7(liquidity).mul(new BN7(sqrtPriceDiff)).shln(64);
      const denomminator = targetSqrtPrice.mul(currentSqrtPrice);
      const quotient = numberator.div(denomminator);
      const remainder = numberator.mod(denomminator);
      result = !remainder.eq(ZERO) ? quotient.add(ONE) : quotient;
    } else {
      const product = new BN7(liquidity).mul(new BN7(sqrtPriceDiff));
      const shoudRoundUp = product.and(U64_MAX).gt(ZERO);
      result = shoudRoundUp ? product.shrn(64).add(ONE) : product.shrn(64);
    }
    return result;
  }
  /**
   * Get the amount of delta_a or delta_b from output parameters, and round down result.
   *
   * @param currentSqrtPrice
   * @param targetSqrtPrice
   * @param liquidity
   * @param a2b
   * @returns
   */
  static getDeltaDownFromOutput(currentSqrtPrice, targetSqrtPrice, liquidity, a2b) {
    const sqrtPriceDiff = currentSqrtPrice.gt(targetSqrtPrice) ? currentSqrtPrice.sub(targetSqrtPrice) : targetSqrtPrice.sub(currentSqrtPrice);
    if (liquidity.lte(ZERO) || sqrtPriceDiff.eq(ZERO)) {
      return ZERO;
    }
    let result;
    if (a2b) {
      const product = liquidity.mul(sqrtPriceDiff);
      result = product.shrn(64);
    } else {
      const numberator = liquidity.mul(sqrtPriceDiff).shln(64);
      const denomminator = targetSqrtPrice.mul(currentSqrtPrice);
      result = numberator.div(denomminator);
    }
    return result;
  }
  /**
   * Simulate per step of swap on every tick.
   *
   * @param currentSqrtPrice
   * @param targetSqrtPrice
   * @param liquidity
   * @param amount
   * @param feeRate
   * @param byAmountIn
   * @returns
   */
  static computeSwapStep(currentSqrtPrice, targetSqrtPrice, liquidity, amount, feeRate, byAmountIn) {
    if (liquidity === ZERO) {
      return {
        amount_in: ZERO,
        amount_out: ZERO,
        next_sqrt_price: targetSqrtPrice,
        fee_amount: ZERO
      };
    }
    const a2b = currentSqrtPrice.gte(targetSqrtPrice);
    let amountIn;
    let amountOut;
    let nextSqrtPrice;
    let feeAmount;
    if (byAmountIn) {
      const amountRemain = MathUtil.checkMulDivFloor(
        amount,
        MathUtil.checkUnsignedSub(FEE_RATE_DENOMINATOR, feeRate),
        FEE_RATE_DENOMINATOR,
        64
      );
      const maxAmountIn = this.getDeltaUpFromInput(
        currentSqrtPrice,
        targetSqrtPrice,
        liquidity,
        a2b
      );
      if (maxAmountIn.gt(amountRemain)) {
        amountIn = amountRemain;
        feeAmount = MathUtil.checkUnsignedSub(amount, amountRemain);
        nextSqrtPrice = this.getNextSqrtPriceFromInput(
          currentSqrtPrice,
          liquidity,
          amountRemain,
          a2b
        );
      } else {
        amountIn = maxAmountIn;
        feeAmount = MathUtil.checkMulDivCeil(
          amountIn,
          feeRate,
          FEE_RATE_DENOMINATOR.sub(feeRate),
          64
        );
        nextSqrtPrice = targetSqrtPrice;
      }
      amountOut = this.getDeltaDownFromOutput(currentSqrtPrice, nextSqrtPrice, liquidity, a2b);
    } else {
      const maxAmountOut = this.getDeltaDownFromOutput(
        currentSqrtPrice,
        targetSqrtPrice,
        liquidity,
        a2b
      );
      if (maxAmountOut.gt(amount)) {
        amountOut = amount;
        nextSqrtPrice = this.getNextSqrtPriceFromOutput(currentSqrtPrice, liquidity, amount, a2b);
      } else {
        amountOut = maxAmountOut;
        nextSqrtPrice = targetSqrtPrice;
      }
      amountIn = this.getDeltaUpFromInput(currentSqrtPrice, nextSqrtPrice, liquidity, a2b);
      feeAmount = MathUtil.checkMulDivCeil(
        amountIn,
        feeRate,
        FEE_RATE_DENOMINATOR.sub(feeRate),
        64
      );
    }
    return {
      amount_in: amountIn,
      amount_out: amountOut,
      next_sqrt_price: nextSqrtPrice,
      fee_amount: feeAmount
    };
  }
  /**
   * Simulate swap by imput lots of ticks.
   * @param aToB
   * @param byAmountIn
   * @param amount
   * @param poolData
   * @param swapTicks
   * @returns
   */
  static computeSwap(aToB, byAmountIn, amount, poolData, swapTicks) {
    let remainerAmount = amount;
    let currentLiquidity = poolData.liquidity;
    let { current_sqrt_price: currentSqrtPrice } = poolData;
    const swapResult = {
      amount_in: ZERO,
      amount_out: ZERO,
      fee_amount: ZERO,
      ref_amount: ZERO,
      next_sqrt_price: ZERO,
      cross_tick_num: 0
    };
    let targetSqrtPrice;
    let signedLiquidityChange;
    const sqrtPriceLimit = SwapUtil.getDefaultSqrtPriceLimit(aToB);
    for (const tick of swapTicks) {
      if (aToB && poolData.current_tick_index < tick.index) {
        continue;
      }
      if (!aToB && poolData.current_tick_index >= tick.index) {
        continue;
      }
      if (tick === null) {
        continue;
      }
      if (aToB && sqrtPriceLimit.gt(tick.sqrt_price) || !aToB && sqrtPriceLimit.lt(tick.sqrt_price)) {
        targetSqrtPrice = sqrtPriceLimit;
      } else {
        targetSqrtPrice = tick.sqrt_price;
      }
      const stepResult = this.computeSwapStep(
        currentSqrtPrice,
        targetSqrtPrice,
        currentLiquidity,
        remainerAmount,
        poolData.fee_rate,
        byAmountIn
      );
      if (!stepResult.amount_in.eq(ZERO)) {
        remainerAmount = byAmountIn ? remainerAmount.sub(stepResult.amount_in.add(stepResult.fee_amount)) : remainerAmount.sub(stepResult.amount_out);
      }
      swapResult.amount_in = swapResult.amount_in.add(stepResult.amount_in);
      swapResult.amount_out = swapResult.amount_out.add(stepResult.amount_out);
      swapResult.fee_amount = swapResult.fee_amount.add(stepResult.fee_amount);
      if (stepResult.next_sqrt_price.eq(tick.sqrt_price)) {
        signedLiquidityChange = tick.liquidity_net.mul(new BN7(-1));
        if (aToB) {
          if (MathUtil.is_neg(signedLiquidityChange)) {
            currentLiquidity = currentLiquidity.add(
              new BN7(MathUtil.asUintN(BigInt(signedLiquidityChange.toString()), 128))
            );
          } else {
            currentLiquidity = currentLiquidity.add(signedLiquidityChange);
          }
        } else if (MathUtil.is_neg(signedLiquidityChange)) {
          currentLiquidity = currentLiquidity.sub(
            new BN7(MathUtil.asUintN(BigInt(signedLiquidityChange.toString()), 128))
          );
        } else {
          currentLiquidity = currentLiquidity.sub(signedLiquidityChange);
        }
        currentSqrtPrice = tick.sqrt_price;
      } else {
        currentSqrtPrice = stepResult.next_sqrt_price;
      }
      swapResult.cross_tick_num += 1;
      if (remainerAmount.eq(ZERO)) {
        break;
      }
    }
    swapResult.amount_in = swapResult.amount_in.add(swapResult.fee_amount);
    swapResult.next_sqrt_price = currentSqrtPrice;
    return swapResult;
  }
  /**
   * Estimate liquidity for coin A
   * @param sqrtPriceX - coin A sqrtprice
   * @param sqrtPriceY - coin B sqrtprice
   * @param coinAmount - token amount
   * @return
   */
  static estimateLiquidityForCoinA(sqrtPriceX, sqrtPriceY, coinAmount) {
    const lowerSqrtPriceX64 = BN7.min(sqrtPriceX, sqrtPriceY);
    const upperSqrtPriceX64 = BN7.max(sqrtPriceX, sqrtPriceY);
    const num = MathUtil.fromX64_BN(coinAmount.mul(upperSqrtPriceX64).mul(lowerSqrtPriceX64));
    const dem = upperSqrtPriceX64.sub(lowerSqrtPriceX64);
    return !num.isZero() && !dem.isZero() ? num.div(dem) : new BN7(0);
  }
  /**
   * Estimate liquidity for coin B
   * @param sqrtPriceX - coin A sqrtprice
   * @param sqrtPriceY - coin B sqrtprice
   * @param coinAmount - token amount
   * @return
   */
  static estimateLiquidityForCoinB(sqrtPriceX, sqrtPriceY, coinAmount) {
    const lowerSqrtPriceX64 = BN7.min(sqrtPriceX, sqrtPriceY);
    const upperSqrtPriceX64 = BN7.max(sqrtPriceX, sqrtPriceY);
    const delta = upperSqrtPriceX64.sub(lowerSqrtPriceX64);
    return !delta.isZero() ? coinAmount.shln(64).div(delta) : new BN7(0);
  }
  /**
   * Update fee rate.
   * @param clmm - clmmpool data
   * @param feeAmount - fee Amount
   * @param refRate - ref rate
   * @param protocolFeeRate - protocol fee rate
   * @param iscoinA - is token A
   * @returns percentage
   */
  static updateFeeRate(clmm, feeAmount, refRate, protocolFeeRate, iscoinA) {
    const protocolFee = MathUtil.checkMulDivCeil(
      feeAmount,
      new BN7(protocolFeeRate),
      FEE_RATE_DENOMINATOR,
      64
    );
    const refFee = refRate === 0 ? ZERO : MathUtil.checkMulDivFloor(feeAmount, new BN7(refRate), FEE_RATE_DENOMINATOR, 64);
    const poolFee = feeAmount.mul(protocolFee).mul(refFee);
    if (iscoinA) {
      clmm.fee_protocol_coin_a = clmm.fee_protocol_coin_a.add(protocolFee);
    } else {
      clmm.fee_protocol_coin_b = clmm.fee_protocol_coin_b.add(protocolFee);
    }
    if (poolFee.eq(ZERO) || clmm.liquidity.eq(ZERO)) {
      return { refFee, clmm };
    }
    const growthFee = poolFee.shln(64).div(clmm.liquidity);
    if (iscoinA) {
      clmm.fee_growth_global_a = clmm.fee_growth_global_a.add(growthFee);
    } else {
      clmm.fee_growth_global_b = clmm.fee_growth_global_b.add(growthFee);
    }
    return { refFee, clmm };
  }
  /**
   * Get token amount fron liquidity.
   * @param liquidity - liquidity
   * @param curSqrtPrice - Pool current sqrt price
   * @param lowerSqrtPrice - position lower sqrt price
   * @param upperSqrtPrice - position upper sqrt price
   * @param roundUp - is round up
   * @returns
   */
  static getCoinAmountFromLiquidity(liquidity, curSqrtPrice, lowerSqrtPrice, upperSqrtPrice, roundUp) {
    const liq = new Decimal3(liquidity.toString());
    const curSqrtPriceStr = new Decimal3(curSqrtPrice.toString());
    const lowerPriceStr = new Decimal3(lowerSqrtPrice.toString());
    const upperPriceStr = new Decimal3(upperSqrtPrice.toString());
    let coinA;
    let coinB;
    if (curSqrtPrice.lt(lowerSqrtPrice)) {
      coinA = MathUtil.toX64_Decimal(liq).mul(upperPriceStr.sub(lowerPriceStr)).div(lowerPriceStr.mul(upperPriceStr));
      coinB = new Decimal3(0);
    } else if (curSqrtPrice.lt(upperSqrtPrice)) {
      coinA = MathUtil.toX64_Decimal(liq).mul(upperPriceStr.sub(curSqrtPriceStr)).div(curSqrtPriceStr.mul(upperPriceStr));
      coinB = MathUtil.fromX64_Decimal(liq.mul(curSqrtPriceStr.sub(lowerPriceStr)));
    } else {
      coinA = new Decimal3(0);
      coinB = MathUtil.fromX64_Decimal(liq.mul(upperPriceStr.sub(lowerPriceStr)));
    }
    if (roundUp) {
      return {
        coin_a: new BN7(coinA.ceil().toString()),
        coin_b: new BN7(coinB.ceil().toString())
      };
    }
    return {
      coin_a: new BN7(coinA.floor().toString()),
      coin_b: new BN7(coinB.floor().toString())
    };
  }
  /**
   * Estimate liquidity and token amount from one amounts
   * @param lowerTick - lower tick
   * @param upperTick - upper tick
   * @param coinAmount - token amount
   * @param isCoinA - is token A
   * @param roundUp - is round up
   * @param isIncrease - is increase
   * @param slippage - slippage percentage
   * @param curSqrtPrice - current sqrt price.
   * @return IncreaseLiquidityInput
   */
  static estLiquidityAndcoinAmountFromOneAmounts(lowerTick, upperTick, coinAmount, isCoinA, roundUp, slippage, curSqrtPrice) {
    const currentTick = TickMath.sqrtPriceX64ToTickIndex(curSqrtPrice);
    const lowerSqrtPrice = TickMath.tickIndexToSqrtPriceX64(lowerTick);
    const upperSqrtPrice = TickMath.tickIndexToSqrtPriceX64(upperTick);
    let liquidity;
    if (currentTick < lowerTick) {
      if (!isCoinA) {
        throw new ClmmpoolsError(
          "lower tick cannot calculate liquidity by coinB",
          "NotSupportedThisCoin" /* NotSupportedThisCoin */
        );
      }
      liquidity = this.estimateLiquidityForCoinA(lowerSqrtPrice, upperSqrtPrice, coinAmount);
    } else if (currentTick > upperTick) {
      if (isCoinA) {
        throw new ClmmpoolsError(
          "upper tick cannot calculate liquidity by coinA",
          "NotSupportedThisCoin" /* NotSupportedThisCoin */
        );
      }
      liquidity = this.estimateLiquidityForCoinB(upperSqrtPrice, lowerSqrtPrice, coinAmount);
    } else if (isCoinA) {
      liquidity = this.estimateLiquidityForCoinA(curSqrtPrice, upperSqrtPrice, coinAmount);
    } else {
      liquidity = this.estimateLiquidityForCoinB(curSqrtPrice, lowerSqrtPrice, coinAmount);
    }
    const coinAmounts = this.getCoinAmountFromLiquidity(
      liquidity,
      curSqrtPrice,
      lowerSqrtPrice,
      upperSqrtPrice,
      roundUp
    );
    const tokenLimitA = roundUp ? MathUtil.toDecimal(coinAmounts.coin_a).mul(1 + slippage).toString() : MathUtil.toDecimal(coinAmounts.coin_a).mul(1 - slippage).toString();
    const tokenLimitB = roundUp ? MathUtil.toDecimal(coinAmounts.coin_b).mul(1 + slippage).toString() : MathUtil.toDecimal(coinAmounts.coin_b).mul(1 - slippage).toString();
    return {
      coin_amount_a: coinAmounts.coin_a,
      coin_amount_b: coinAmounts.coin_b,
      token_max_a: roundUp ? new BN7(Decimal3.ceil(tokenLimitA).toString()) : new BN7(Decimal3.floor(tokenLimitA).toString()),
      token_max_b: roundUp ? new BN7(Decimal3.ceil(tokenLimitB).toString()) : new BN7(Decimal3.floor(tokenLimitB).toString()),
      liquidity_amount: liquidity,
      fix_amount_a: isCoinA
    };
  }
  /**
   * Estimate liquidity from token amounts
   * @param curSqrtPrice - current sqrt price.
   * @param lowerTick - lower tick
   * @param upperTick - upper tick
   * @param tokenAmount - token amount
   * @return
   */
  static estimateLiquidityFromcoinAmounts(curSqrtPrice, lowerTick, upperTick, tokenAmount) {
    if (lowerTick > upperTick) {
      throw new ClmmpoolsError(
        "lower tick cannot be greater than lower tick",
        "InvalidTwoTickIndex" /* InvalidTwoTickIndex */
      );
    }
    const currTick = TickMath.sqrtPriceX64ToTickIndex(curSqrtPrice);
    const lowerSqrtPrice = TickMath.tickIndexToSqrtPriceX64(lowerTick);
    const upperSqrtPrice = TickMath.tickIndexToSqrtPriceX64(upperTick);
    if (currTick < lowerTick) {
      return this.estimateLiquidityForCoinA(lowerSqrtPrice, upperSqrtPrice, tokenAmount.coin_a);
    }
    if (currTick >= upperTick) {
      return this.estimateLiquidityForCoinB(upperSqrtPrice, lowerSqrtPrice, tokenAmount.coin_b);
    }
    const estimateLiquidityAmountA = this.estimateLiquidityForCoinA(
      curSqrtPrice,
      upperSqrtPrice,
      tokenAmount.coin_a
    );
    const estimateLiquidityAmountB = this.estimateLiquidityForCoinB(
      curSqrtPrice,
      lowerSqrtPrice,
      tokenAmount.coin_b
    );
    return BN7.min(estimateLiquidityAmountA, estimateLiquidityAmountB);
  }
  /**
   * Estimate coin amounts from total amount
   * @param lowerTick
   * @param upperTick
   * @param decimalsA
   * @param decimalsB
   * @param curSqrtPrice
   * @param totalAmount
   * @param tokenPriceA
   * @param tokenPriceB
   * @returns
   */
  static estCoinAmountsFromTotalAmount(lowerTick, upperTick, curSqrtPrice, totalAmount, tokenPriceA, tokenPriceB) {
    const { ratioA, ratioB } = this.calculateDepositRatioFixTokenA(
      lowerTick,
      upperTick,
      curSqrtPrice
    );
    const amountA = MathUtil.toDecimal(totalAmount).mul(ratioA).div(tokenPriceA);
    const amountB = MathUtil.toDecimal(totalAmount).mul(ratioB).div(tokenPriceB);
    return { amountA, amountB };
  }
  static calculateDepositRatioFixTokenA(lowerTick, upperTick, curSqrtPrice) {
    const coinAmountA = new BN7(1e8);
    const { coin_amount_b: coinAmountB } = this.estLiquidityAndcoinAmountFromOneAmounts(
      lowerTick,
      upperTick,
      coinAmountA,
      true,
      true,
      0,
      curSqrtPrice
    );
    const currPrice = TickMath.sqrtPriceX64ToPrice(curSqrtPrice, 0, 0);
    const transformAmountB = MathUtil.toDecimal(coinAmountA.toString()).mul(currPrice);
    const totalAmount = transformAmountB.add(coinAmountB.toString());
    const ratioA = transformAmountB.div(totalAmount);
    const ratioB = MathUtil.toDecimal(coinAmountB.toString()).div(totalAmount);
    return { ratioA, ratioB };
  }
  static withLiquiditySlippage(value, slippage, mode) {
    return MathUtil.toDecimal(value)[mode](MathUtil.toDecimal(value).mul(slippage)).toDP(0);
  }
  static getLiquidityAndCoinYByCoinX(coinInVal, reserveInSize, reserveOutSize, lpSupply) {
    if (coinInVal.lte(0)) {
      throw new ClmmpoolsError("coinInVal is less than zero", "InvalidCoinAmount" /* InvalidCoinAmount */);
    }
    if (reserveInSize.lte(0) || reserveOutSize.lte(0)) {
      return -1;
    }
    const coinYAmount = coinInVal.mul(reserveOutSize).div(reserveInSize);
    const sqrtSupply = lpSupply;
    const lpX = coinInVal.div(reserveInSize).mul(sqrtSupply);
    const lpY = coinYAmount.div(reserveOutSize).mul(sqrtSupply);
    const lpAmount = Decimal3.min(lpX, lpY);
    return {
      coin_y_amount: coinYAmount,
      lp_amount: lpAmount
    };
  }
  static getCoinXYForLiquidity(liquidity, reserveInSize, reserveOutSize, lpSupply) {
    if (liquidity.lte(0)) {
      throw new ClmmpoolsError(
        "liquidity can't be equal or less than zero",
        "InvalidLiquidityAmount" /* InvalidLiquidityAmount */
      );
    }
    if (reserveInSize.lte(0) || reserveOutSize.lte(0)) {
      throw new ClmmpoolsError(
        "reserveInSize or reserveOutSize can not be equal or less than zero",
        "InvalidReserveAmount" /* InvalidReserveAmount */
      );
    }
    const sqrtSupply = lpSupply;
    const coinXAmount = liquidity.div(sqrtSupply).mul(reserveInSize);
    const coinYAmount = liquidity.div(sqrtSupply).mul(reserveOutSize);
    return {
      coinXAmount,
      coinYAmount
    };
  }
  /**
   * Builds a pool name based on two coin types and tick spacing.
   * @param {string} coinTypeA - The type of the first coin.
   * @param {string} coinTypeB - The type of the second coin.
   * @param {string} tickSpacing - The tick spacing of the pool.
   * @returns {string} - The name of the pool.
   */
  static buildPoolName(coinTypeA, coinTypeB, tickSpacing) {
    const coinNameA = parseStructTag(coinTypeA).name;
    const coinNameB = parseStructTag(coinTypeB).name;
    return `${coinNameA}-${coinNameB}[${tickSpacing}]`;
  }
  /**
   * Builds a Pool object based on a SuiObjectResponse.
   * @param {SuiObjectResponse} objects - The SuiObjectResponse containing information about the pool.
   * @returns {PoolStruct} - The built Pool object.
   */
  static buildPool(objects) {
    const type = SuiUtil.getMoveObjectType(objects);
    const formatType = parseStructTag(type);
    const fields = SuiUtil.getObjectFields(objects);
    if (fields == null) {
      throw new ClmmpoolsError(
        `Pool id ${SuiUtil.getObjectId(objects)} not exists.`,
        "InvalidPoolObject" /* InvalidPoolObject */
      );
    }
    const rewarders = [];
    fields.rewarder_manager.fields.rewarders.forEach((item) => {
      const { emissions_per_second } = item.fields;
      const emissionSeconds = MathUtil.fromX64(new BN7(emissions_per_second));
      const emissionsEveryDay = emissionSeconds.mul(3600).mul(24).toString();
      rewarders.push({
        emissions_per_second,
        emissions_every_day: emissionsEveryDay,
        coin_address: normalizeStructTag(item.fields.reward_coin.fields.name),
        growth_global: item.fields.growth_global
      });
    });
    const pool = {
      pool_id: SuiUtil.getObjectId(objects),
      pool_type: type,
      coin_type_a: CoinUtil.normalizeCoinType(normalizeStructTag(formatType.typeParams[0])),
      coin_type_b: CoinUtil.normalizeCoinType(normalizeStructTag(formatType.typeParams[1])),
      coin_amount_a: fields.coin_a,
      coin_amount_b: fields.coin_b,
      current_sqrt_price: fields.current_sqrt_price,
      current_tick_index: MathUtil.asIntN(BigInt(fields.current_tick_index.fields.bits)),
      fee_growth_global_a: fields.fee_growth_global_a,
      fee_growth_global_b: fields.fee_growth_global_b,
      fee_protocol_coin_a: fields.fee_protocol_coin_a,
      fee_protocol_coin_b: fields.fee_protocol_coin_b,
      fee_rate: fields.fee_rate,
      is_pause: fields.is_pause,
      liquidity: fields.liquidity,
      position_manager: {
        positions_handle: fields.position_manager.fields.positions.fields.id.id,
        size: Number(fields.position_manager.fields.positions.fields.size)
      },
      rewarder_infos: rewarders,
      rewarder_last_updated_time: fields.rewarder_manager.fields.last_updated_time,
      tick_spacing: fields.tick_spacing,
      ticks_handle: fields.tick_manager.fields.ticks.fields.id.id,
      uri: fields.url,
      index: Number(fields.index),
      name: ""
    };
    pool.name = this.buildPoolName(pool.coin_type_a, pool.coin_type_b, pool.tick_spacing);
    return pool;
  }
};

// src/utils/position-util.ts
import BN9 from "bn.js";

// src/lib/percentage.ts
import BN8 from "bn.js";
var Percentage = class _Percentage {
  numerator;
  denominator;
  constructor(numerator, denominator) {
    this.toString = () => {
      return `${this.numerator.toString()}/${this.denominator.toString()}`;
    };
    this.numerator = numerator;
    this.denominator = denominator;
  }
  /**
   * Get the percentage of a number.
   *
   * @param number
   * @returns
   */
  static fromDecimal(number) {
    return _Percentage.fromFraction(number.toDecimalPlaces(1).mul(10).toNumber(), 1e3);
  }
  /**
   * Get the percentage of a fraction.
   *
   * @param numerator
   * @param denominator
   * @returns
   */
  static fromFraction(numerator, denominator) {
    const num = typeof numerator === "number" ? new BN8(numerator.toString()) : numerator;
    const denom = typeof denominator === "number" ? new BN8(denominator.toString()) : denominator;
    return new _Percentage(num, denom);
  }
};

// src/utils/position-util.ts
var PositionUtil = class {
  /**
   * Get the position status for the given tick indices.
   *
   * @param currentTickIndex The current tick index.
   * @param lowerTickIndex The lower tick index.
   * @param upperTickIndex The upper tick index.
   * @returns The position status.
   */
  static getPositionStatus(currentTickIndex, lowerTickIndex, upperTickIndex) {
    if (currentTickIndex < lowerTickIndex) {
      return 0 /* BelowRange */;
    }
    if (currentTickIndex < upperTickIndex) {
      return 1 /* InRange */;
    }
    return 2 /* AboveRange */;
  }
  /**
   * Get token A from liquidity.
   * @param liquidity - liquidity.
   * @param sqrtPrice0X64 - Current sqrt price of coin 0.
   * @param sqrtPrice1X64 - Current sqrt price of coin 1.
   * @param roundUp - If round up.
   *
   * @returns
   */
  static getCoinAFromLiquidity(liquidity, sqrtPrice0X64, sqrtPrice1X64, roundUp) {
    const [sqrtPriceLowerX64, sqrtPriceUpperX64] = this.orderSqrtPrice(
      sqrtPrice0X64,
      sqrtPrice1X64
    );
    const numerator = liquidity.mul(sqrtPriceUpperX64.sub(sqrtPriceLowerX64)).shln(64);
    const denominator = sqrtPriceUpperX64.mul(sqrtPriceLowerX64);
    if (roundUp) {
      return MathUtil.divRoundUp(numerator, denominator);
    }
    return numerator.div(denominator);
  }
  /**
   * Get token B from liquidity.
   * @param liquidity - liqudity.
   * @param sqrtPrice0X64 - Current sqrt price of token 0.
   * @param sqrtPrice1X64 - Current sqrt price of token 1.
   * @param roundUp - If round up.
   *
   * @returns
   */
  static getCoinBFromLiquidity(liquidity, sqrtPrice0X64, sqrtPrice1X64, roundUp) {
    const [sqrtPriceLowerX64, sqrtPriceUpperX64] = this.orderSqrtPrice(
      sqrtPrice0X64,
      sqrtPrice1X64
    );
    const result = liquidity.mul(sqrtPriceUpperX64.sub(sqrtPriceLowerX64));
    if (roundUp) {
      return MathUtil.shiftRightRoundUp(result);
    }
    return result.shrn(64);
  }
  /**
   * Get liquidity from token A.
   *
   * @param amount - The amount of token A.
   * @param sqrtPriceLowerX64 - The lower sqrt price.
   * @param sqrtPriceUpperX64 - The upper sqrt price.
   * @param roundUp - If round up.
   * @returns liquidity.
   */
  static getLiquidityFromCoinA(amount, sqrtPriceLowerX64, sqrtPriceUpperX64, roundUp) {
    const result = amount.mul(sqrtPriceLowerX64).mul(sqrtPriceUpperX64).div(sqrtPriceUpperX64.sub(sqrtPriceLowerX64));
    if (roundUp) {
      return MathUtil.shiftRightRoundUp(result);
    }
    return result.shrn(64);
  }
  /**
   * Get liquidity from token B.
   * @param amount - The amount of token B.
   * @param sqrtPriceLowerX64 - The lower sqrt price.
   * @param sqrtPriceUpperX64 - The upper sqrt price.
   * @param roundUp - If round up.
   *
   * @returns liquidity.
   */
  static getLiquidityFromCoinB(amount, sqrtPriceLowerX64, sqrtPriceUpperX64, roundUp) {
    const numerator = amount.shln(64);
    const denominator = sqrtPriceUpperX64.sub(sqrtPriceLowerX64);
    if (roundUp) {
      return MathUtil.divRoundUp(numerator, denominator);
    }
    return numerator.div(denominator);
  }
  /**
   * Get amount of fixed delta.
   * @param currentSqrtPriceX64 - Current sqrt price.
   * @param targetSqrtPriceX64 - Target sqrt price.
   * @param liquidity - liqudity.
   * @param amountSpecified - The amount specified in the swap.
   * @param swapDirection - The swap direction.
   *
   * @returns
   */
  static getAmountFixedDelta(currentSqrtPriceX64, targetSqrtPriceX64, liquidity, amountSpecified, swapDirection) {
    if (amountSpecified === "Specified input amount" /* Input */ === (swapDirection === "a2b" /* A2B */)) {
      return this.getCoinAFromLiquidity(
        liquidity,
        currentSqrtPriceX64,
        targetSqrtPriceX64,
        amountSpecified === "Specified input amount" /* Input */
      );
    }
    return this.getCoinBFromLiquidity(
      liquidity,
      currentSqrtPriceX64,
      targetSqrtPriceX64,
      amountSpecified === "Specified input amount" /* Input */
    );
  }
  /**
   * Get amount of unfixed delta.
   * @param currentSqrtPriceX64 - Current sqrt price.
   * @param targetSqrtPriceX64 - Target sqrt price.
   * @param liquidity - liqudity.
   * @param amountSpecified - The amount specified in the swap.
   * @param swapDirection - The swap direction.
   *
   * @returns
   */
  static getAmountUnfixedDelta(currentSqrtPriceX64, targetSqrtPriceX64, liquidity, amountSpecified, swapDirection) {
    if (amountSpecified === "Specified input amount" /* Input */ === (swapDirection === "a2b" /* A2B */)) {
      return this.getCoinBFromLiquidity(
        liquidity,
        currentSqrtPriceX64,
        targetSqrtPriceX64,
        amountSpecified === "Specified output amount" /* Output */
      );
    }
    return this.getCoinAFromLiquidity(
      liquidity,
      currentSqrtPriceX64,
      targetSqrtPriceX64,
      amountSpecified === "Specified output amount" /* Output */
    );
  }
  static adjustForSlippage(n, { numerator, denominator }, adjustUp) {
    if (adjustUp) {
      return n.mul(denominator.add(numerator)).div(denominator);
    }
    return n.mul(denominator).div(denominator.add(numerator));
  }
  static adjustForCoinSlippage(tokenAmount, slippage, adjustUp) {
    return {
      token_max_a: this.adjustForSlippage(tokenAmount.coin_a, slippage, adjustUp),
      token_max_b: this.adjustForSlippage(tokenAmount.coin_b, slippage, adjustUp)
    };
  }
  /**
   * Order sqrt price.
   * @param liquidity - liqudity.
   * @param sqrtPrice0X64 - Current sqrt price of coin 0.
   * @param sqrtPrice1X64 - Current sqrt price of coin 1.
   *
   * @returns
   */
  static orderSqrtPrice(sqrtPrice0X64, sqrtPrice1X64) {
    if (sqrtPrice0X64.lt(sqrtPrice1X64)) {
      return [sqrtPrice0X64, sqrtPrice1X64];
    }
    return [sqrtPrice1X64, sqrtPrice0X64];
  }
  /**
   * Get a fee quote on the outstanding fees owed to a position.
   *
   * @category CollectFeesQuoteParam
   * @param param A collection of fetched Clmmpool accounts to faciliate the quote.
   * @returns A quote object containing the fees owed for each token in the pool.
   */
  static collectFeesQuote(param) {
    const { fee_growth_inside_a, fee_growth_inside_b } = this.getFeeInTickRange(
      param.clmmpool,
      param.tickLower,
      param.tickUpper
    );
    return this.updateFees(param.position, fee_growth_inside_a, fee_growth_inside_b);
  }
  /**
   * Get the fee growth in the given tick range.
   *
   * @param clmmpool The CLMM pool.
   * @param tickLower The lower tick.
   * @param tickUpper The upper tick.
   * @returns The fee growth in the given tick range.
   */
  static getFeeInTickRange(clmmpool, tickLower, tickUpper) {
    let fee_growth_below_a = new BN9(0);
    let fee_growth_below_b = new BN9(0);
    if (clmmpool.current_tick_index < tickLower.index) {
      fee_growth_below_a = MathUtil.subUnderflowU128(
        new BN9(clmmpool.fee_growth_global_a),
        new BN9(tickLower.fee_growth_outside_a)
      );
      fee_growth_below_b = MathUtil.subUnderflowU128(
        new BN9(clmmpool.fee_growth_global_b),
        new BN9(tickLower.fee_growth_outside_b)
      );
    } else {
      fee_growth_below_a = new BN9(tickLower.fee_growth_outside_a);
      fee_growth_below_b = new BN9(tickLower.fee_growth_outside_b);
    }
    let fee_growth_above_a = new BN9(0);
    let fee_growth_above_b = new BN9(0);
    if (clmmpool.current_tick_index < tickUpper.index) {
      fee_growth_above_a = new BN9(tickUpper.fee_growth_outside_a);
      fee_growth_above_b = new BN9(tickUpper.fee_growth_outside_b);
    } else {
      fee_growth_above_a = MathUtil.subUnderflowU128(
        new BN9(clmmpool.fee_growth_global_a),
        new BN9(tickUpper.fee_growth_outside_a)
      );
      fee_growth_above_b = MathUtil.subUnderflowU128(
        new BN9(clmmpool.fee_growth_global_b),
        new BN9(tickUpper.fee_growth_outside_b)
      );
    }
    const fee_growth_inside_a = MathUtil.subUnderflowU128(
      MathUtil.subUnderflowU128(new BN9(clmmpool.fee_growth_global_a), fee_growth_below_a),
      fee_growth_above_a
    );
    const fee_growth_inside_b = MathUtil.subUnderflowU128(
      MathUtil.subUnderflowU128(new BN9(clmmpool.fee_growth_global_b), fee_growth_below_b),
      fee_growth_above_b
    );
    return { fee_growth_inside_a, fee_growth_inside_b };
  }
  static updateFees(position, fee_growth_inside_a, fee_growth_inside_b) {
    const growth_delta_a = MathUtil.subUnderflowU128(
      fee_growth_inside_a,
      new BN9(position.fee_growth_inside_a)
    );
    const fee_delta_a = new BN9(position.liquidity).mul(growth_delta_a).shrn(64);
    const growth_delta_b = MathUtil.subUnderflowU128(
      fee_growth_inside_b,
      new BN9(position.fee_growth_inside_b)
    );
    const fee_delta_b = new BN9(position.liquidity).mul(growth_delta_b).shrn(64);
    const fee_owed_a = new BN9(position.fee_owed_a).add(fee_delta_a);
    const fee_owed_b = new BN9(position.fee_owed_b).add(fee_delta_b);
    return {
      position_id: position.pos_object_id,
      fee_owed_a,
      fee_owed_b
    };
  }
  /** Builds a Position object based on a SuiObjectResponse.
   * @param {SuiObjectResponse} object - The SuiObjectResponse containing information about the position.
   * @returns {PositionStruct} - The built Position object.
   */
  static buildPosition(object) {
    if (object.error != null || object.data?.content?.dataType !== "moveObject") {
      throw new ClmmpoolsError(
        `Position not exists. Get Position error:${object.error}`,
        "InvalidPositionObject" /* InvalidPositionObject */
      );
    }
    let nft = {
      creator: "",
      description: "",
      image_url: "",
      link: "",
      name: "",
      project_url: ""
    };
    let position = {
      ...nft,
      pos_object_id: "",
      owner: "",
      type: "",
      coin_type_a: "",
      coin_type_b: "",
      liquidity: "",
      tick_lower_index: 0,
      tick_upper_index: 0,
      index: 0,
      pool: "",
      reward_amount_owed_0: "0",
      reward_amount_owed_1: "0",
      reward_amount_owed_2: "0",
      reward_growth_inside_0: "0",
      reward_growth_inside_1: "0",
      reward_growth_inside_2: "0",
      fee_growth_inside_a: "0",
      fee_owed_a: "0",
      fee_growth_inside_b: "0",
      fee_owed_b: "0",
      position_status: "Exists" /* Exists */,
      is_locked: false
    };
    let fields = SuiUtil.getObjectFields(object);
    if (fields) {
      const type = SuiUtil.getMoveObjectType(object);
      const ownerWarp = SuiUtil.getObjectOwner(object);
      if ("nft" in fields) {
        fields = fields.nft.fields;
        nft.description = fields.description;
        nft.name = fields.name;
        nft.link = fields.url;
      } else {
        nft = this.buildNFT(object);
      }
      position = {
        ...nft,
        pos_object_id: fields.id.id,
        owner: ownerWarp.AddressOwner,
        type,
        liquidity: fields.liquidity,
        coin_type_a: fields.coin_type_a.fields.name,
        coin_type_b: fields.coin_type_b.fields.name,
        tick_lower_index: MathUtil.asIntN(BigInt(fields.tick_lower_index.fields.bits)),
        tick_upper_index: MathUtil.asIntN(BigInt(fields.tick_upper_index.fields.bits)),
        index: fields.index,
        pool: fields.pool,
        reward_amount_owed_0: "0",
        reward_amount_owed_1: "0",
        reward_amount_owed_2: "0",
        reward_growth_inside_0: "0",
        reward_growth_inside_1: "0",
        reward_growth_inside_2: "0",
        fee_growth_inside_a: "0",
        fee_owed_a: "0",
        fee_growth_inside_b: "0",
        fee_owed_b: "0",
        position_status: "Exists" /* Exists */,
        is_locked: fields.is_locked
      };
    }
    const deletedResponse = SuiUtil.getObjectDeletedResponse(object);
    if (deletedResponse) {
      position.pos_object_id = deletedResponse.objectId;
      position.position_status = "Deleted" /* Deleted */;
    }
    const objectNotExistsResponse = SuiUtil.getObjectNotExistsResponse(object);
    if (objectNotExistsResponse) {
      position.pos_object_id = objectNotExistsResponse;
      position.position_status = "NotExists" /* NotExists */;
    }
    return position;
  }
  /**
   * Builds an NFT object based on a response containing information about the NFT.
   * @param {any} objects - The response containing information about the NFT.
   * @returns {NFT} - The built NFT object.
   */
  static buildNFT(objects) {
    const fields = SuiUtil.getObjectDisplay(objects).data;
    const nft = {
      creator: "",
      description: "",
      image_url: "",
      link: "",
      name: "",
      project_url: ""
    };
    if (fields) {
      nft.creator = fields["creator"];
      nft.description = fields["description"];
      nft.image_url = fields["image_url"];
      nft.link = fields["link"];
      nft.name = fields["name"];
      nft.project_url = fields["project_url"];
    }
    return nft;
  }
  /**
   * Builds a PositionReward object based on a response containing information about the reward.
   * @param {any} fields - The response containing information about the reward.
   * @returns {PositionReward} - The built PositionReward object.
   */
  static buildPositionReward(fields) {
    const rewarders = {
      reward_amount_owed_0: "0",
      reward_amount_owed_1: "0",
      reward_amount_owed_2: "0",
      reward_growth_inside_0: "0",
      reward_growth_inside_1: "0",
      reward_growth_inside_2: "0"
    };
    fields = "fields" in fields ? fields.fields : fields;
    fields.rewards.forEach((item, index) => {
      const { amount_owned, growth_inside } = "fields" in item ? item.fields : item;
      if (index === 0) {
        rewarders.reward_amount_owed_0 = amount_owned;
        rewarders.reward_growth_inside_0 = growth_inside;
      } else if (index === 1) {
        rewarders.reward_amount_owed_1 = amount_owned;
        rewarders.reward_growth_inside_1 = growth_inside;
      } else if (index === 2) {
        rewarders.reward_amount_owed_2 = amount_owned;
        rewarders.reward_growth_inside_2 = growth_inside;
      }
    });
    const tick_lower_index = "fields" in fields.tick_lower_index ? fields.tick_lower_index.fields.bits : fields.tick_lower_index.bits;
    const tick_upper_index = "fields" in fields.tick_upper_index ? fields.tick_upper_index.fields.bits : fields.tick_upper_index.bits;
    const possition = {
      liquidity: fields.liquidity,
      tick_lower_index: MathUtil.asIntN(BigInt(tick_lower_index)),
      tick_upper_index: MathUtil.asIntN(BigInt(tick_upper_index)),
      ...rewarders,
      fee_growth_inside_a: fields.fee_growth_inside_a,
      fee_owed_a: fields.fee_owned_a,
      fee_growth_inside_b: fields.fee_growth_inside_b,
      fee_owed_b: fields.fee_owned_b,
      pos_object_id: fields.position_id
    };
    return possition;
  }
  static buildClmmPositionName(pool_index, position_index) {
    return `Parrot LP | Pool${pool_index}-${position_index}`;
  }
};

// src/utils/transaction-util.ts
function findAdjustCoin(coinPair) {
  const isAdjustCoinA = CoinUtil.isSuiCoin(coinPair.coin_type_a);
  const isAdjustCoinB = CoinUtil.isSuiCoin(coinPair.coin_type_b);
  return { is_adjust_coin_a: isAdjustCoinA, is_adjust_coin_b: isAdjustCoinB };
}
function reverSlippageAmount(slippageAmount, slippage) {
  return Decimal4.ceil(MathUtil.toDecimal(slippageAmount).div(1 + slippage)).toString();
}
async function printTransaction(tx, isPrint = true) {
  console.log(`inputs`, tx.blockData.inputs);
  tx.blockData.transactions.forEach((item, index) => {
    if (isPrint) {
      console.log(`transaction ${index}: `, item);
    }
  });
}
var TransactionUtil = class _TransactionUtil {
  static buildCollectRewarderAndFeeTransaction(sdk, tx, params, allCoinAsset, allCoinAssetA, allCoinAssetB) {
    if (allCoinAssetA === void 0) {
      allCoinAssetA = [...allCoinAsset];
    }
    if (allCoinAssetB === void 0) {
      allCoinAssetB = [...allCoinAsset];
    }
    const coinTypeA = CoinUtil.normalizeCoinType(params.coin_type_a);
    const coinTypeB = CoinUtil.normalizeCoinType(params.coin_type_b);
    if (params.collect_fee) {
      const primaryCoinAInput = _TransactionUtil.buildCoinForAmount(
        tx,
        allCoinAssetA,
        BigInt(0),
        coinTypeA,
        false
      );
      allCoinAssetA = primaryCoinAInput.remain_coins;
      const primaryCoinBInput = _TransactionUtil.buildCoinForAmount(
        tx,
        allCoinAssetB,
        BigInt(0),
        coinTypeB,
        false
      );
      allCoinAssetB = primaryCoinBInput.remain_coins;
      tx = sdk.Position.buildCollectFeeWithCoinTransaction(
        {
          pool_id: params.pool_id,
          position_id: params.position_id,
          coin_type_a: params.coin_type_a,
          coin_type_b: params.coin_type_b
        },
        tx,
        primaryCoinAInput.target_coin,
        primaryCoinBInput.target_coin
      );
    }
    const primaryCoinInputs = [];
    params.rewarder_coin_types.forEach((type) => {
      switch (CoinUtil.normalizeCoinType(type)) {
        case coinTypeA:
          primaryCoinInputs.push(
            _TransactionUtil.buildCoinForAmount(tx, allCoinAssetA, BigInt(0), type, false).target_coin
          );
          break;
        case coinTypeB:
          primaryCoinInputs.push(
            _TransactionUtil.buildCoinForAmount(tx, allCoinAssetB, BigInt(0), type, false).target_coin
          );
          break;
        default:
          primaryCoinInputs.push(
            _TransactionUtil.buildCoinForAmount(tx, allCoinAsset, BigInt(0), type, false).target_coin
          );
          break;
      }
    });
    tx = sdk.Rewarder.buildCollectRewarderWithCoinTransaction(params, tx, primaryCoinInputs);
    return tx;
  }
  /**
   * adjust transaction for gas
   * @param sdk
   * @param amount
   * @param tx
   * @returns
   */
  static async adjustTransactionForGas(sdk, allCoins, amount, tx) {
    tx.setSender(sdk.senderAddress);
    const amountCoins = CoinUtil.selectCoinAssetGreaterThanOrEqual(allCoins, amount).selected;
    if (amountCoins.length === 0) {
      throw new ClmmpoolsError(`Insufficient balance`, "InsufficientBalance" /* InsufficientBalance */);
    }
    const totalAmount = CoinUtil.calculateTotalBalance(allCoins);
    if (totalAmount - amount > 1e9) {
      return { fixAmount: amount };
    }
    const estimateGas = await sdk.fullClient.calculateTxGas(tx);
    const gasCoins = CoinUtil.selectCoinAssetGreaterThanOrEqual(
      allCoins,
      BigInt(estimateGas),
      amountCoins.map((item) => item.coin_object_id)
    ).selected;
    if (gasCoins.length === 0) {
      const newGas = BigInt(estimateGas) + BigInt(500);
      if (totalAmount - amount < newGas) {
        amount -= newGas;
        if (amount < 0) {
          throw new ClmmpoolsError(`gas Insufficient balance`, "InsufficientBalance" /* InsufficientBalance */);
        }
        const newTx = new Transaction();
        return { fixAmount: amount, newTx };
      }
    }
    return { fixAmount: amount };
  }
  // -----------------------------------------liquidity-----------------------------------------------//
  /**
   * build add liquidity transaction
   * @param params
   * @param slippage
   * @param curSqrtPrice
   * @returns
   */
  static async buildAddLiquidityFixTokenForGas(sdk, allCoins, params, gasEstimateArg, tx, inputCoinA, inputCoinB) {
    tx = await _TransactionUtil.buildAddLiquidityFixToken(
      sdk,
      allCoins,
      params,
      tx,
      inputCoinA,
      inputCoinB
    );
    const { is_adjust_coin_a: isAdjustCoinA } = findAdjustCoin(params);
    const suiAmount = isAdjustCoinA ? params.amount_a : params.amount_b;
    const newResult = await _TransactionUtil.adjustTransactionForGas(
      sdk,
      CoinUtil.getCoinAssets(isAdjustCoinA ? params.coin_type_a : params.coin_type_b, allCoins),
      BigInt(suiAmount),
      tx
    );
    const { fixAmount } = newResult;
    const { newTx } = newResult;
    if (newTx != null) {
      let primaryCoinAInputs;
      let primaryCoinBInputs;
      if (isAdjustCoinA) {
        params.amount_a = Number(fixAmount);
        primaryCoinAInputs = _TransactionUtil.buildAddLiquidityFixTokenCoinInput(
          newTx,
          !params.fix_amount_a,
          fixAmount.toString(),
          params.slippage,
          params.coin_type_a,
          allCoins,
          false
        );
        primaryCoinBInputs = _TransactionUtil.buildAddLiquidityFixTokenCoinInput(
          newTx,
          params.fix_amount_a,
          params.amount_b,
          params.slippage,
          params.coin_type_b,
          allCoins,
          false
        );
      } else {
        params.amount_b = Number(fixAmount);
        primaryCoinAInputs = _TransactionUtil.buildAddLiquidityFixTokenCoinInput(
          newTx,
          !params.fix_amount_a,
          params.amount_a,
          params.slippage,
          params.coin_type_a,
          allCoins,
          false
        );
        primaryCoinBInputs = _TransactionUtil.buildAddLiquidityFixTokenCoinInput(
          newTx,
          params.fix_amount_a,
          fixAmount.toString(),
          params.slippage,
          params.coin_type_b,
          allCoins,
          false
        );
        params = _TransactionUtil.fixAddLiquidityFixTokenParams(
          params,
          gasEstimateArg.slippage,
          gasEstimateArg.current_sqrt_price
        );
        tx = await _TransactionUtil.buildAddLiquidityFixTokenArgs(
          newTx,
          sdk,
          allCoins,
          params,
          primaryCoinAInputs,
          primaryCoinBInputs
        );
        return tx;
      }
    }
    return tx;
  }
  /**
   * build add liquidity transaction
   * @param params
   * @param packageId
   * @returns
   */
  static async buildAddLiquidityFixToken(sdk, allCoinAsset, params, tx, inputCoinA, inputCoinB) {
    if (sdk.senderAddress.length === 0) {
      throw Error("this config sdk senderAddress is empty");
    }
    tx = tx || new Transaction();
    let primaryCoinAInputs;
    let primaryCoinBInputs;
    if (inputCoinA == null || inputCoinB == null) {
      primaryCoinAInputs = _TransactionUtil.buildAddLiquidityFixTokenCoinInput(
        tx,
        !params.fix_amount_a,
        params.amount_a,
        params.slippage,
        params.coin_type_a,
        allCoinAsset,
        false
      );
      primaryCoinBInputs = _TransactionUtil.buildAddLiquidityFixTokenCoinInput(
        tx,
        params.fix_amount_a,
        params.amount_b,
        params.slippage,
        params.coin_type_b,
        allCoinAsset,
        false
      );
    } else {
      primaryCoinAInputs = {
        target_coin: inputCoinA,
        remain_coins: [],
        is_mint_zero_coin: false,
        target_coin_amount: "0"
      };
      primaryCoinBInputs = {
        target_coin: inputCoinB,
        remain_coins: [],
        is_mint_zero_coin: false,
        target_coin_amount: "0"
      };
    }
    tx = _TransactionUtil.buildAddLiquidityFixTokenArgs(
      tx,
      sdk,
      allCoinAsset,
      params,
      primaryCoinAInputs,
      primaryCoinBInputs
    );
    return tx;
  }
  static buildAddLiquidityFixTokenCoinInput(tx, need_interval_amount, amount, slippage, coinType, allCoinAsset, buildVector = true) {
    return need_interval_amount ? _TransactionUtil.buildCoinForAmountInterval(
      tx,
      allCoinAsset,
      {
        amount_second: BigInt(reverSlippageAmount(amount, slippage)),
        amount_first: BigInt(amount)
      },
      coinType,
      buildVector
    ) : _TransactionUtil.buildCoinForAmount(tx, allCoinAsset, BigInt(amount), coinType, buildVector);
  }
  /**
   * fix add liquidity fix token for coin amount
   * @param params
   * @param slippage
   * @param curSqrtPrice
   * @returns
   */
  static fixAddLiquidityFixTokenParams(params, slippage, curSqrtPrice) {
    const coinAmount = params.fix_amount_a ? params.amount_a : params.amount_b;
    const liquidityInput = PoolUtil.estLiquidityAndcoinAmountFromOneAmounts(
      Number(params.tick_lower),
      Number(params.tick_upper),
      new BN10(coinAmount),
      params.fix_amount_a,
      true,
      slippage,
      curSqrtPrice
    );
    params.amount_a = params.fix_amount_a ? params.amount_a : liquidityInput.token_max_a.toNumber();
    params.amount_b = params.fix_amount_a ? liquidityInput.token_max_b.toNumber() : params.amount_b;
    return params;
  }
  static buildAddLiquidityFixTokenArgs(tx, sdk, allCoinAsset, params, primaryCoinAInputs, primaryCoinBInputs) {
    const typeArguments = [params.coin_type_a, params.coin_type_b];
    const functionName = params.is_open ? "mint_with_liquidity_fix_amount" : "add_liquidity_fix_amount";
    const { clmm_pool, facade } = sdk.sdkOptions;
    if (!params.is_open) {
      tx = _TransactionUtil.buildCollectRewarderAndFeeTransaction(
        sdk,
        tx,
        params,
        allCoinAsset,
        primaryCoinAInputs.remain_coins,
        primaryCoinBInputs.remain_coins
      );
    }
    const clmmConfig = clmm_pool.config;
    const args = params.is_open ? [
      tx.object(clmmConfig.global_config_id),
      tx.object(params.pool_id),
      tx.pure.u32(Number(MathUtil.asUintN(BigInt(params.tick_lower)).toString())),
      tx.pure.u32(Number(MathUtil.asUintN(BigInt(params.tick_upper)).toString())),
      primaryCoinAInputs.target_coin,
      primaryCoinBInputs.target_coin,
      tx.pure.u64(params.amount_a),
      tx.pure.u64(params.amount_b),
      tx.pure.bool(params.fix_amount_a),
      tx.object(CLOCK_ADDRESS)
    ] : [
      tx.object(clmmConfig.global_config_id),
      tx.object(params.pool_id),
      tx.object(params.position_id),
      primaryCoinAInputs.target_coin,
      primaryCoinBInputs.target_coin,
      tx.pure.u64(params.amount_a),
      tx.pure.u64(params.amount_b),
      tx.pure.bool(params.fix_amount_a),
      tx.object(CLOCK_ADDRESS)
    ];
    tx.moveCall({
      target: `${facade.published_at}::${ClmmIntegratePoolModule}::${functionName}`,
      typeArguments,
      arguments: args
    });
    return tx;
  }
  // -------------------------------------------swap--------------------------------------------------//
  /**
   * build add liquidity transaction
   * @param params
   * @param slippage
   * @param curSqrtPrice
   * @returns
   */
  static async buildSwapTransactionForGas(sdk, params, allCoinAsset, gasEstimateArg) {
    let tx = _TransactionUtil.buildSwapTransaction(sdk, params, allCoinAsset);
    tx.setSender(sdk.senderAddress);
    const newResult = await _TransactionUtil.adjustTransactionForGas(
      sdk,
      CoinUtil.getCoinAssets(params.a2b ? params.coin_type_a : params.coin_type_b, allCoinAsset),
      BigInt(params.by_amount_in ? params.amount : params.amount_limit),
      tx
    );
    const { fixAmount, newTx } = newResult;
    if (newTx !== void 0) {
      newTx.setSender(sdk.senderAddress);
      if (params.by_amount_in) {
        params.amount = fixAmount.toString();
      } else {
        params.amount_limit = fixAmount.toString();
      }
      params = await _TransactionUtil.fixSwapParams(sdk, params, gasEstimateArg);
      const primaryCoinInputA = _TransactionUtil.buildCoinForAmount(
        tx,
        allCoinAsset,
        params.a2b ? BigInt(params.by_amount_in ? params.amount : params.amount_limit) : BigInt(0),
        params.coin_type_a
      );
      const primaryCoinInputB = _TransactionUtil.buildCoinForAmount(
        tx,
        allCoinAsset,
        params.a2b ? BigInt(0) : BigInt(params.by_amount_in ? params.amount : params.amount_limit),
        params.coin_type_b
      );
      tx = _TransactionUtil.buildSwapTransactionArgs(
        newTx,
        params,
        sdk.sdkOptions,
        primaryCoinInputA,
        primaryCoinInputB
      );
    }
    return tx;
  }
  /**
   * build swap transaction
   * @param params
   * @param packageId
   * @returns
   */
  static buildSwapTransaction(sdk, params, allCoinAsset) {
    let tx = new Transaction();
    tx.setSender(sdk.senderAddress);
    const primaryCoinInputA = _TransactionUtil.buildCoinForAmount(
      tx,
      allCoinAsset,
      params.a2b ? BigInt(params.by_amount_in ? params.amount : params.amount_limit) : BigInt(0),
      params.coin_type_a,
      false
    );
    const primaryCoinInputB = _TransactionUtil.buildCoinForAmount(
      tx,
      allCoinAsset,
      params.a2b ? BigInt(0) : BigInt(params.by_amount_in ? params.amount : params.amount_limit),
      params.coin_type_b,
      false
    );
    tx = _TransactionUtil.buildSwapTransactionArgs(
      tx,
      params,
      sdk.sdkOptions,
      primaryCoinInputA,
      primaryCoinInputB
    );
    return tx;
  }
  /**
   * build swap transaction
   * @param params
   * @param packageId
   * @returns
   */
  static buildSwapTransactionArgs(tx, params, sdkOptions, primaryCoinInputA, primaryCoinInputB) {
    const { clmm_pool, facade } = sdkOptions;
    const sqrtPriceLimit = SwapUtil.getDefaultSqrtPriceLimit(params.a2b);
    const typeArguments = [params.coin_type_a, params.coin_type_b];
    const { global_config_id } = clmm_pool.config;
    if (global_config_id === void 0) {
      throw Error("clmm.config.global_config_id is undefined");
    }
    const hasSwapPartner = params.swap_partner !== void 0;
    const functionName = hasSwapPartner ? params.a2b ? "swap_a2b_with_partner" : "swap_b2a_with_partner" : params.a2b ? "swap_a2b" : "swap_b2a";
    const args = hasSwapPartner ? [
      tx.object(global_config_id),
      tx.object(params.pool_id),
      tx.object(params.swap_partner),
      primaryCoinInputA.target_coin,
      primaryCoinInputB.target_coin,
      tx.pure.bool(params.by_amount_in),
      tx.pure.u64(params.amount),
      tx.pure.u64(params.amount_limit),
      tx.pure.u128(sqrtPriceLimit.toString()),
      tx.object(CLOCK_ADDRESS)
    ] : [
      tx.object(global_config_id),
      tx.object(params.pool_id),
      primaryCoinInputA.target_coin,
      primaryCoinInputB.target_coin,
      tx.pure.bool(params.by_amount_in),
      tx.pure.u64(params.amount),
      tx.pure.u64(params.amount_limit),
      tx.pure.u128(sqrtPriceLimit.toString()),
      tx.object(CLOCK_ADDRESS)
    ];
    tx.moveCall({
      target: `${facade.published_at}::${ClmmIntegratePoolModule}::${functionName}`,
      typeArguments,
      arguments: args
    });
    return tx;
  }
  // -------------------------------------swap-with-out-transfer-coin-----------------------------------------//
  /**
   * build add liquidity transaction with out transfer coins
   * @param params
   * @param slippage
   * @param curSqrtPrice
   * @returns
   */
  static async buildSwapTransactionWithoutTransferCoinsForGas(sdk, params, allCoinAsset, gasEstimateArg) {
    let { tx, coinABs } = _TransactionUtil.buildSwapTransactionWithoutTransferCoins(
      sdk,
      params,
      allCoinAsset
    );
    tx.setSender(sdk.senderAddress);
    const newResult = await _TransactionUtil.adjustTransactionForGas(
      sdk,
      CoinUtil.getCoinAssets(params.a2b ? params.coin_type_a : params.coin_type_b, allCoinAsset),
      BigInt(params.by_amount_in ? params.amount : params.amount_limit),
      tx
    );
    const { fixAmount, newTx } = newResult;
    if (newTx !== void 0) {
      newTx.setSender(sdk.senderAddress);
      if (params.by_amount_in) {
        params.amount = fixAmount.toString();
      } else {
        params.amount_limit = fixAmount.toString();
      }
      params = await _TransactionUtil.fixSwapParams(sdk, params, gasEstimateArg);
      const primaryCoinInputA = _TransactionUtil.buildCoinForAmount(
        tx,
        allCoinAsset,
        params.a2b ? BigInt(params.by_amount_in ? params.amount : params.amount_limit) : BigInt(0),
        params.coin_type_a,
        false,
        true
      );
      const primaryCoinInputB = _TransactionUtil.buildCoinForAmount(
        tx,
        allCoinAsset,
        params.a2b ? BigInt(0) : BigInt(params.by_amount_in ? params.amount : params.amount_limit),
        params.coin_type_b,
        false,
        true
      );
      const res = _TransactionUtil.buildSwapTransactionWithoutTransferCoinArgs(
        sdk,
        newTx,
        params,
        sdk.sdkOptions,
        primaryCoinInputA,
        primaryCoinInputB
      );
      tx = res.tx;
      coinABs = res.txRes;
    }
    return { tx, coinABs };
  }
  /**
   * build swap transaction and return swaped coin
   * @param params
   * @param packageId
   * @returns
   */
  static buildSwapTransactionWithoutTransferCoins(sdk, params, allCoinAsset) {
    const tx = new Transaction();
    tx.setSender(sdk.senderAddress);
    const primaryCoinInputA = _TransactionUtil.buildCoinForAmount(
      tx,
      allCoinAsset,
      params.a2b ? BigInt(params.by_amount_in ? params.amount : params.amount_limit) : BigInt(0),
      params.coin_type_a,
      false,
      true
    );
    const primaryCoinInputB = _TransactionUtil.buildCoinForAmount(
      tx,
      allCoinAsset,
      params.a2b ? BigInt(0) : BigInt(params.by_amount_in ? params.amount : params.amount_limit),
      params.coin_type_b,
      false,
      true
    );
    const res = _TransactionUtil.buildSwapTransactionWithoutTransferCoinArgs(
      sdk,
      tx,
      params,
      sdk.sdkOptions,
      primaryCoinInputA,
      primaryCoinInputB
    );
    return { tx: res.tx, coinABs: res.txRes };
  }
  /**
   * build swap transaction
   * @param params
   * @param packageId
   * @returns
   */
  static buildSwapTransactionWithoutTransferCoinArgs(sdk, tx, params, sdkOptions, primaryCoinInputA, primaryCoinInputB) {
    const { clmm_pool, facade } = sdkOptions;
    const sqrtPriceLimit = SwapUtil.getDefaultSqrtPriceLimit(params.a2b);
    const { global_config_id } = clmm_pool.config;
    if (global_config_id === void 0) {
      throw Error("clmm.config.global_config_id is undefined");
    }
    const hasSwapPartner = params.swap_partner !== void 0;
    const functionName = hasSwapPartner ? "swap_with_partner" : "swap";
    const moduleName = hasSwapPartner ? ClmmIntegrateRouterWithPartnerModule : ClmmIntegrateRouterModule;
    const args = hasSwapPartner ? [
      tx.object(global_config_id),
      tx.object(params.pool_id),
      tx.object(params.swap_partner),
      primaryCoinInputA.target_coin,
      primaryCoinInputB.target_coin,
      tx.pure.bool(params.a2b),
      tx.pure.bool(params.by_amount_in),
      tx.pure.u64(params.amount),
      tx.pure.u128(sqrtPriceLimit.toString()),
      tx.pure.bool(false),
      // use coin value always set false.
      tx.object(CLOCK_ADDRESS)
    ] : [
      tx.object(global_config_id),
      tx.object(params.pool_id),
      primaryCoinInputA.target_coin,
      primaryCoinInputB.target_coin,
      tx.pure.bool(params.a2b),
      tx.pure.bool(params.by_amount_in),
      tx.pure.u64(params.amount),
      tx.pure.u128(sqrtPriceLimit.toString()),
      tx.pure.bool(false),
      // use coin value always set false.
      tx.object(CLOCK_ADDRESS)
    ];
    const typeArguments = [params.coin_type_a, params.coin_type_b];
    const coinABs = tx.moveCall({
      target: `${facade.published_at}::${moduleName}::${functionName}`,
      typeArguments,
      arguments: args
    });
    if (params.by_amount_in) {
      const toCoinType = params.a2b ? params.coin_type_b : params.coin_type_a;
      const toCoin = params.a2b ? coinABs[1] : coinABs[0];
      const totalAmount = Number(params.amount_limit);
      this.checkCoinThreshold(sdk, params.by_amount_in, tx, toCoin, totalAmount, toCoinType);
    }
    return { tx, txRes: coinABs };
  }
  static async fixSwapParams(sdk, params, gasEstimateArg) {
    const { current_pool: currentPool } = gasEstimateArg;
    const res = await sdk.Swap.preswap({
      decimals_a: gasEstimateArg.decimals_a,
      decimals_b: gasEstimateArg.decimals_b,
      a2b: params.a2b,
      by_amount_in: params.by_amount_in,
      amount: params.amount,
      pool: currentPool,
      current_sqrt_price: currentPool.current_sqrt_price,
      coin_type_a: currentPool.coin_type_a,
      coin_type_b: currentPool.coin_type_b
    });
    const toAmount = gasEstimateArg.by_amount_in ? res.estimatedAmountOut : res.estimatedAmountIn;
    const amountLimit = PositionUtil.adjustForSlippage(
      toAmount,
      gasEstimateArg.slippage,
      !gasEstimateArg.by_amount_in
    );
    params.amount_limit = amountLimit.toString();
    return params;
  }
  static async syncBuildCoinInputForAmount(sdk, tx, amount, coinType, buildVector = true) {
    if (sdk.senderAddress.length === 0) {
      throw Error("this config sdk senderAddress is empty");
    }
    const allCoins = await sdk.Coin.getOwnerCoinAssets(sdk.senderAddress, coinType);
    const primaryCoinInput = _TransactionUtil.buildCoinForAmount(
      tx,
      allCoins,
      amount,
      coinType,
      buildVector
    ).target_coin;
    return primaryCoinInput;
  }
  static buildCoinForAmount(tx, allCoins, amount, coinType, buildVector = true, fixAmount = false) {
    const coinAssets = CoinUtil.getCoinAssets(coinType, allCoins);
    if (amount === BigInt(0) && coinAssets.length === 0) {
      return _TransactionUtil.buildZeroValueCoin(allCoins, tx, coinType, buildVector);
    }
    const amountTotal = CoinUtil.calculateTotalBalance(coinAssets);
    if (amountTotal < amount) {
      throw new ClmmpoolsError(
        `The amount(${amountTotal}) is Insufficient balance for ${coinType} , expect ${amount} `,
        "InsufficientBalance" /* InsufficientBalance */
      );
    }
    return _TransactionUtil.buildCoin(
      tx,
      allCoins,
      coinAssets,
      amount,
      coinType,
      buildVector,
      fixAmount
    );
  }
  static buildCoin(tx, allCoins, coinAssets, amount, coinType, buildVector = true, fixAmount = false) {
    if (CoinUtil.isSuiCoin(coinType)) {
      if (buildVector) {
        const amountCoin2 = tx.splitCoins(tx.gas, [tx.pure.u64(amount)]);
        return {
          target_coin: tx.makeMoveVec({ elements: [amountCoin2] }),
          remain_coins: allCoins,
          target_coin_amount: amount.toString(),
          is_mint_zero_coin: false,
          original_splitted_coin: tx.gas
        };
      }
      if (amount === BigInt(0) && coinAssets.length > 1) {
        const selectedCoinsResult3 = CoinUtil.selectCoinAssetGreaterThanOrEqual(coinAssets, amount);
        return {
          target_coin: tx.object(selectedCoinsResult3.selected[0].coin_object_id),
          remain_coins: selectedCoinsResult3.remaining,
          target_coin_amount: selectedCoinsResult3.selected[0].balance.toString(),
          is_mint_zero_coin: false
        };
      }
      const selectedCoinsResult2 = CoinUtil.selectCoinAssetGreaterThanOrEqual(coinAssets, amount);
      const amountCoin = tx.splitCoins(tx.gas, [tx.pure.u64(amount)]);
      return {
        target_coin: amountCoin,
        remain_coins: selectedCoinsResult2.remaining,
        target_coin_amount: amount.toString(),
        is_mint_zero_coin: false,
        original_splitted_coin: tx.gas
      };
    }
    const selectedCoinsResult = CoinUtil.selectCoinAssetGreaterThanOrEqual(coinAssets, amount);
    const totalSelectedCoinAmount = selectedCoinsResult.selected.reduce((a, b) => Number(a) + Number(b.balance), 0).toString();
    const coinObjectIds = selectedCoinsResult.selected.map((item) => item.coin_object_id);
    if (buildVector) {
      return {
        target_coin: tx.makeMoveVec({ elements: coinObjectIds.map((id) => tx.object(id)) }),
        remain_coins: selectedCoinsResult.remaining,
        target_coin_amount: selectedCoinsResult.selected.reduce((a, b) => Number(a) + Number(b.balance), 0).toString(),
        is_mint_zero_coin: false
      };
    }
    const [primaryCoinA, ...mergeCoinAs] = coinObjectIds;
    const primaryCoinAObject = tx.object(primaryCoinA);
    let targetCoin = primaryCoinAObject;
    const tragetCoinAmount = selectedCoinsResult.selected.reduce((a, b) => Number(a) + Number(b.balance), 0).toString();
    let originalSplitedCoin;
    if (mergeCoinAs.length > 0) {
      tx.mergeCoins(
        primaryCoinAObject,
        mergeCoinAs.map((coin) => tx.object(coin))
      );
    }
    if (fixAmount && Number(totalSelectedCoinAmount) > Number(amount)) {
      targetCoin = tx.splitCoins(primaryCoinAObject, [tx.pure.u64(amount)]);
      originalSplitedCoin = primaryCoinAObject;
    }
    return {
      target_coin: targetCoin,
      remain_coins: selectedCoinsResult.remaining,
      original_splitted_coin: originalSplitedCoin,
      target_coin_amount: tragetCoinAmount,
      is_mint_zero_coin: false
    };
  }
  static buildZeroValueCoin(allCoins, tx, coinType, buildVector = true) {
    const zeroCoin = _TransactionUtil.callMintZeroValueCoin(tx, coinType);
    let targetCoin;
    if (buildVector) {
      targetCoin = tx.makeMoveVec({ elements: [zeroCoin] });
    } else {
      targetCoin = zeroCoin;
    }
    return {
      target_coin: targetCoin,
      remain_coins: allCoins,
      is_mint_zero_coin: true,
      target_coin_amount: "0"
    };
  }
  static buildCoinForAmountInterval(tx, allCoins, amounts, coinType, buildVector = true) {
    const coinAssets = CoinUtil.getCoinAssets(coinType, allCoins);
    if (amounts.amount_first === BigInt(0)) {
      if (coinAssets.length > 0) {
        return _TransactionUtil.buildCoin(
          tx,
          [...allCoins],
          [...coinAssets],
          amounts.amount_first,
          coinType,
          buildVector
        );
      }
      return _TransactionUtil.buildZeroValueCoin(allCoins, tx, coinType, buildVector);
    }
    const amountTotal = CoinUtil.calculateTotalBalance(coinAssets);
    if (amountTotal >= amounts.amount_first) {
      return _TransactionUtil.buildCoin(
        tx,
        [...allCoins],
        [...coinAssets],
        amounts.amount_first,
        coinType,
        buildVector
      );
    }
    if (amountTotal < amounts.amount_second) {
      throw new ClmmpoolsError(
        `The amount(${amountTotal}) is Insufficient balance for ${coinType} , expect ${amounts.amount_second} `,
        "InsufficientBalance" /* InsufficientBalance */
      );
    }
    return _TransactionUtil.buildCoin(
      tx,
      [...allCoins],
      [...coinAssets],
      amounts.amount_second,
      coinType,
      buildVector
    );
  }
  static callMintZeroValueCoin = (txb, coinType) => {
    return txb.moveCall({
      target: "0x2::coin::zero",
      typeArguments: [coinType]
    });
  };
  // ------------------------------------------router-v1-------------------------------------------------//
  static async buildRouterSwapTransaction(sdk, params, byAmountIn, allCoinAsset, recipient) {
    let tx = new Transaction();
    if (params.paths.length > 1) {
      params.partner = "";
    }
    tx = await this.buildRouterBasePathTx(sdk, params, byAmountIn, allCoinAsset, tx, recipient);
    return tx;
  }
  static async buildRouterBasePathTx(sdk, params, byAmountIn, allCoinAsset, tx, recipient) {
    const validPaths = params.paths.filter((path) => path && path.pool_ids);
    const inputAmount = Number(
      validPaths.reduce((total, path) => total.add(path.amount_in), ZERO).toString()
    );
    const outputAmount = Number(
      validPaths.reduce((total, path) => total.add(path.amount_out), ZERO).toString()
    );
    const totalAmountLimit = byAmountIn ? Math.round(Number(outputAmount.toString()) * (1 - params.price_slippage_point)) : Math.round(Number(inputAmount.toString()) * (1 + params.price_slippage_point));
    const fromCoinType = params.paths[0].coin_types[0];
    const toCoinType = params.paths[0].coin_types[params.paths[0].coin_types.length - 1];
    const fromCoinBuildResult = _TransactionUtil.buildCoinForAmount(
      tx,
      allCoinAsset,
      byAmountIn ? BigInt(inputAmount) : BigInt(totalAmountLimit),
      fromCoinType,
      false,
      true
    );
    const isSplited = fromCoinBuildResult.original_splitted_coin !== void 0;
    const toCoinBuildResult = _TransactionUtil.buildCoinForAmount(
      tx,
      allCoinAsset,
      BigInt(0),
      toCoinType,
      false
    );
    const buildRouterBasePathReturnCoin = await this.buildRouterBasePathReturnCoins(
      sdk,
      params,
      byAmountIn,
      fromCoinBuildResult,
      toCoinBuildResult,
      tx
    );
    const transferedCoins = [];
    const { toCoin, fromCoin } = buildRouterBasePathReturnCoin;
    tx = buildRouterBasePathReturnCoin.tx;
    if (toCoinBuildResult.is_mint_zero_coin) {
      transferedCoins.push({
        coin_type: toCoinType,
        coin: toCoin
      });
    } else if (toCoinBuildResult.original_splitted_coin !== void 0) {
      tx.mergeCoins(toCoinBuildResult.original_splitted_coin, [toCoin]);
    } else {
      tx.mergeCoins(toCoinBuildResult.target_coin, [toCoin]);
    }
    if (isSplited) {
      const originalSplitedFromCoin = fromCoinBuildResult?.original_splitted_coin;
      tx.mergeCoins(originalSplitedFromCoin, [fromCoin]);
    } else {
      transferedCoins.push({
        coin_type: fromCoinType,
        coin: fromCoin
      });
    }
    for (let i = 0; i < transferedCoins.length; i++) {
      this.buildTransferCoin(
        sdk,
        tx,
        transferedCoins[i].coin,
        transferedCoins[i].coin_type,
        recipient
      );
    }
    return tx;
  }
  static async buildRouterBasePathReturnCoins(sdk, params, byAmountIn, fromCoinBuildRes, toCoinBuildRes, tx) {
    const { clmm_pool, facade } = sdk.sdkOptions;
    const globalConfigID = clmm_pool.config.global_config_id;
    const validPaths = params.paths.filter((path) => path && path.pool_ids);
    const inputAmount = Number(
      validPaths.reduce((total, path) => total.add(path.amount_in), ZERO).toString()
    );
    const outputAmount = Number(
      validPaths.reduce((total, path) => total.add(path.amount_out), ZERO).toString()
    );
    const totalAmountLimit = byAmountIn ? Math.round(Number(outputAmount.toString()) * (1 - params.price_slippage_point)) : Math.round(Number(inputAmount.toString()) * (1 + params.price_slippage_point));
    const fromCoinType = params.paths[0].coin_types[0];
    const toCoinType = params.paths[0].coin_types[params.paths[0].coin_types.length - 1];
    let fromCoin = fromCoinBuildRes.target_coin;
    let toCoin;
    if (toCoinBuildRes.is_mint_zero_coin || toCoinBuildRes.original_splitted_coin !== void 0) {
      toCoin = toCoinBuildRes.target_coin;
    } else {
      toCoin = _TransactionUtil.callMintZeroValueCoin(tx, toCoinType);
    }
    const noPartner = params.partner === "";
    const moduleName = noPartner ? ClmmIntegrateRouterModule : ClmmIntegrateRouterWithPartnerModule;
    for (const path of validPaths) {
      if (path.pool_ids.length === 1) {
        const a2b = path.a2b[0];
        const swapParams = {
          amount: Number(path.amount_in.toString()),
          amountLimit: totalAmountLimit,
          poolCoinA: path.a2b[0] ? fromCoinType : toCoinType,
          poolCoinB: path.a2b[0] ? toCoinType : fromCoinType
        };
        const functionName = noPartner ? "swap" : "swap_with_partner";
        const poolCoinA = a2b ? fromCoin : toCoin;
        const poolCoinB = a2b ? toCoin : fromCoin;
        const amount = byAmountIn ? path.amount_in.toString() : path.amount_out.toString();
        const sqrtPriceLimit = SwapUtil.getDefaultSqrtPriceLimit(a2b).toString();
        const args = noPartner ? [
          tx.object(globalConfigID),
          tx.object(path.pool_ids[0]),
          poolCoinA,
          poolCoinB,
          tx.pure.bool(a2b),
          tx.pure.bool(byAmountIn),
          tx.pure.u64(amount),
          tx.pure.u128(sqrtPriceLimit),
          tx.pure.bool(false),
          tx.object(CLOCK_ADDRESS)
        ] : [
          tx.object(globalConfigID),
          tx.object(path.pool_ids[0]),
          tx.object(params.partner),
          poolCoinA,
          poolCoinB,
          tx.pure.bool(a2b),
          tx.pure.bool(byAmountIn),
          tx.pure.u64(amount),
          tx.pure.u128(sqrtPriceLimit),
          tx.pure.bool(false),
          tx.object(CLOCK_ADDRESS)
        ];
        const typeArguments = [swapParams.poolCoinA, swapParams.poolCoinB];
        const coinABs = tx.moveCall({
          target: `${sdk.sdkOptions.facade.published_at}::${moduleName}::${functionName}`,
          typeArguments,
          arguments: args
        });
        fromCoin = a2b ? coinABs[0] : coinABs[1];
        toCoin = a2b ? coinABs[1] : coinABs[0];
      } else {
        const amount0 = byAmountIn ? path.amount_in : path.raw_amount_limit[0];
        const amount1 = byAmountIn ? 0 : path.amount_out;
        let functionName = "";
        if (path.a2b[0]) {
          if (path.a2b[1]) {
            functionName = "swap_ab_bc";
          } else {
            functionName = "swap_ab_cb";
          }
        } else if (path.a2b[1]) {
          functionName = "swap_ba_bc";
        } else {
          functionName = "swap_ba_cb";
        }
        if (!noPartner) {
          functionName = `${functionName}_with_partner`;
        }
        const sqrtPriceLimit0 = SwapUtil.getDefaultSqrtPriceLimit(path.a2b[0]);
        const sqrtPriceLimit1 = SwapUtil.getDefaultSqrtPriceLimit(path.a2b[1]);
        const args = noPartner ? [
          tx.object(globalConfigID),
          tx.object(path.pool_ids[0]),
          tx.object(path.pool_ids[1]),
          fromCoin,
          toCoin,
          tx.pure.bool(byAmountIn),
          tx.pure.u64(amount0.toString()),
          tx.pure.u64(amount1.toString()),
          tx.pure.u128(sqrtPriceLimit0.toString()),
          tx.pure.u128(sqrtPriceLimit1.toString()),
          tx.object(CLOCK_ADDRESS)
        ] : [
          tx.object(globalConfigID),
          tx.object(path.pool_ids[0]),
          tx.object(path.pool_ids[1]),
          tx.object(params.partner),
          fromCoin,
          toCoin,
          tx.pure.bool(byAmountIn),
          tx.pure.u64(amount0.toString()),
          tx.pure.u64(amount1.toString()),
          tx.pure.u128(sqrtPriceLimit0.toString()),
          tx.pure.u128(sqrtPriceLimit1.toString()),
          tx.object(CLOCK_ADDRESS)
        ];
        const typeArguments = [path.coin_types[0], path.coin_types[1], path.coin_types[2]];
        const fromToCoins = tx.moveCall({
          target: `${facade.published_at}::${moduleName}::${functionName}`,
          typeArguments,
          arguments: args
        });
        fromCoin = fromToCoins[0];
        toCoin = fromToCoins[1];
      }
    }
    this.checkCoinThreshold(sdk, byAmountIn, tx, toCoin, totalAmountLimit, toCoinType);
    return { fromCoin, toCoin, tx };
  }
  // ------------------------------------------router-v2-------------------------------------------------//
  static async buildAggregatorSwapReturnCoins(sdk, param, fromCoinBuildRes, toCoinBuildRes, partner, priceSplitPoint, tx, recipient) {
    if (recipient == null) {
      if (sdk.senderAddress.length === 0) {
        throw Error("recipient and this config sdk senderAddress all not set");
      }
      recipient = sdk.senderAddress;
    }
    if (param.splitPaths.length > 1) {
      partner = "";
    }
    let fromCoin;
    let toCoin;
    if (!param.byAmountIn || param.splitPaths.length === 1) {
      const onePaths = [];
      for (const splitPath of param.splitPaths) {
        const a2b = [];
        const poolAddress = [];
        const rawAmountLimit = [];
        const coinType = [];
        for (let i = 0; i < splitPath.basePaths.length; i += 1) {
          const basePath = splitPath.basePaths[i];
          a2b.push(basePath.direction);
          poolAddress.push(basePath.poolAddress);
          rawAmountLimit.push(new BN10(basePath.inputAmount.toString()));
          if (i === 0) {
            coinType.push(basePath.fromCoin, basePath.toCoin);
          } else {
            coinType.push(basePath.toCoin);
          }
        }
        const onePath = {
          amount_in: new BN10(splitPath.inputAmount.toString()),
          amount_out: new BN10(splitPath.outputAmount.toString()),
          pool_ids: poolAddress,
          a2b,
          raw_amount_limit: rawAmountLimit,
          is_exceed: false,
          coin_types: coinType
        };
        onePaths.push(onePath);
      }
      const params = {
        paths: onePaths,
        partner,
        price_slippage_point: priceSplitPoint
      };
      const buildRouterBasePathReturnCoinRes = await this.buildRouterBasePathReturnCoins(
        sdk,
        params,
        param.byAmountIn,
        fromCoinBuildRes,
        toCoinBuildRes,
        tx
      );
      fromCoin = buildRouterBasePathReturnCoinRes.fromCoin;
      toCoin = buildRouterBasePathReturnCoinRes.toCoin;
      tx = buildRouterBasePathReturnCoinRes.tx;
    } else {
      const amountLimit = Math.round(param.outputAmount * (1 - priceSplitPoint));
      fromCoin = fromCoinBuildRes.target_coin;
      if (toCoinBuildRes.is_mint_zero_coin || toCoinBuildRes.original_splitted_coin !== void 0) {
        toCoin = toCoinBuildRes.target_coin;
      } else {
        toCoin = _TransactionUtil.callMintZeroValueCoin(tx, param.toCoin);
      }
      for (let i = 0; i < param.splitPaths.length; i += 1) {
        const splitPath = param.splitPaths[i];
        let middleCoin;
        for (let i2 = 0; i2 < splitPath.basePaths.length; i2 += 1) {
          const basePath = splitPath.basePaths[i2];
          if (basePath.label === "Parrot") {
            if (i2 === 0) {
              if (splitPath.basePaths.length === 1) {
                const clmmTxBuild = this.buildClmmBasePathTx(
                  sdk,
                  basePath,
                  tx,
                  param.byAmountIn,
                  fromCoin,
                  toCoin,
                  false,
                  partner
                );
                fromCoin = clmmTxBuild.from;
                toCoin = clmmTxBuild.to;
              } else {
                middleCoin = _TransactionUtil.callMintZeroValueCoin(tx, basePath.toCoin);
                const clmmTxBuild = this.buildClmmBasePathTx(
                  sdk,
                  basePath,
                  tx,
                  param.byAmountIn,
                  fromCoin,
                  middleCoin,
                  false,
                  partner
                );
                fromCoin = clmmTxBuild.from;
                middleCoin = clmmTxBuild.to;
              }
            } else {
              const clmmTxBuild = this.buildClmmBasePathTx(
                sdk,
                basePath,
                tx,
                param.byAmountIn,
                middleCoin,
                toCoin,
                true,
                partner
              );
              middleCoin = clmmTxBuild.from;
              toCoin = clmmTxBuild.to;
              tx.moveCall({
                target: `${sdk.sdkOptions.facade.published_at}::${ClmmIntegrateCoinUtilsModule}::send_coin`,
                typeArguments: [basePath.fromCoin],
                arguments: [middleCoin, tx.pure.address(recipient)]
              });
            }
          }
        }
      }
      this.checkCoinThreshold(sdk, param.byAmountIn, tx, toCoin, amountLimit, param.toCoin);
    }
    return { fromCoin, toCoin, tx };
  }
  static async buildAggregatorSwapTransaction(sdk, param, allCoinAsset, partner, priceSlippagePoint, recipient) {
    let tx = new Transaction();
    const amountLimit = param.byAmountIn ? Math.round(param.outputAmount * (1 - priceSlippagePoint)) : Math.round(param.inputAmount * (1 + priceSlippagePoint));
    const fromCoinBuildResult = _TransactionUtil.buildCoinForAmount(
      tx,
      allCoinAsset,
      param.byAmountIn ? BigInt(param.inputAmount) : BigInt(amountLimit),
      param.fromCoin,
      false,
      true
    );
    const isSplited = fromCoinBuildResult.original_splitted_coin != null;
    const toCoinBuildResult = _TransactionUtil.buildCoinForAmount(
      tx,
      allCoinAsset,
      BigInt(0),
      param.toCoin,
      false
    );
    const buildAggregatorSwapReturnCoinsRes = await this.buildAggregatorSwapReturnCoins(
      sdk,
      param,
      fromCoinBuildResult,
      toCoinBuildResult,
      partner,
      priceSlippagePoint,
      tx,
      recipient
    );
    const { fromCoin, toCoin } = buildAggregatorSwapReturnCoinsRes;
    tx = buildAggregatorSwapReturnCoinsRes.tx;
    const transferedCoins = [];
    if (toCoinBuildResult.is_mint_zero_coin) {
      transferedCoins.push({
        coin_type: param.toCoin,
        coin: toCoin
      });
    } else if (toCoinBuildResult.original_splitted_coin != null) {
      tx.mergeCoins(toCoinBuildResult.original_splitted_coin, [toCoin]);
    } else {
      tx.mergeCoins(toCoinBuildResult.target_coin, [toCoin]);
    }
    if (isSplited) {
      const originalSplitedFromCoin = fromCoinBuildResult.original_splitted_coin;
      tx.mergeCoins(originalSplitedFromCoin, [fromCoin]);
    } else {
      transferedCoins.push({
        coin_type: param.fromCoin,
        coin: fromCoin
      });
    }
    for (let i = 0; i < transferedCoins.length; i++) {
      this.buildTransferCoin(
        sdk,
        tx,
        transferedCoins[i].coin,
        transferedCoins[i].coin_type,
        recipient
      );
    }
    return tx;
  }
  static checkCoinThreshold(sdk, byAmountIn, tx, coin, amountLimit, coinType) {
    if (byAmountIn) {
      tx.moveCall({
        target: `${sdk.sdkOptions.facade.published_at}::${ClmmIntegrateRouterModule}::check_coin_threshold`,
        typeArguments: [coinType],
        arguments: [coin, tx.pure.u64(amountLimit)]
      });
    }
  }
  static buildClmmBasePathTx(sdk, basePath, tx, byAmountIn, from, to, middleStep, partner) {
    const { clmm_pool, facade } = sdk.sdkOptions;
    const globalConfigID = clmm_pool.config.global_config_id;
    let coinA = basePath.direction ? from : to;
    let coinB = basePath.direction ? to : from;
    const noPartner = partner === "";
    const moduleName = noPartner ? ClmmIntegrateRouterModule : ClmmIntegrateRouterWithPartnerModule;
    const functionName = noPartner ? "swap" : "swap_with_partner";
    const amount = byAmountIn ? basePath.inputAmount.toString() : basePath.outputAmount.toString();
    const sqrtPriceLimit = SwapUtil.getDefaultSqrtPriceLimit(basePath.direction);
    const args = noPartner ? [
      tx.object(globalConfigID),
      tx.object(basePath.poolAddress),
      coinA,
      coinB,
      tx.pure.bool(basePath.direction),
      tx.pure.bool(byAmountIn),
      tx.pure.u64(amount),
      tx.pure.u128(sqrtPriceLimit.toString()),
      tx.pure.bool(middleStep),
      tx.object(CLOCK_ADDRESS)
    ] : [
      tx.object(globalConfigID),
      tx.object(basePath.poolAddress),
      tx.object(partner),
      coinA,
      coinB,
      tx.pure.bool(basePath.direction),
      tx.pure.bool(byAmountIn),
      tx.pure.u64(amount),
      tx.pure.u128(sqrtPriceLimit.toString()),
      tx.pure.bool(middleStep),
      tx.object(CLOCK_ADDRESS)
    ];
    const typeArguments = basePath.direction ? [basePath.fromCoin, basePath.toCoin] : [basePath.toCoin, basePath.fromCoin];
    const coinAB = tx.moveCall({
      target: `${facade.published_at}::${moduleName}::${functionName}`,
      typeArguments,
      arguments: args
    });
    coinA = coinAB[0];
    coinB = coinAB[1];
    from = basePath.direction ? coinA : coinB;
    to = basePath.direction ? coinB : coinA;
    return {
      from,
      to,
      tx
    };
  }
  static buildCoinTypePair(coinTypes, partitionQuantities) {
    const coinTypePair = [];
    if (coinTypes.length === 2) {
      const pair = [];
      pair.push(coinTypes[0], coinTypes[1]);
      coinTypePair.push(pair);
    } else {
      const directPair = [];
      directPair.push(coinTypes[0], coinTypes[coinTypes.length - 1]);
      coinTypePair.push(directPair);
      for (let i = 1; i < coinTypes.length - 1; i += 1) {
        if (partitionQuantities[i - 1] === 0) {
          continue;
        }
        const pair = [];
        pair.push(coinTypes[0], coinTypes[i], coinTypes[coinTypes.length - 1]);
        coinTypePair.push(pair);
      }
    }
    return coinTypePair;
  }
  // ------------------------------------------utils-------------------------------------------------//
  static buildTransferCoinToSender(sdk, tx, coin, coinType) {
    tx.moveCall({
      target: `${sdk.sdkOptions.facade.published_at}::${ClmmIntegrateCoinUtilsModule}::transfer_coin_to_sender`,
      typeArguments: [coinType],
      arguments: [coin]
    });
  }
  // If recipient not set, transfer objects move call will use ctx sender
  static buildTransferCoin(sdk, tx, coin, coinType, recipient) {
    if (recipient != null) {
      tx.transferObjects([coin], tx.pure.address(recipient));
    } else {
      _TransactionUtil.buildTransferCoinToSender(sdk, tx, coin, coinType);
    }
  }
};

// src/utils/apr-util.ts
import BN11 from "bn.js";
import Decimal5 from "decimal.js";
var D365 = new BN11(365);
var H24 = new BN11(24);
var S3600 = new BN11(3600);
var B05 = new BN11(0.5);
var AprUtil = class {
  static estPoolAPR(preBlockReward, rewardPrice, totalTradingFee, totalLiquidityValue) {
    const annualRate = D365.mul(H24).mul(S3600).mul(B05);
    const APR = annualRate.mul(
      preBlockReward.mul(rewardPrice).add(totalTradingFee).div(totalLiquidityValue)
    );
    return APR;
  }
  static estPositionAPRWithDeltaMethod(currentTickIndex, lowerTickIndex, upperTickIndex, currentSqrtPriceX64, poolLiquidity, decimalsA, decimalsB, decimalsRewarder0, decimalsRewarder1, decimalsRewarder2, feeRate, amountAStr, amountBStr, poolAmountA, poolAmountB, swapVolumeStr, poolRewarders0Str, poolRewarders1Str, poolRewarders2Str, coinAPriceStr, coinBPriceStr, rewarder0PriceStr, rewarder1PriceStr, rewarder2PriceStr) {
    const amountA = new Decimal5(amountAStr);
    const amountB = new Decimal5(amountBStr);
    const swapVolume = new Decimal5(swapVolumeStr);
    const poolRewarders0 = new Decimal5(poolRewarders0Str);
    const poolRewarders1 = new Decimal5(poolRewarders1Str);
    const poolRewarders2 = new Decimal5(poolRewarders2Str);
    const coinAPrice = new Decimal5(coinAPriceStr);
    const coinBPrice = new Decimal5(coinBPriceStr);
    const rewarder0Price = new Decimal5(rewarder0PriceStr);
    const rewarder1Price = new Decimal5(rewarder1PriceStr);
    const rewarder2Price = new Decimal5(rewarder2PriceStr);
    const lowerSqrtPriceX64 = TickMath.tickIndexToSqrtPriceX64(lowerTickIndex);
    const upperSqrtPriceX64 = TickMath.tickIndexToSqrtPriceX64(upperTickIndex);
    const lowerSqrtPriceD = MathUtil.toX64_Decimal(MathUtil.fromX64(lowerSqrtPriceX64)).round();
    const upperSqrtPriceD = MathUtil.toX64_Decimal(MathUtil.fromX64(upperSqrtPriceX64)).round();
    const currentSqrtPriceD = MathUtil.toX64_Decimal(MathUtil.fromX64(currentSqrtPriceX64)).round();
    let deltaLiquidity;
    const liquidityAmount0 = amountA.mul(new Decimal5(10 ** decimalsA)).mul(upperSqrtPriceD.mul(lowerSqrtPriceD)).div(upperSqrtPriceD.sub(lowerSqrtPriceD)).round();
    const liquidityAmount1 = amountB.mul(new Decimal5(10 ** decimalsB)).div(upperSqrtPriceD.sub(lowerSqrtPriceD)).round();
    if (currentTickIndex < lowerTickIndex) {
      deltaLiquidity = liquidityAmount0;
    } else if (currentTickIndex > upperTickIndex) {
      deltaLiquidity = liquidityAmount1;
    } else {
      deltaLiquidity = Decimal5.min(liquidityAmount0, liquidityAmount1);
    }
    const deltaY = deltaLiquidity.mul(currentSqrtPriceD.sub(lowerSqrtPriceD));
    const deltaX = deltaLiquidity.mul(upperSqrtPriceD.sub(currentSqrtPriceD)).div(currentSqrtPriceD.mul(upperSqrtPriceD));
    const posValidTVL = deltaX.div(new Decimal5(10 ** decimalsA)).mul(coinAPrice).add(deltaY.div(new Decimal5(10 ** decimalsB).mul(coinBPrice)));
    const poolValidTVL = this.calculatePoolTVL(
      poolAmountA,
      poolAmountB,
      decimalsA,
      decimalsB,
      coinAPrice,
      coinBPrice
    );
    const posValidRate = posValidTVL.div(poolValidTVL);
    const feeAPR = deltaLiquidity.eq(new Decimal5(0)) ? new Decimal5(0) : new Decimal5(feeRate / 1e4).mul(swapVolume).mul(
      new Decimal5(deltaLiquidity.toString()).div(
        new Decimal5(poolLiquidity.toString()).add(new Decimal5(deltaLiquidity.toString()))
      )
    ).div(posValidTVL);
    const aprCoe = posValidRate.eq(new Decimal5(0)) ? new Decimal5(0) : posValidRate.mul(new Decimal5(36500 / 7)).div(posValidTVL);
    const posRewarder0APR = poolRewarders0.div(new Decimal5(10 ** decimalsRewarder0)).mul(rewarder0Price).mul(aprCoe);
    const posRewarder1APR = poolRewarders1.div(new Decimal5(10 ** decimalsRewarder1)).mul(rewarder1Price).mul(aprCoe);
    const posRewarder2APR = poolRewarders2.div(new Decimal5(10 ** decimalsRewarder2)).mul(rewarder2Price).mul(aprCoe);
    return {
      fee_apr: feeAPR,
      pos_rewarder0_apr: posRewarder0APR,
      pos_rewarder1_apr: posRewarder1APR,
      pos_rewarder2_apr: posRewarder2APR
    };
  }
  static estPositionAPRWithMultiMethod(lowerUserPrice, upperUserPrice, lowerHistPrice, upperHistPrice) {
    const retroLower = Math.max(lowerUserPrice, lowerHistPrice);
    const retroUpper = Math.min(upperUserPrice, upperHistPrice);
    const retroRange = retroUpper - retroLower;
    const userRange = upperUserPrice - lowerUserPrice;
    const histRange = upperHistPrice - lowerHistPrice;
    const userRangeD = new Decimal5(userRange.toString());
    const histRangeD = new Decimal5(histRange.toString());
    const retroRangeD = new Decimal5(retroRange.toString());
    let m = new Decimal5("0");
    if (retroRange < 0) {
      m = new Decimal5("0");
    } else if (userRange === retroRange) {
      m = histRangeD.div(retroRangeD);
    } else if (histRange === retroRange) {
      m = retroRangeD.div(userRangeD);
    } else {
      m = retroRangeD.mul(retroRangeD).div(histRangeD).div(userRangeD);
    }
    return m;
  }
  static calculatePoolTVL(amountA, amountB, decimalsA, decimalsB, priceA, priceB) {
    const liquidityA = new Decimal5(amountA.toString()).div(Decimal5.pow(10, decimalsA)).mul(priceA);
    const liquidityB = new Decimal5(amountB.toString()).div(Decimal5.pow(10, decimalsB)).mul(priceB);
    return liquidityA.add(liquidityB);
  }
};

// src/lib/pool.ts
import { Transaction as Transaction2 } from "@mysten/sui/transactions";

// src/lib/base-lib.ts
var BaseLib = class {
  _sdk;
  constructor(sdk) {
    this._sdk = sdk;
  }
  get sdk() {
    return this._sdk;
  }
};

// src/lib/pool.ts
import { isValidSuiAddress, parseStructTag as parseStructTag2 } from "@mysten/sui/utils";
var Pool = class extends BaseLib {
  /**
   * Gets a list of positions for the given positionHandle.
   * @param {string} positionHandle The handle for the position.
   * @returns {DataPageResult<PositionStruct>} A promise that resolves to an array of Position objects.
   */
  async getPositionList(positionHandle, page, limit) {
    const fields = this.sdk.fullClient.getAllDynamicFields(positionHandle);
    const totalIds = [];
    for await (const field of fields) {
      totalIds.push(field.name.value);
    }
    const start = (page - 1) * limit;
    const end = start + limit;
    const selectedIds = totalIds.slice(start, end);
    const positions = await this.sdk.Position.getSimplePositionList(selectedIds);
    return {
      result: positions,
      total: totalIds.length,
      page,
      limit
    };
  }
  /**
   * Gets a list of pools.
   * @returns {Promise<DataPageResult<PoolStruct>>} An array of Pool objects.
   */
  async getPools(page, limit) {
    const totalIds = [];
    const events = this.sdk.fullClient.queryAllEvents({
      MoveEventType: `${this.sdk.sdkOptions.clmm_pool.package_id}::pool_factory::CreatePoolEvent`
    });
    for await (const event of events) {
      totalIds.push(event.parsedJson.pool_id);
    }
    const start = (page - 1) * limit;
    const end = start + limit;
    const selectedIds = totalIds.slice(start, end);
    const objectDataResponses = await this.sdk.fullClient.batchGetObjects(selectedIds, {
      showContent: true,
      showType: true
    });
    const pools = objectDataResponses.map((item) => PoolUtil.buildPool(item));
    return { result: pools, total: totalIds.length, page, limit };
  }
  async getPoolsByIds(poolIds) {
    const objectDataResponses = await this.sdk.fullClient.batchGetObjects(poolIds, {
      showContent: true,
      showType: true
    });
    return objectDataResponses.map((item) => PoolUtil.buildPool(item));
  }
  /**
   * Gets a pool by its object ID.
   * @param {string} poolID The object ID of the pool to get.
   * @returns {Promise<PoolStruct>} A promise that resolves to a Pool object.
   */
  async getPool(poolID) {
    const object = await this.sdk.fullClient.getObject({
      id: poolID,
      options: {
        showType: true,
        showContent: true
      }
    });
    if (object.error != null || object.data?.content?.dataType !== "moveObject") {
      throw new ClmmpoolsError(
        `getPool error code: ${object.error?.code ?? "unknown error"}, please check config and object id`,
        "InvalidPoolObject" /* InvalidPoolObject */
      );
    }
    const pool = PoolUtil.buildPool(object);
    return pool;
  }
  async getPoolByCoins(coins, feeRate) {
    if (coins.length === 0) return [];
    const url = this.sdk.sdkOptions.backendUrl;
    const response = await fetch(url);
    let json;
    try {
      json = await response.json();
    } catch (e) {
      throw new ClmmpoolsError(
        `Failed tp [arse response from ${url}].`,
        "InvalidSwapCountUrl" /* InvalidSwapCountUrl */
      );
    }
    const { pools } = json.data;
    if (!pools || pools.length === 0) {
      throw new ClmmpoolsError(
        `Failed tp [arse response from ${url}].`,
        "PoolsNotFound" /* PoolsNotFound */
      );
    }
    const poolAddresses = [];
    for (const pool of pools) {
      if (coins.includes(pool.coin_a_address) && coins.includes(pool.coin_b_address)) {
        if (feeRate != null) {
          if (pool.object.feeRate === feeRate) {
            poolAddresses.push(pool.address);
          }
        } else {
          poolAddresses.push(pool.address);
        }
      }
    }
    if (poolAddresses.length > 0) {
      const objectDataResponses = await this.sdk.fullClient.batchGetObjects(poolAddresses, {
        showContent: true,
        showType: true
      });
      return objectDataResponses.map((item) => PoolUtil.buildPool(item));
    }
    return [];
  }
  /**
   * Create a pool of clmmpool protocol. The pool is identified by (CoinTypeA, CoinTypeB, tick_spacing).
   * @param {CreatePoolParams | CreatePoolAddLiquidityParams} params
   * @returns {Promise<Transaction>}
   */
  async buildCreatePoolTransaction(params) {
    return await this.createPoolAndAddLiquidity(params);
  }
  /**
   * Gets the ClmmConfig object for the given package object ID.
   * @returns the ClmmConfig object.
   */
  async getClmmConfigs() {
    const { package_id } = this.sdk.sdkOptions.clmm_pool;
    const packageObject = await this.sdk.fullClient.getObject({
      id: package_id,
      options: { showPreviousTransaction: true }
    });
    const previousTx = SuiUtil.getObjectPreviousTransactionDigest(packageObject);
    const clmmConfig = {
      pools_id: "",
      global_config_id: "",
      global_vault_id: "",
      admin_cap_id: "",
      trade_partners_id: "",
      pool_partners_id: "",
      coin_list_id: "",
      coin_list_handle_id: ""
    };
    const objects = this.sdk.fullClient.queryAllEvents({ Transaction: previousTx });
    for await (const item of objects) {
      if (!item.type) continue;
      const fields = item.parsedJson;
      const parsed = parseStructTag2(item.type);
      switch (`${parsed.address}::${parsed.module}::${parsed.name}`) {
        case `${package_id}::config::InitConfigEvent`:
          clmmConfig.global_config_id = fields.global_config_id;
          clmmConfig.admin_cap_id = fields.admin_cap_id;
          break;
        case `${package_id}::factory::InitFactoryEvent`:
          clmmConfig.pools_id = fields.pools_id;
          break;
        case `${package_id}::rewarder::RewarderInitEvent`:
          clmmConfig.global_vault_id = fields.global_vault_id;
          break;
        case `${package_id}::trade_partner::InitTradePartnersEvent`:
          clmmConfig.trade_partners_id = fields.trade_partners_id;
          break;
        case `${package_id}::pool_partner::InitPoolPartnersEvent`:
          clmmConfig.pool_partners_id = fields.pool_partners_id;
          break;
        default:
          break;
      }
    }
    return clmmConfig;
  }
  /**
   * Gets the SUI transaction response for a given transaction digest.
   * @param digest - The digest of the transaction for which the SUI transaction response is requested.
   * @returns A Promise that resolves with the SUI transaction block response or null if the response is not available.
   */
  async getSuiTransactionResponse(digest) {
    let objects;
    try {
      objects = await this.sdk.fullClient.getTransactionBlock({
        digest,
        options: {
          showEvents: true,
          showEffects: true,
          showBalanceChanges: true,
          showInput: true,
          showObjectChanges: true
        }
      });
    } catch (error) {
      objects = await this.sdk.fullClient.getTransactionBlock({
        digest,
        options: {
          showEvents: true,
          showEffects: true
        }
      });
    }
    return objects;
  }
  /**
   * Create pool internal.
   * @param {CreatePoolParams[]}params The parameters for the pools.
   * @returns {Promise<Transaction>} A promise that resolves to the transaction payload.
   */
  async createPool(params) {
    const tx = new Transaction2();
    const { facade, clmm_pool } = this.sdk.sdkOptions;
    const eventConfig = clmm_pool.config;
    const globalPauseStatusObjectId = eventConfig.global_config_id;
    const poolsId = eventConfig.pools_id;
    params.forEach((params2) => {
      const args = [
        tx.object(globalPauseStatusObjectId),
        tx.object(poolsId),
        tx.pure.u32(params2.tick_spacing),
        tx.pure.u128(params2.initialize_sqrt_price),
        tx.pure.string(params2.uri),
        tx.object(CLOCK_ADDRESS)
      ];
      tx.moveCall({
        target: `${facade.published_at}::${ClmmIntegratePoolModule}::create_pool`,
        typeArguments: [params2.coin_type_a, params2.coin_type_b],
        arguments: args
      });
    });
    return tx;
  }
  /**
   * Create pool and add liquidity internal. It will call create_pool_with_liquidity function.
   * @param {CreatePoolAddLiquidityParams}params The parameters for the create and liquidity.
   * @returns {Promise<Transaction>} A promise that resolves to the transaction payload.
   */
  async createPoolAndAddLiquidity(params) {
    if (!isValidSuiAddress(this.sdk.senderAddress)) {
      throw new ClmmpoolsError(
        "this config sdk senderAddress is not set right",
        "InvalidSendAddress" /* InvalidSendAddress */
      );
    }
    const tx = new Transaction2();
    const { facade, clmm_pool } = this.sdk.sdkOptions;
    const eventConfig = clmm_pool.config;
    const globalConfigId = eventConfig.global_config_id;
    const poolsId = eventConfig.pools_id;
    const allCoinAsset = await this.sdk.Coin.getOwnerCoinAssets(this.sdk.senderAddress);
    const primaryCoinAInputsR = TransactionUtil.buildCoinForAmount(
      tx,
      allCoinAsset,
      BigInt(params.amount_a),
      params.coin_type_a,
      false,
      true
    );
    const primaryCoinBInputsR = TransactionUtil.buildCoinForAmount(
      tx,
      allCoinAsset,
      BigInt(params.amount_b),
      params.coin_type_b,
      false,
      true
    );
    const hasPoolPartner = params.pool_partner !== void 0;
    const functionName = hasPoolPartner ? "create_pool_with_liquidity_partner" : "create_pool_with_liquidity";
    const args = hasPoolPartner ? [
      tx.object(globalConfigId),
      tx.object(params.pool_partner),
      tx.object(poolsId),
      tx.pure.u32(params.tick_spacing),
      tx.pure.u128(params.initialize_sqrt_price),
      tx.pure.string(params.uri),
      primaryCoinAInputsR.target_coin,
      primaryCoinBInputsR.target_coin,
      tx.pure.u32(Number(MathUtil.asUintN(BigInt(params.tick_lower)).toString())),
      tx.pure.u32(Number(MathUtil.asUintN(BigInt(params.tick_upper)).toString())),
      tx.pure.u64(params.amount_a),
      tx.pure.u64(params.amount_b),
      tx.pure.bool(params.fix_amount_a),
      tx.object(CLOCK_ADDRESS)
    ] : [
      tx.object(globalConfigId),
      tx.object(poolsId),
      tx.pure.u32(params.tick_spacing),
      tx.pure.u128(params.initialize_sqrt_price),
      tx.pure.string(params.uri),
      primaryCoinAInputsR.target_coin,
      primaryCoinBInputsR.target_coin,
      tx.pure.u32(Number(MathUtil.asUintN(BigInt(params.tick_lower)).toString())),
      tx.pure.u32(Number(MathUtil.asUintN(BigInt(params.tick_upper)).toString())),
      tx.pure.u64(params.amount_a),
      tx.pure.u64(params.amount_b),
      tx.pure.bool(params.fix_amount_a),
      tx.object(CLOCK_ADDRESS)
    ];
    tx.moveCall({
      target: `${facade.published_at}::${ClmmIntegratePoolModule}::${functionName}`,
      typeArguments: [params.coin_type_a, params.coin_type_b],
      arguments: args
    });
    return tx;
  }
  /**
   * Fetches ticks from the exchange.
   * @param {FetchParams} params The parameters for the fetch.
   */
  async *getTicks(params) {
    const { facade, simulationAccount } = this.sdk.sdkOptions;
    let start = [];
    const limit = 512;
    while (true) {
      const tx = new Transaction2();
      tx.moveCall({
        target: `${facade.published_at}::${ClmmFetcherModule}::fetch_ticks`,
        typeArguments: [params.coin_type_a, params.coin_type_b],
        arguments: [
          tx.object(params.pool_id),
          tx.makeMoveVec({
            elements: start.map((index) => tx.pure.u32(index)),
            type: "u32"
          }),
          tx.pure.u64(limit.toString())
        ]
      });
      const simulateRes = await this.sdk.fullClient.devInspectTransactionBlock({
        transactionBlock: tx,
        sender: simulationAccount.address
      });
      if (simulateRes.error != null) {
        throw new ClmmpoolsError(
          `getTicks error code: ${simulateRes.error ?? "unknown error"}, please check config and tick object ids`,
          "InvalidTickObjectId" /* InvalidTickObjectId */
        );
      }
      const events = simulateRes.events || [];
      let nextTick;
      let count = 0;
      for (const event of events) {
        if (parseStructTag2(event.type).name === "FetchTicksResultEvent") {
          count += event.parsedJson.ticks.length;
          for (const tick of event.parsedJson.ticks) {
            yield nextTick = TickUtil.buildTickDataByEvent(tick);
          }
        }
      }
      if (count < limit) break;
      start = [Number(MathUtil.asUintN(BigInt(nextTick.index)))];
    }
  }
  /**
   * Fetches a list of position rewards from the exchange.
   * @param {FetchParams} params The parameters for the fetch.
   * @returns {Promise<PositionReward[]>} A promise that resolves to an array of position rewards.
   */
  async fetchPositionRewardList(params) {
    const { facade, simulationAccount } = this.sdk.sdkOptions;
    const allPosition = [];
    let start = [];
    const limit = 512;
    while (true) {
      const typeArguments = [params.coin_type_a, params.coin_type_b];
      const tx = new Transaction2();
      const vecStart = tx.makeMoveVec({
        elements: start.map((id) => tx.pure.address(id)),
        type: void 0
      });
      const args = [tx.object(params.pool_id), vecStart, tx.pure.u64(limit)];
      tx.moveCall({
        target: `${facade.published_at}::${ClmmFetcherModule}::fetch_positions`,
        arguments: args,
        typeArguments
      });
      const simulateRes = await this.sdk.fullClient.devInspectTransactionBlock({
        transactionBlock: tx,
        sender: simulationAccount.address
      });
      if (simulateRes.error != null) {
        throw new ClmmpoolsError(
          `fetch position reward error code: ${simulateRes.error ?? "unknown error"}, please check config and tick object ids`,
          "InvalidPositionRewardObject" /* InvalidPositionRewardObject */
        );
      }
      const positionRewards = [];
      simulateRes?.events?.forEach((item) => {
        if (parseStructTag2(item.type).name === `FetchPositionsEvent`) {
          item.parsedJson.positions.forEach((item2) => {
            const positionReward = PositionUtil.buildPositionReward(item2);
            positionRewards.push(positionReward);
          });
        }
      });
      allPosition.push(...positionRewards);
      if (positionRewards.length < limit) {
        break;
      } else {
        start = [positionRewards[positionRewards.length - 1].pos_object_id];
      }
    }
    return allPosition;
  }
  /**
   * Fetches ticks from the fullnode using the RPC API.
   * @param {string} tickHandle The handle for the tick. Get tick handle from `sdk.Pool.getPool()`
   */
  async *getTicksByRpc(tickHandle) {
    let hasNextPage = true;
    let cursor = null;
    const limit = 50;
    do {
      const idRes = await this.sdk.fullClient.getDynamicFields({
        parentId: tickHandle,
        cursor,
        limit
      });
      hasNextPage = idRes.hasNextPage;
      cursor = idRes.nextCursor;
      const objectIds = [];
      idRes.data.forEach((item) => {
        if (parseStructTag2(item.objectType).module === "skip_list") {
          objectIds.push(item.objectId);
        }
      });
      const objectDataResponses = await this.sdk.fullClient.batchGetObjects(objectIds, {
        showContent: true,
        showType: true
      });
      for (const obj of objectDataResponses) {
        if (obj.error != null || obj.data?.content?.dataType !== "moveObject") {
          throw new ClmmpoolsError(
            `getTicksByRpc error code: ${obj.error?.code ?? "unknown error"}, please check config and tick object ids`,
            "InvalidTickObjectId" /* InvalidTickObjectId */
          );
        }
        yield TickUtil.buildTickData(obj);
      }
    } while (hasNextPage);
  }
  /**
   * Gets the tick data for the given tick index.
   * @param {string} tickHandle The handle for the tick.
   * @param {number} tickIndex The index of the tick.
   * @returns {Promise<TickData>} A promise that resolves to the tick data.
   */
  async getTickDataByIndex(tickHandle, tickIndex) {
    const res = await this.sdk.fullClient.getDynamicFieldObject({
      parentId: tickHandle,
      name: {
        type: "u64",
        value: MathUtil.asUintN(BigInt(TickMath.tickScore(tickIndex).toString())).toString()
      }
    });
    if (res.error != null || res.data?.content?.dataType !== "moveObject") {
      throw new ClmmpoolsError(
        `get tick by index: ${tickIndex} error: ${res.error}`,
        "InvalidTickIndex" /* InvalidTickIndex */
      );
    }
    return TickUtil.buildTickData(res);
  }
  /**
   * Gets the tick data for the given object ID.
   * @param {string} tickId The object ID of the tick.
   * @returns {Promise<TickData | null>} A promise that resolves to the tick data.
   */
  async getTickDataByObjectId(tickId) {
    const res = await this.sdk.fullClient.getObject({
      id: tickId,
      options: { showContent: true }
    });
    if (res.error != null || res.data?.content?.dataType !== "moveObject") {
      throw new ClmmpoolsError(
        `getTicksByRpc error code: ${res.error?.code ?? "unknown error"}, please check config and tick object ids`,
        "InvalidTickObjectId" /* InvalidTickObjectId */
      );
    }
    return TickUtil.buildTickData(res);
  }
  /**
   * Get partner ref fee amount
   * @param {string}partner Partner object id
   * @returns {Promise<CoinAsset[]>} A promise that resolves to an array of coin asset.
   */
  async getPartnerRefFeeAmount(partner, showDisplay = true) {
    const objectDataResponse = await this.sdk.fullClient.getObject({
      id: partner,
      options: {
        showOwner: true,
        showContent: true,
        showDisplay,
        showType: true
      }
    });
    if (objectDataResponse.data?.content?.dataType !== "moveObject") {
      throw new ClmmpoolsError(
        `get partner by object id: ${partner} error: ${objectDataResponse.error}`,
        "NotFoundPartnerObject" /* NotFoundPartnerObject */
      );
    }
    const balance = objectDataResponse.data.content.fields.balances;
    const coins = [];
    const objects = this.sdk.fullClient.getAllDynamicFields(balance.fields.id.id);
    for await (const object2 of objects) {
      if (object2.objectId != null) {
        coins.push(object2.objectId);
      }
    }
    const refFee = [];
    const object = await this.sdk.fullClient.batchGetObjects(coins, {
      showOwner: true,
      showContent: true,
      showDisplay,
      showType: true
    });
    object.forEach((info) => {
      if (info.error != null || info.data?.content?.dataType !== "moveObject") {
        throw new ClmmpoolsError(
          `get coin by object id: ${info.data.objectId} error: ${info.error}`,
          "InvalidParnterRefFeeFields" /* InvalidParnterRefFeeFields */
        );
      }
      refFee.push({
        // @ts-expect-error
        coin_address: info.data.content.fields.name,
        coin_object_id: info.data.objectId,
        // @ts-expect-error
        balance: BigInt(info.data.content.fields.value)
      });
    });
    return refFee;
  }
  /**
   * Claim partner ref fee.
   * @param {string} partnerCap partner cap id.
   * @param {string} partner partner id.
   * @returns {Promise<Transaction>} A promise that resolves to the transaction payload.
   */
  async buildClaimPartnerRefFeeTransaction(partnerCap, partner, coinType) {
    const tx = new Transaction2();
    const { clmm_pool } = this.sdk.sdkOptions;
    const clmmConfig = clmm_pool.config;
    const typeArguments = [coinType];
    const args = [
      tx.object(clmmConfig.global_config_id),
      tx.object(partnerCap),
      tx.object(partner)
    ];
    tx.moveCall({
      target: `${clmm_pool.published_at}::${ClmmPartnerModule}::claim_ref_fee`,
      arguments: args,
      typeArguments
    });
    return tx;
  }
};

// src/lib/position.ts
import BN12 from "bn.js";
import { Transaction as Transaction3 } from "@mysten/sui/transactions";
import { isValidSuiAddress as isValidSuiAddress2, isValidSuiObjectId, parseStructTag as parseStructTag3 } from "@mysten/sui/utils";
var Position = class extends BaseLib {
  /**
   * Builds the full address of the Position type.
   * @returns The full address of the Position type.
   */
  buildPositionType() {
    const parrotClmm = this.sdk.sdkOptions.clmm_pool.package_id;
    return `${parrotClmm}::position::Position`;
  }
  /**
   * Gets a list of positions for the given account address.
   * @param accountAddress The account address to get positions for.
   * @param assignPoolIds An array of pool IDs to filter the positions by.
   * @returns array of Position objects.
   */
  async getPositionList(accountAddress, assignPoolIds = [], showDisplay = true) {
    const allPosition = [];
    const ownerRes = this.sdk.fullClient.getAllOwnedObjects(accountAddress, {
      options: { showType: true, showContent: true, showDisplay, showOwner: true },
      filter: { Package: this.sdk.sdkOptions.clmm_pool.package_id }
    });
    const hasAssignPoolIds = assignPoolIds.length > 0;
    for await (const item of ownerRes) {
      const parsedTag = parseStructTag3(item.data.type);
      const typeWithoutGeneric = `${parsedTag.address}::${parsedTag.module}::${parsedTag.name}`;
      if (typeWithoutGeneric === this.buildPositionType()) {
        const position = PositionUtil.buildPosition(item);
        if (hasAssignPoolIds) {
          if (assignPoolIds.includes(position.pool)) {
            allPosition.push(position);
          }
        } else {
          allPosition.push(position);
        }
      }
    }
    return allPosition;
  }
  /**
   * Gets a position by its handle and ID. But it needs pool info, so it is not recommended to use this method.
   * if you want to get a position, you can use getPositionById method directly.
   * @param {string} positionHandle The handle of the position to get.
   * @param {string} positionID The ID of the position to get.
   * @param {boolean} calculateRewarder Whether to calculate the rewarder of the position.
   * @returns {Promise<PositionStruct>} Position object.
   */
  async getPosition(positionHandle, positionID, calculateRewarder = true, showDisplay = true) {
    let position = await this.getSimplePosition(positionID, showDisplay);
    if (calculateRewarder) {
      position = await this.updatePositionRewarders(positionHandle, position);
    }
    return position;
  }
  /**
   * Gets a position by its ID.
   * @param {string} positionID The ID of the position to get.
   * @param {boolean} calculateRewarder Whether to calculate the rewarder of the position.
   * @returns {Promise<PositionStruct>} Position object.
   */
  async getPositionById(positionID, calculateRewarder = true, showDisplay = true) {
    const position = await this.getSimplePosition(positionID, showDisplay);
    if (calculateRewarder) {
      const pool = await this.sdk.Pool.getPool(position.pool);
      const result = await this.updatePositionRewarders(
        pool.position_manager.positions_handle,
        position
      );
      return result;
    }
    return position;
  }
  /**
   * Gets a simple position for the given position ID.
   * @param {string} positionID The ID of the position to get.
   * @returns {Promise<PositionStruct>} Position object.
   */
  async getSimplePosition(positionID, showDisplay = true) {
    const objectDataResponses = await this.sdk.fullClient.getObject({
      id: positionID,
      options: { showContent: true, showType: true, showDisplay, showOwner: true }
    });
    const position = PositionUtil.buildPosition(objectDataResponses);
    return position;
  }
  /**
   * Gets a list of simple positions for the given position IDs.
   * @param {SuiObjectIdType[]} positionIDs The IDs of the positions to get.
   * @returns {Promise<PositionStruct[]>} A promise that resolves to an array of Position objects.
   */
  async getSimplePositionList(positionIDs, showDisplay = true) {
    const positionList = [];
    if (positionIDs.length > 0) {
      const objectDataResponses = await this.sdk.fullClient.batchGetObjects(positionIDs, {
        showOwner: true,
        showContent: true,
        showDisplay,
        showType: true
      });
      objectDataResponses.forEach((info) => {
        if (info.error == null) {
          positionList.push(PositionUtil.buildPosition(info));
        }
      });
    }
    return positionList;
  }
  /**
   * Updates the rewarders of position
   * @param {string} positionHandle Position handle
   * @param {PositionStruct} position Position object
   * @returns {Promise<PositionStruct>} A promise that resolves to an array of Position objects.
   */
  async updatePositionRewarders(positionHandle, position) {
    const positionReward = await this.getPositionRewarders(positionHandle, position.pos_object_id);
    return {
      ...position,
      ...positionReward
    };
  }
  /**
   * Gets the position rewarders for the given position handle and position object ID.
   * @param {string} positionHandle The handle of the position.
   * @param {string} positionID The ID of the position object.
   * @returns {Promise<PositionReward | undefined>} PositionReward object.
   */
  async getPositionRewarders(positionHandle, positionID) {
    const dynamicFieldObject = await this.sdk.fullClient.getDynamicFieldObject({
      parentId: positionHandle,
      name: {
        type: "0x2::object::ID",
        value: positionID
      }
    });
    const objectFields = SuiUtil.getObjectFields(dynamicFieldObject.data);
    const fields = objectFields.value.fields.value;
    const positionReward = PositionUtil.buildPositionReward(fields);
    return positionReward;
  }
  /**
   * Fetches the Position fee amount for a given list of addresses.
   * @param {FetchPosFeeParams[]} params  An array of FetchPosFeeParams objects containing the target addresses and their corresponding amounts.
   * @returns {Promise<CollectFeesQuote[]>} A Promise that resolves with the fetched position fee amount for the specified addresses.
   */
  async fetchPosFeeAmount(params) {
    const { clmm_pool, facade, simulationAccount } = this.sdk.sdkOptions;
    const tx = new Transaction3();
    for (const paramItem of params) {
      const typeArguments = [paramItem.coin_type_a, paramItem.coin_type_b];
      const args = [
        tx.object(clmm_pool.config.global_config_id),
        tx.object(paramItem.pool_id),
        tx.pure.address(paramItem.position_id)
      ];
      tx.moveCall({
        target: `${facade.published_at}::${ClmmFetcherModule}::fetch_position_fees`,
        arguments: args,
        typeArguments
      });
    }
    const simulateRes = await this.sdk.fullClient.devInspectTransactionBlock({
      transactionBlock: tx,
      sender: simulationAccount.address
    });
    if (simulateRes.error != null) {
      throw new ClmmpoolsError(
        `fetch position fee error code: ${simulateRes.error ?? "unknown error"}, please check config and postion and pool object ids`,
        "InvalidPoolObject" /* InvalidPoolObject */
      );
    }
    const valueData = simulateRes.events?.filter((item) => {
      return parseStructTag3(item.type).name === `FetchPositionFeesEvent`;
    });
    if (valueData.length === 0) {
      return [];
    }
    const result = [];
    for (let i = 0; i < valueData.length; i += 1) {
      const { parsedJson } = valueData[i];
      const posRrewarderResult = {
        fee_owed_a: new BN12(parsedJson.fee_owned_a),
        fee_owed_b: new BN12(parsedJson.fee_owned_b),
        position_id: parsedJson.position_id
      };
      result.push(posRrewarderResult);
    }
    return result;
  }
  /**
   * Fetches the Position fee amount for a given list of addresses.
   * @param positionIDs An array of position object ids.
   * @returns {Promise<Record<string, CollectFeesQuote>>} A Promise that resolves with the fetched position fee amount for the specified position object ids.
   */
  async batchFetchPositionFees(positionIDs) {
    const posFeeParamsList = [];
    for (const id of positionIDs) {
      const position = await this.sdk.Position.getPositionById(id, false);
      const pool = await this.sdk.Pool.getPool(position.pool);
      posFeeParamsList.push({
        pool_id: pool.pool_id,
        position_id: position.pos_object_id,
        coin_type_a: pool.coin_type_a,
        coin_type_b: pool.coin_type_b
      });
    }
    const positionMap = {};
    if (posFeeParamsList.length > 0) {
      const result = await this.fetchPosFeeAmount(posFeeParamsList);
      for (const posRewarderInfo of result) {
        positionMap[posRewarderInfo.position_id] = posRewarderInfo;
      }
      return positionMap;
    }
    return positionMap;
  }
  /**
   * create add liquidity transaction payload with fix token
   * @param {AddLiquidityFixTokenParams} params
   * @param gasEstimateArg : When the fix input amount is SUI, gasEstimateArg can control whether to recalculate the number of SUI to prevent insufficient gas.
   * If this parameter is not passed, gas estimation is not performed
   * @returns {Promise<TransactionBlock>}
   */
  async buildAddLiquidityFixTokenTransaction(params, gasEstimateArg, tx, inputCoinA, inputCoinB) {
    if (!isValidSuiAddress2(this.sdk.senderAddress)) {
      throw new ClmmpoolsError(
        "this config sdk senderAddress is not set right",
        "InvalidSendAddress" /* InvalidSendAddress */
      );
    }
    const allCoinAsset = await this.sdk.Coin.getOwnerCoinAssets(this.sdk.senderAddress);
    if (gasEstimateArg) {
      const { is_adjust_coin_a: isAdjustCoinA, is_adjust_coin_b: isAdjustCoinB } = findAdjustCoin(params);
      params = params;
      if (params.fix_amount_a && isAdjustCoinA || !params.fix_amount_a && isAdjustCoinB) {
        tx = await TransactionUtil.buildAddLiquidityFixTokenForGas(
          this.sdk,
          allCoinAsset,
          params,
          gasEstimateArg,
          tx,
          inputCoinA,
          inputCoinB
        );
        return tx;
      }
    }
    return TransactionUtil.buildAddLiquidityFixToken(
      this.sdk,
      allCoinAsset,
      params,
      tx,
      inputCoinA,
      inputCoinB
    );
  }
  /**
   * create add liquidity transaction payload
   * @param {AddLiquidityParams} params
   * @returns {Promise<TransactionBlock>}
   */
  async buildMintAndAddLiquidityTransaction(params, tx, inputCoinA, inputCoinB) {
    const { facade, clmm_pool } = this.sdk.sdkOptions;
    if (!isValidSuiAddress2(this.sdk.senderAddress)) {
      throw new ClmmpoolsError(
        "this config sdk senderAddress is not set right",
        "InvalidSendAddress" /* InvalidSendAddress */
      );
    }
    const tick_lower = MathUtil.asUintN(BigInt(params.tick_lower)).toString();
    const tick_upper = MathUtil.asUintN(BigInt(params.tick_upper)).toString();
    const typeArguments = [params.coin_type_a, params.coin_type_b];
    tx = tx || new Transaction3();
    const needOpenPosition = !isValidSuiObjectId(params.position_id);
    const max_amount_a = BigInt(params.max_amount_a);
    const max_amount_b = BigInt(params.max_amount_b);
    let primaryCoinAInputs;
    let primaryCoinBInputs;
    if (inputCoinA == null || inputCoinB == null) {
      const allCoinAsset = await this.sdk.Coin.getOwnerCoinAssets(this.sdk.senderAddress);
      primaryCoinAInputs = TransactionUtil.buildCoinForAmount(
        tx,
        allCoinAsset,
        max_amount_a,
        params.coin_type_a,
        false
      );
      primaryCoinBInputs = TransactionUtil.buildCoinForAmount(
        tx,
        allCoinAsset,
        max_amount_b,
        params.coin_type_b,
        false
      );
    } else {
      primaryCoinAInputs = {
        target_coin: inputCoinA,
        remain_coins: [],
        is_mint_zero_coin: false,
        target_coin_amount: "0"
      };
      primaryCoinBInputs = {
        target_coin: inputCoinB,
        remain_coins: [],
        is_mint_zero_coin: false,
        target_coin_amount: "0"
      };
    }
    if (needOpenPosition) {
      tx.moveCall({
        target: `${facade.published_at}::${ClmmIntegratePoolModule}::mint_with_liquidity`,
        typeArguments,
        arguments: [
          tx.object(clmm_pool.config.global_config_id),
          tx.object(params.pool_id),
          tx.pure.u32(Number(tick_lower)),
          tx.pure.u32(Number(tick_upper)),
          primaryCoinAInputs.target_coin,
          primaryCoinBInputs.target_coin,
          tx.pure.u64(params.max_amount_a),
          tx.pure.u64(params.max_amount_b),
          tx.pure.u128(params.delta_liquidity),
          tx.object(CLOCK_ADDRESS)
        ]
      });
    } else {
      const allCoinAsset = await this.sdk.Coin.getOwnerCoinAssets(this.sdk.senderAddress);
      tx = TransactionUtil.buildCollectRewarderAndFeeTransaction(
        this.sdk,
        tx,
        params,
        allCoinAsset,
        primaryCoinAInputs.remain_coins,
        primaryCoinBInputs.remain_coins
      );
      tx.moveCall({
        target: `${facade.published_at}::${ClmmIntegratePoolModule}::add_liquidity`,
        typeArguments,
        arguments: [
          tx.object(clmm_pool.config.global_config_id),
          tx.object(params.pool_id),
          tx.object(params.position_id),
          primaryCoinAInputs.target_coin,
          primaryCoinBInputs.target_coin,
          tx.pure.u64(params.max_amount_a),
          tx.pure.u64(params.max_amount_b),
          tx.pure.u128(params.delta_liquidity),
          tx.object(CLOCK_ADDRESS)
        ]
      });
    }
    return tx;
  }
  /**
   * Remove liquidity from a position.
   * @param {RemoveLiquidityParams} params
   * @returns {TransactionBlock}
   */
  async buildRemoveLiquidityTransaction(params, tx) {
    if (!isValidSuiAddress2(this.sdk.senderAddress)) {
      throw new ClmmpoolsError(
        "this config sdk senderAddress is not set right",
        "InvalidSendAddress" /* InvalidSendAddress */
      );
    }
    const { clmm_pool, facade } = this.sdk.sdkOptions;
    const functionName = "remove_liquidity";
    tx = tx || new Transaction3();
    const typeArguments = [params.coin_type_a, params.coin_type_b];
    const allCoinAsset = await this.sdk.Coin.getOwnerCoinAssets(this.sdk.senderAddress);
    tx = TransactionUtil.buildCollectRewarderAndFeeTransaction(this.sdk, tx, params, allCoinAsset);
    const args = [
      tx.object(clmm_pool.config.global_config_id),
      tx.object(params.pool_id),
      tx.object(params.position_id),
      tx.pure.u128(params.delta_liquidity),
      tx.pure.u64(params.min_amount_a),
      tx.pure.u64(params.min_amount_b),
      tx.object(CLOCK_ADDRESS)
    ];
    tx.moveCall({
      target: `${facade.published_at}::${ClmmIntegratePoolModule}::${functionName}`,
      typeArguments,
      arguments: args
    });
    return tx;
  }
  /**
   * Close position and remove all liquidity and collect_reward
   * @param {BurnParams} params
   * @returns {TransactionBlock}
   */
  async buildBurnTransaction(params, tx) {
    if (!isValidSuiAddress2(this.sdk.senderAddress)) {
      throw new ClmmpoolsError(
        "this config sdk senderAddress is not set right",
        "InvalidSendAddress" /* InvalidSendAddress */
      );
    }
    const { clmm_pool, facade } = this.sdk.sdkOptions;
    tx = tx || new Transaction3();
    const typeArguments = [params.coin_type_a, params.coin_type_b];
    const allCoinAsset = await this.sdk.Coin.getOwnerCoinAssets(this.sdk.senderAddress);
    tx = TransactionUtil.buildCollectRewarderAndFeeTransaction(this.sdk, tx, params, allCoinAsset);
    tx.moveCall({
      target: `${facade.published_at}::${ClmmIntegratePoolModule}::burn`,
      typeArguments,
      arguments: [
        tx.object(clmm_pool.config.global_config_id),
        tx.object(params.pool_id),
        tx.object(params.position_id),
        tx.pure.u64(params.min_amount_a),
        tx.pure.u64(params.min_amount_b),
        tx.object(CLOCK_ADDRESS)
      ]
    });
    return tx;
  }
  /**
   * Open position in clmmpool.
   * @param {MintParams} params
   * @returns {TransactionBlock}
   */
  buildMintTransaction(params, tx) {
    const { clmm_pool, facade } = this.sdk.sdkOptions;
    tx = tx || new Transaction3();
    const typeArguments = [params.coin_type_a, params.coin_type_b];
    const tick_lower = MathUtil.asUintN(BigInt(params.tick_lower)).toString();
    const tick_upper = MathUtil.asUintN(BigInt(params.tick_upper)).toString();
    const args = [
      tx.object(clmm_pool.config.global_config_id),
      tx.object(params.pool_id),
      tx.pure.u32(Number(tick_lower)),
      tx.pure.u32(Number(tick_upper))
    ];
    tx.moveCall({
      target: `${facade.published_at}::${ClmmIntegratePoolModule}::mint`,
      typeArguments,
      arguments: args
    });
    return tx;
  }
  /**
   * Collect LP fee from Position.
   * @param {CollectFeeParams} params
   * @param {TransactionBlock} tx
   * @returns {TransactionBlock}
   */
  async buildCollectFeeTransaction(params, tx, inputCoinA, inputCoinB) {
    if (!isValidSuiAddress2(this.sdk.senderAddress)) {
      throw new ClmmpoolsError(
        "this config sdk senderAddress is not set right",
        "InvalidSendAddress" /* InvalidSendAddress */
      );
    }
    const allCoinAsset = await this.sdk.Coin.getOwnerCoinAssets(this.sdk.senderAddress, null);
    tx = tx || new Transaction3();
    const primaryCoinAInput = TransactionUtil.buildCoinForAmount(
      tx,
      allCoinAsset,
      BigInt(0),
      params.coin_type_a,
      false
    );
    const primaryCoinBInput = TransactionUtil.buildCoinForAmount(
      tx,
      allCoinAsset,
      BigInt(0),
      params.coin_type_b,
      false
    );
    const coinA = inputCoinA ?? primaryCoinAInput.target_coin;
    const coinB = inputCoinB ?? primaryCoinBInput.target_coin;
    this.buildCollectFeeWithCoinTransaction(params, tx, coinA, coinB);
    return tx;
  }
  async buildBatchCollectFeeTransaction(params, tx, inputCoinA, inputCoinB) {
    if (!isValidSuiAddress2(this.sdk.senderAddress)) {
      throw new ClmmpoolsError(
        "this config sdk senderAddress is not set right",
        "InvalidSendAddress" /* InvalidSendAddress */
      );
    }
    const allCoinAsset = await this.sdk.Coin.getOwnerCoinAssets(this.sdk.senderAddress, null);
    tx = tx || new Transaction3();
    params.forEach((param) => {
      const primaryCoinAInput = TransactionUtil.buildCoinForAmount(
        tx,
        allCoinAsset,
        BigInt(0),
        param.coin_type_a,
        false
      );
      const primaryCoinBInput = TransactionUtil.buildCoinForAmount(
        tx,
        allCoinAsset,
        BigInt(0),
        param.coin_type_b,
        false
      );
      const coinA = inputCoinA ?? primaryCoinAInput.target_coin;
      const coinB = inputCoinB ?? primaryCoinBInput.target_coin;
      this.buildCollectFeeWithCoinTransaction(param, tx, coinA, coinB);
    });
    return tx;
  }
  buildCollectFeeWithCoinTransaction(params, tx, primaryCoinAInput, primaryCoinBInput) {
    const { clmm_pool, facade } = this.sdk.sdkOptions;
    const typeArguments = [params.coin_type_a, params.coin_type_b];
    const args = [
      tx.object(clmm_pool.config.global_config_id),
      tx.object(params.pool_id),
      tx.object(params.position_id),
      primaryCoinAInput,
      primaryCoinBInput
    ];
    tx.moveCall({
      target: `${facade.published_at}::${ClmmIntegratePoolModule}::collect_fee`,
      typeArguments,
      arguments: args
    });
    return tx;
  }
  buildCollectFeeNoSendTransaction(params, tx, primaryCoinAInput, primaryCoinBInput) {
    const { clmm_pool, facade } = this.sdk.sdkOptions;
    const typeArguments = [params.coin_type_a, params.coin_type_b];
    const args = [
      tx.object(clmm_pool.config.global_config_id),
      tx.object(params.pool_id),
      tx.object(params.position_id),
      primaryCoinAInput,
      primaryCoinBInput
    ];
    tx.moveCall({
      target: `${facade.published_at}::${ClmmIntegratePoolModule}::collect_fee_no_send`,
      typeArguments,
      arguments: args
    });
    return tx;
  }
  /**
   * calculate fee
   * @param {CollectFeeParams} params
   * @returns
   */
  async calculateFee(params) {
    const paylod = await this.buildCollectFeeTransaction(params);
    if (!isValidSuiAddress2(this.sdk.senderAddress)) {
      throw new ClmmpoolsError(
        "this config sdk senderAddress is not set right",
        "InvalidSendAddress" /* InvalidSendAddress */
      );
    }
    const res = await this.sdk.fullClient.devInspectTransactionBlock({
      transactionBlock: paylod,
      sender: this.sdk.senderAddress
    });
    for (const event of res.events) {
      if (parseStructTag3(event.type).name === "CollectFeeEvent") {
        const json = event.parsedJson;
        return {
          feeOwedA: json.amount_a,
          feeOwedB: json.amount_b
        };
      }
    }
    return {
      feeOwedA: "0",
      feeOwedB: "0"
    };
  }
};

// src/lib/router.ts
import BN13 from "bn.js";
import { Graph, GraphEdge, GraphVertex } from "@syntsugar/cc-graph";
import { Transaction as Transaction4 } from "@mysten/sui/transactions";
import { parseStructTag as parseStructTag4 } from "@mysten/sui/utils";
var Router = class extends BaseLib {
  graph = new Graph(false);
  tvlProvider = /* @__PURE__ */ new Map();
  coinAddressMap = /* @__PURE__ */ new Map();
  poolAddressMap = /* @__PURE__ */ new Map();
  /**
   * Get pool address map with direction
   * @param {string} base base coin
   * @param {string} quote quote coin
   * @returns {AddressAndDirection} address with direction
   */
  getPoolAddressMapAndDirection(base, quote) {
    const { pair, reversePair } = this.buildPairSymbol(base, quote);
    let addressMap = this.poolAddressMap.get(pair);
    if (addressMap != null) {
      return {
        address_map: addressMap,
        direction: true
      };
    }
    addressMap = this.poolAddressMap.get(reversePair);
    if (addressMap != null) {
      return {
        address_map: addressMap,
        direction: false
      };
    }
    return void 0;
  }
  /**
   * Find best router must load graph first
   * @param {CoinProvider} coins all coins
   * @param {PathProvider} paths all paths
   * @param {TVLProvider} tvls tvl in pools
   */
  loadGraph(coins, paths, tvls) {
    this.addCoinProvider(coins);
    this.addTVLProvider(tvls);
    this.addPathProvider(paths);
  }
  /**
   * Add path provider to router graph
   * @param {PathProvider} provider path provider
   * @returns {Router} module of router
   */
  addPathProvider(provider) {
    this.graph = new Graph(false);
    this.poolAddressMap = /* @__PURE__ */ new Map();
    provider.forEach((path) => {
      const vertexA = this.graph.getVertexByKey(path.base) ?? new GraphVertex(path.base);
      const vertexB = this.graph.getVertexByKey(path.quote) ?? new GraphVertex(path.quote);
      const coinA = this.coinAddressMap.get(path.base);
      const coinB = this.coinAddressMap.get(path.quote);
      this.graph.addEdge(new GraphEdge(vertexA, vertexB));
      if (coinA && coinB) {
        const { pair } = this.buildPairSymbol(path.base, path.quote);
        this.poolAddressMap.set(pair, path.address_map);
      }
    });
    return this;
  }
  /**
   * Add coin provider to router graph
   * @param {CoinProvider} provider  coin provider
   * @returns {Router} module of router
   */
  addCoinProvider(provider) {
    this.coinAddressMap = /* @__PURE__ */ new Map();
    provider.forEach((coin) => {
      this.coinAddressMap.set(coin.address, coin);
    });
    return this;
  }
  addTVLProvider(provider) {
    this.tvlProvider = /* @__PURE__ */ new Map();
    provider.forEach((node) => {
      this.tvlProvider.set(node.pool_id, node.tvl);
    });
    return this;
  }
  /**
   * Get token info from coin address map
   * @param {string} key coin type
   * @returns {CoinNode | undefined}
   */
  tokenInfo(key) {
    return this.coinAddressMap.get(key);
  }
  /**
   * Get fee rate info from pool address map
   * @param from from coin type
   * @param to to coin type
   * @param address pool address
   * @returns fee rate of pool
   */
  getFeeRate(from, to, address) {
    const poolSymbol = this.buildPairSymbol(from, to).pair;
    const addressMap = this.poolAddressMap.get(poolSymbol);
    if (addressMap != null) {
      for (const [key, value] of addressMap.entries()) {
        if (value === address) {
          return key * 100;
        }
      }
    }
    const poolSymbolRev = this.buildPairSymbol(from, to).reversePair;
    const addressMapRev = this.poolAddressMap.get(poolSymbolRev);
    if (addressMapRev != null) {
      for (const [key, value] of addressMapRev.entries()) {
        if (value === address) {
          return key * 100;
        }
      }
    }
    return 0;
  }
  /**
   * Get the best price from router graph.
   *
   * @param {string} from from coin type
   * @param {string} to to coin type
   * @param {BN} amount coin amount
   * @param {boolean} byAmountIn weather fixed input amount
   * @param {PreSwapWithMultiPoolParams} swapWithMultiPoolParams use to downgrade
   * @returns {Promise<RouteResult>} best swap router
   */
  async bestRoute(from, to, amount, byAmountIn, swapWithMultiPoolParams) {
    const fromCoin = this.tokenInfo(from);
    const toCoin = this.tokenInfo(to);
    if (fromCoin === void 0 || toCoin === void 0) {
      throw new ClmmpoolsError("From/To coin is undefined", "InvalidCoin" /* InvalidCoin */);
    }
    const fromVertex = this.graph.getVertexByKey(fromCoin.address);
    const toVertex = this.graph.getVertexByKey(toCoin.address);
    const pathIters = this.graph.findAllPath(fromVertex, toVertex);
    const allPaths = Array.from(pathIters);
    if (allPaths.length === 0) {
      throw new ClmmpoolsError("No find valid path in coin graph", "NotFoundPath" /* NotFoundPath */);
    }
    let preRouterSwapParams = [];
    for (let i = 0; i < allPaths.length; i += 1) {
      const path = allPaths[i];
      if (path.length > 3) {
        continue;
      }
      const fromAndTo = [];
      const swapDirection = [];
      const poolsAB = [];
      const poolsBC = [];
      for (let j = 0; j < path.length - 1; j += 1) {
        const subFrom = path[j].value.toString();
        const subTo = path[j + 1].value.toString();
        const addressMapAndDirection = this.getPoolAddressMapAndDirection(subFrom, subTo);
        const addressMap = addressMapAndDirection?.address_map;
        const direction = addressMapAndDirection?.direction;
        if (addressMap != null && direction != null) {
          swapDirection.push(direction);
          fromAndTo.push(subFrom);
          fromAndTo.push(subTo);
          addressMap.forEach((address) => {
            if (j === 0) {
              poolsAB.push(address);
            } else {
              poolsBC.push(address);
            }
          });
        }
      }
      for (const poolAB of poolsAB) {
        if (poolsBC.length > 0) {
          for (const poolBC of poolsBC) {
            const param = {
              step_nums: 2,
              pool_ab: poolAB,
              pool_bc: poolBC,
              a2b: swapDirection[0],
              b2c: swapDirection[1],
              amount,
              by_amount_in: byAmountIn,
              coin_type_a: fromAndTo[0],
              coin_type_b: fromAndTo[1],
              coin_type_c: fromAndTo[3]
            };
            preRouterSwapParams.push(param);
          }
        } else {
          const param = {
            step_nums: 1,
            pool_ab: poolAB,
            pool_bc: void 0,
            a2b: swapDirection[0],
            b2c: void 0,
            amount,
            by_amount_in: byAmountIn,
            coin_type_a: fromAndTo[0],
            coin_type_b: fromAndTo[1],
            coin_type_c: void 0
          };
          preRouterSwapParams.push(param);
        }
      }
    }
    const stepNumsOne = preRouterSwapParams.filter((item) => item.step_nums === 1);
    const notStepNumsOne = preRouterSwapParams.filter((item) => item.step_nums !== 1);
    const poolTvls = this.tvlProvider;
    if (poolTvls.size > 0) {
      notStepNumsOne.sort((a, b) => {
        let aTvlMinimum = 0;
        let bTvlMinimum = 0;
        if (poolTvls.has(a.pool_ab) && poolTvls.has(a.pool_bc)) {
          const tvlPoolAB = poolTvls.get(a.pool_ab);
          const tvlPoolBC = poolTvls.get(a.pool_bc);
          aTvlMinimum = Math.min(tvlPoolAB, tvlPoolBC);
        }
        if (poolTvls.has(b.pool_ab) && poolTvls.has(b.pool_bc)) {
          const tvlPoolAB = poolTvls.get(b.pool_ab);
          const tvlPoolBC = poolTvls.get(b.pool_bc);
          bTvlMinimum = Math.min(tvlPoolAB, tvlPoolBC);
        }
        return bTvlMinimum - aTvlMinimum;
      });
    }
    preRouterSwapParams = [...stepNumsOne, ...notStepNumsOne];
    if (preRouterSwapParams.length === 0) {
      if (swapWithMultiPoolParams != null) {
        const preSwapResult2 = await this.sdk.Swap.preSwapWithMultiPool(swapWithMultiPoolParams);
        const onePath2 = {
          amount_in: new BN13(preSwapResult2.estimated_amount_in),
          amount_out: new BN13(preSwapResult2.estimated_amount_out),
          pool_ids: [preSwapResult2.pool_id],
          a2b: [preSwapResult2.a2b],
          raw_amount_limit: byAmountIn ? [preSwapResult2.estimated_amount_out] : [preSwapResult2.estimated_amount_in],
          is_exceed: preSwapResult2.is_exceed,
          coin_types: [from, to]
        };
        const result2 = {
          amount_in: new BN13(preSwapResult2.estimated_amount_in),
          amount_out: new BN13(preSwapResult2.estimated_amount_out),
          paths: [onePath2],
          a2b: preSwapResult2.a2b,
          b2c: void 0,
          by_amount_in: byAmountIn,
          is_exceed: preSwapResult2.is_exceed,
          target_sqrt_price: [preSwapResult2.estimated_end_sqrt_price],
          current_sqrt_price: [preSwapResult2.estimated_start_sqrt_price],
          coin_type_a: from,
          coin_type_b: to,
          coin_type_c: void 0
        };
        return result2;
      }
      throw new ClmmpoolsError(
        "No parameters available for service downgrade",
        "NoDowngradeNeedParams" /* NoDowngradeNeedParams */
      );
    }
    const preSwapResult = await this.preRouterSwapA2B2C(preRouterSwapParams.slice(0, 16));
    if (preSwapResult == null) {
      if (swapWithMultiPoolParams != null) {
        const preSwapResult2 = await this.sdk.Swap.preSwapWithMultiPool(swapWithMultiPoolParams);
        const onePath2 = {
          amount_in: new BN13(preSwapResult2.estimated_amount_in),
          amount_out: new BN13(preSwapResult2.estimated_amount_out),
          pool_ids: [preSwapResult2.pool_id],
          a2b: [preSwapResult2.a2b],
          raw_amount_limit: byAmountIn ? [preSwapResult2.estimated_amount_out] : [preSwapResult2.estimated_amount_in],
          is_exceed: preSwapResult2.is_exceed,
          coin_types: [from, to]
        };
        const result3 = {
          amount_in: new BN13(preSwapResult2.estimated_amount_in),
          amount_out: new BN13(preSwapResult2.estimated_amount_out),
          paths: [onePath2],
          a2b: preSwapResult2.a2b,
          b2c: void 0,
          by_amount_in: byAmountIn,
          is_exceed: preSwapResult2.is_exceed,
          target_sqrt_price: [preSwapResult2.estimated_end_sqrt_price],
          current_sqrt_price: [preSwapResult2.estimated_start_sqrt_price],
          coin_type_a: from,
          coin_type_b: to,
          coin_type_c: void 0
        };
        return result3;
      }
      const result2 = {
        amount_in: ZERO,
        amount_out: ZERO,
        paths: [],
        a2b: false,
        b2c: false,
        by_amount_in: byAmountIn,
        is_exceed: true,
        target_sqrt_price: [],
        current_sqrt_price: [],
        coin_type_a: "",
        coin_type_b: "",
        coin_type_c: void 0
      };
      return result2;
    }
    const bestIndex = preSwapResult.index;
    const poolAddress = preRouterSwapParams[bestIndex].pool_bc != null ? [preRouterSwapParams[bestIndex].pool_ab, preRouterSwapParams[bestIndex].pool_bc] : [preRouterSwapParams[bestIndex].pool_ab];
    const rawAmountLimit = byAmountIn ? [preSwapResult.amount_medium, preSwapResult.amount_out] : [preSwapResult.amount_in, preSwapResult.amount_medium];
    const a2bs = [];
    a2bs.push(preRouterSwapParams[bestIndex].a2b);
    if (preSwapResult.step_num > 1) {
      a2bs.push(preRouterSwapParams[bestIndex].b2c);
    }
    const coinTypes = [];
    coinTypes.push(preRouterSwapParams[bestIndex].coin_type_a);
    coinTypes.push(preRouterSwapParams[bestIndex].coin_type_b);
    if (preSwapResult.step_num > 1) {
      coinTypes.push(preRouterSwapParams[bestIndex].coin_type_c);
    }
    const onePath = {
      amount_in: preSwapResult.amount_in,
      amount_out: preSwapResult.amount_out,
      pool_ids: poolAddress,
      a2b: a2bs,
      raw_amount_limit: rawAmountLimit,
      is_exceed: preSwapResult.is_exceed,
      coin_types: coinTypes
    };
    const result = {
      amount_in: preSwapResult.amount_in,
      amount_out: preSwapResult.amount_out,
      paths: [onePath],
      a2b: preRouterSwapParams[bestIndex].a2b,
      b2c: preSwapResult.step_num > 1 ? preRouterSwapParams[bestIndex].b2c : void 0,
      by_amount_in: byAmountIn,
      is_exceed: preSwapResult.is_exceed,
      target_sqrt_price: preSwapResult.target_sqrt_price,
      current_sqrt_price: preSwapResult.current_sqrt_price,
      coin_type_a: preRouterSwapParams[bestIndex].coin_type_a,
      coin_type_b: preRouterSwapParams[bestIndex].coin_type_b,
      coin_type_c: preSwapResult.step_num > 1 ? preRouterSwapParams[bestIndex].coin_type_c : void 0
    };
    return result;
  }
  async priceUseV1(from, to, _amount, byAmountIn, swapWithMultiPoolParams) {
    if (swapWithMultiPoolParams != null) {
      const preSwapResult = await this.sdk.Swap.preSwapWithMultiPool(swapWithMultiPoolParams);
      const onePath = {
        amount_in: new BN13(preSwapResult.estimated_amount_in),
        amount_out: new BN13(preSwapResult.estimated_amount_out),
        pool_ids: [preSwapResult.pool_id],
        a2b: [preSwapResult.a2b],
        raw_amount_limit: byAmountIn ? [preSwapResult.estimated_amount_out] : [preSwapResult.estimated_amount_in],
        is_exceed: preSwapResult.is_exceed,
        coin_types: [from, to]
      };
      const result = {
        amount_in: new BN13(preSwapResult.estimated_amount_in),
        amount_out: new BN13(preSwapResult.estimated_amount_out),
        paths: [onePath],
        a2b: preSwapResult.a2b,
        b2c: void 0,
        by_amount_in: byAmountIn,
        is_exceed: preSwapResult.is_exceed,
        target_sqrt_price: [preSwapResult.estimated_end_sqrt_price],
        current_sqrt_price: [preSwapResult.estimated_start_sqrt_price],
        coin_type_a: from,
        coin_type_b: to,
        coin_type_c: void 0
      };
      return result;
    }
    throw new ClmmpoolsError(
      "No parameters available for service downgrade",
      "NoDowngradeNeedParams" /* NoDowngradeNeedParams */
    );
  }
  async preRouterSwapA2B2C(params) {
    if (params.length === 0) {
      return null;
    }
    const { facade, simulationAccount } = this.sdk.sdkOptions;
    const tx = new Transaction4();
    for (const param of params) {
      if (param.step_nums > 1) {
        const args = [
          tx.object(param.pool_ab),
          tx.object(param.pool_bc),
          tx.pure.bool(param.a2b),
          tx.pure.bool(param.b2c),
          tx.pure.bool(param.by_amount_in),
          tx.pure.u64(param.amount.toString())
        ];
        const typeArguments = [];
        if (param.a2b) {
          typeArguments.push(param.coin_type_a, param.coin_type_b);
        } else {
          typeArguments.push(param.coin_type_b, param.coin_type_a);
        }
        if (param.b2c) {
          typeArguments.push(param.coin_type_b, param.coin_type_c);
        } else {
          typeArguments.push(param.coin_type_c, param.coin_type_b);
        }
        tx.moveCall({
          target: `${facade.published_at}::${ClmmIntegrateRouterModule}::calculate_router_swap_result`,
          typeArguments,
          arguments: args
        });
      } else {
        const args = [
          tx.object(param.pool_ab),
          tx.pure.bool(param.a2b),
          tx.pure.bool(param.by_amount_in),
          tx.pure.u64(param.amount.toString())
        ];
        const typeArguments = param.a2b ? [param.coin_type_a, param.coin_type_b] : [param.coin_type_b, param.coin_type_a];
        tx.moveCall({
          target: `${facade.published_at}::${ClmmExpectSwapModule}::get_expect_swap_result`,
          arguments: args,
          typeArguments
        });
      }
    }
    const simulateRes = await this.sdk.fullClient.devInspectTransactionBlock({
      transactionBlock: tx,
      sender: simulationAccount.address
    });
    const valueData = simulateRes.events?.filter((item) => {
      return parseStructTag4(item.type).name === `CalculatedRouterSwapResultEvent` || parseStructTag4(item.type).name === `ExpectSwapResultEvent`;
    });
    if (valueData.length === 0) {
      return null;
    }
    let tempMaxAmount = params[0].by_amount_in ? ZERO : U64_MAX;
    let tempIndex = 0;
    for (let i = 0; i < valueData.length; i += 1) {
      if (valueData[i].parsedJson.data.is_exceed) {
        continue;
      }
      if (params[0].by_amount_in) {
        const amount = new BN13(valueData[i].parsedJson.data.amount_out);
        if (amount.gt(tempMaxAmount)) {
          tempIndex = i;
          tempMaxAmount = amount;
        }
      } else {
        const amount = params[i].step_nums > 1 ? new BN13(valueData[i].parsedJson.data.amount_in) : new BN13(valueData[i].parsedJson.data.amount_in).add(
          new BN13(valueData[i].parsedJson.data.fee_amount)
        );
        if (amount.lt(tempMaxAmount)) {
          tempIndex = i;
          tempMaxAmount = amount;
        }
      }
    }
    const currentSqrtPrice = [];
    const targetSqrtPrice = [];
    if (params[tempIndex].step_nums > 1) {
      targetSqrtPrice.push(
        valueData[tempIndex].parsedJson.data.target_sqrt_price_ab,
        valueData[tempIndex].parsedJson.data.target_sqrt_price_cd
      );
      currentSqrtPrice.push(
        valueData[tempIndex].parsedJson.data.current_sqrt_price_ab,
        valueData[tempIndex].parsedJson.data.current_sqrt_price_cd
      );
    } else {
      targetSqrtPrice.push(valueData[tempIndex].parsedJson.data.after_sqrt_price);
      currentSqrtPrice.push(valueData[tempIndex].parsedJson.current_sqrt_price);
    }
    const result = {
      index: tempIndex,
      amount_in: params[0].by_amount_in ? params[tempIndex].amount : tempMaxAmount,
      amount_medium: valueData[tempIndex].parsedJson.data.amount_medium,
      amount_out: params[0].by_amount_in ? tempMaxAmount : params[tempIndex].amount,
      target_sqrt_price: targetSqrtPrice,
      current_sqrt_price: currentSqrtPrice,
      is_exceed: valueData[tempIndex].parsedJson.data.is_exceed,
      step_num: params[tempIndex].step_nums
    };
    return result;
  }
  /**
   * build pair symbol
   * @param base base coin
   * @param quote quote coin
   * @returns pair symbol
   */
  buildPairSymbol(base, quote) {
    return {
      pair: `${base}-${quote}`,
      reversePair: `${quote}-${base}`
    };
  }
};

// src/lib/swap.ts
import BN14 from "bn.js";
import Decimal6 from "decimal.js";
import { Transaction as Transaction5 } from "@mysten/sui/transactions";
import { parseStructTag as parseStructTag5 } from "@mysten/sui/utils";
var AMM_SWAP_MODULE = "amm_swap";
var POOL_STRUCT = "Pool";
var Swap = class extends BaseLib {
  calculateSwapFee(paths) {
    let fee = MathUtil.toDecimal(0);
    paths.forEach((item) => {
      const pathCount = item.basePaths.length;
      if (pathCount > 0) {
        const path = item.basePaths[0];
        const feeRate = path.label === "Parrot" ? new Decimal6(path.feeRate).div(10 ** 6) : new Decimal6(path.feeRate).div(10 ** 9);
        const feeAmount = MathUtil.toDecimal(path.inputAmount).div(10 ** path.fromDecimal).mul(feeRate);
        fee = fee.add(feeAmount);
        if (pathCount > 1) {
          const path2 = item.basePaths[1];
          const price1 = path.direction ? path.currentPrice : new Decimal6(1).div(path.currentPrice);
          const price2 = path2.direction ? path2.currentPrice : new Decimal6(1).div(path2.currentPrice);
          const feeRate2 = path2.label === "Parrot" ? new Decimal6(path2.feeRate).div(10 ** 6) : new Decimal6(path2.feeRate).div(10 ** 9);
          const feeAmount2 = MathUtil.toDecimal(path2.outputAmount).div(10 ** path2.toDecimal).mul(feeRate2);
          const fee2 = feeAmount2.div(price1.mul(price2));
          fee = fee.add(fee2);
        }
      }
    });
    return fee.toString();
  }
  calculateSwapPriceImpact(paths) {
    let impactValue = MathUtil.toDecimal(0);
    paths.forEach((item) => {
      const pathCount = item.basePaths.length;
      if (pathCount === 1) {
        const path = item.basePaths[0];
        const outputAmount = MathUtil.toDecimal(path.outputAmount).div(10 ** path.toDecimal);
        const inputAmount = MathUtil.toDecimal(path.inputAmount).div(10 ** path.fromDecimal);
        const rate = outputAmount.div(inputAmount);
        const cprice = path.direction ? new Decimal6(path.currentPrice) : new Decimal6(1).div(path.currentPrice);
        impactValue = impactValue.add(this.calculateSingleImpact(rate, cprice));
      }
      if (pathCount === 2) {
        const path = item.basePaths[0];
        const path2 = item.basePaths[1];
        const cprice1 = path.direction ? new Decimal6(path.currentPrice) : new Decimal6(1).div(path.currentPrice);
        const cprice2 = path2.direction ? new Decimal6(path2.currentPrice) : new Decimal6(1).div(path2.currentPrice);
        const cprice = cprice1.mul(cprice2);
        const outputAmount = new Decimal6(path2.outputAmount).div(10 ** path2.toDecimal);
        const inputAmount = new Decimal6(path.inputAmount).div(10 ** path.fromDecimal);
        const rate = outputAmount.div(inputAmount);
        impactValue = impactValue.add(this.calculateSingleImpact(rate, cprice));
      }
    });
    return impactValue.toString();
  }
  calculateSingleImpact = (rate, cprice) => {
    return cprice.minus(rate).div(cprice).mul(100);
  };
  /**
   * Performs a pre-swap with multiple pools.
   *
   * @param {PreSwapWithMultiPoolParams} params The parameters for the pre-swap.
   * @returns {Promise<SwapWithMultiPoolData>} A promise that resolves to the swap data.
   */
  async preSwapWithMultiPool(params) {
    const { facade, simulationAccount } = this.sdk.sdkOptions;
    const tx = new Transaction5();
    const typeArguments = [params.coin_type_a, params.coin_type_b];
    for (let i = 0; i < params.pool_ids.length; i += 1) {
      const args = [
        tx.object(params.pool_ids[i]),
        tx.pure.bool(params.a2b),
        tx.pure.bool(params.by_amount_in),
        tx.pure.u64(params.amount)
      ];
      tx.moveCall({
        target: `${facade.published_at}::${ClmmFetcherModule}::calculate_swap_result`,
        arguments: args,
        typeArguments
      });
    }
    const simulateRes = await this.sdk.fullClient.devInspectTransactionBlock({
      transactionBlock: tx,
      sender: simulationAccount.address
    });
    if (simulateRes.error != null) {
      throw new ClmmpoolsError(
        `pre swap with multi pools error code: ${simulateRes.error ?? "unknown error"}, please check config and params`,
        "InvalidConfig" /* InvalidConfig */
      );
    }
    const valueData = simulateRes.events?.filter((item) => {
      return parseStructTag5(item.type).name === `CalculatedSwapResultEvent`;
    });
    if (valueData.length === 0) {
      return null;
    }
    if (valueData.length !== params.pool_ids.length) {
      throw new ClmmpoolsError(
        "valueData.length !== params.pools.length",
        "ParamsLengthNotEqual" /* ParamsLengthNotEqual */
      );
    }
    let tempMaxAmount = params.by_amount_in ? ZERO : U64_MAX;
    let tempIndex = 0;
    for (let i = 0; i < valueData.length; i += 1) {
      if (valueData[i].parsedJson.data.is_exceed) {
        continue;
      }
      if (params.by_amount_in) {
        const amount = new BN14(valueData[i].parsedJson.data.amount_out);
        if (amount.gt(tempMaxAmount)) {
          tempIndex = i;
          tempMaxAmount = amount;
        }
      } else {
        const amount = new BN14(valueData[i].parsedJson.data.amount_out);
        if (amount.lt(tempMaxAmount)) {
          tempIndex = i;
          tempMaxAmount = amount;
        }
      }
    }
    return this.transformSwapWithMultiPoolData(
      {
        pool_id: params.pool_ids[tempIndex],
        a2b: params.a2b,
        by_amount_in: params.by_amount_in,
        amount: params.amount,
        coin_type_a: params.coin_type_a,
        coin_type_b: params.coin_type_b
      },
      valueData[tempIndex].parsedJson
    );
  }
  /**
   * Performs a pre-swap.
   *
   * @param {PreSwapParams} params The parameters for the pre-swap.
   * @returns {Promise<PreSwapParams>} A promise that resolves to the swap data.
   */
  async preswap(params) {
    const { facade, simulationAccount } = this.sdk.sdkOptions;
    const tx = new Transaction5();
    const typeArguments = [params.coin_type_a, params.coin_type_b];
    const args = [
      tx.object(params.pool.pool_id),
      tx.pure.bool(params.a2b),
      tx.pure.bool(params.by_amount_in),
      tx.pure.u64(params.amount)
    ];
    tx.moveCall({
      target: `${facade.published_at}::${ClmmFetcherModule}::calculate_swap_result`,
      arguments: args,
      typeArguments
    });
    const simulateRes = await this.sdk.fullClient.devInspectTransactionBlock({
      transactionBlock: tx,
      sender: simulationAccount.address
    });
    if (simulateRes.error != null) {
      throw new ClmmpoolsError(
        `preswap error code: ${simulateRes.error ?? "unknown error"}, please check config and params`,
        "InvalidConfig" /* InvalidConfig */
      );
    }
    const valueData = simulateRes.events?.filter((item) => {
      return parseStructTag5(item.type).name === `CalculatedSwapResultEvent`;
    });
    if (valueData.length === 0) {
      return null;
    }
    return this.transformSwapData(params, valueData[0].parsedJson.data);
  }
  transformSwapData(params, data) {
    const estimatedAmountIn = data.amount_in && data.fee_amount ? new BN14(data.amount_in).add(new BN14(data.fee_amount)).toString() : "";
    return {
      pool_id: params.pool.pool_id,
      current_sqrt_price: params.current_sqrt_price,
      estimated_amount_in: estimatedAmountIn,
      estimated_amount_out: data.amount_out,
      estimated_end_sqrt_price: data.after_sqrt_price,
      estimated_fee_amount: data.fee_amount,
      is_exceed: data.is_exceed,
      amount: params.amount,
      a2b: params.a2b,
      by_amount_in: params.by_amount_in
    };
  }
  transformSwapWithMultiPoolData(params, jsonData) {
    const { data } = jsonData;
    const estimatedAmountIn = data.amount_in && data.fee_amount ? new BN14(data.amount_in).add(new BN14(data.fee_amount)).toString() : "";
    return {
      pool_id: params.pool_id,
      estimated_amount_in: estimatedAmountIn,
      estimated_amount_out: data.amount_out,
      estimated_end_sqrt_price: data.after_sqrt_price,
      estimated_start_sqrt_price: data.step_results[0].current_sqrt_price,
      estimated_fee_amount: data.fee_amount,
      is_exceed: data.is_exceed,
      amount: params.amount,
      a2b: params.a2b,
      by_amount_in: params.by_amount_in
    };
  }
  /**
   * Calculates the rates for a swap.
   * @param {CalculateSwapResultParams} params The parameters for the calculation.
   * @returns {calculateSwapResult} The results of the calculation.
   */
  calculateSwapResult(params) {
    const { current_pool: currentPool } = params;
    const poolData = PoolUtil.transClmmpoolDataWithoutTicks(currentPool);
    let ticks;
    if (params.a2b) {
      ticks = params.swap_ticks.sort((a, b) => {
        return b.index - a.index;
      });
    } else {
      ticks = params.swap_ticks.sort((a, b) => {
        return a.index - b.index;
      });
    }
    const swapResult = PoolUtil.computeSwap(
      params.a2b,
      params.by_amount_in,
      params.amount,
      poolData,
      ticks
    );
    let isExceed = false;
    if (params.by_amount_in) {
      isExceed = swapResult.amount_in.lt(params.amount);
    } else {
      isExceed = swapResult.amount_out.lt(params.amount);
    }
    const sqrtPriceLimit = SwapUtil.getDefaultSqrtPriceLimit(params.a2b);
    if (params.a2b && swapResult.next_sqrt_price.lt(sqrtPriceLimit)) {
      isExceed = true;
    }
    if (!params.a2b && swapResult.next_sqrt_price.gt(sqrtPriceLimit)) {
      isExceed = true;
    }
    let extraComputeLimit = 0;
    if (swapResult.cross_tick_num > 6 && swapResult.cross_tick_num < 40) {
      extraComputeLimit = 22e3 * (swapResult.cross_tick_num - 6);
    }
    if (swapResult.cross_tick_num > 40) {
      isExceed = true;
    }
    const prePrice = TickMath.sqrtPriceX64ToPrice(
      poolData.current_sqrt_price,
      params.decimals_a,
      params.decimals_b
    ).toNumber();
    const afterPrice = TickMath.sqrtPriceX64ToPrice(
      swapResult.next_sqrt_price,
      params.decimals_a,
      params.decimals_b
    ).toNumber();
    const priceImpactPct = Math.abs(prePrice - afterPrice) / prePrice * 100;
    return {
      estimated_amount_in: swapResult.amount_in,
      estimated_amount_out: swapResult.amount_out,
      estimated_end_sqrt_price: swapResult.next_sqrt_price,
      estimated_fee_amount: swapResult.fee_amount,
      is_exceed: isExceed,
      extra_compute_limit: extraComputeLimit,
      amount: params.amount,
      a2b: params.a2b,
      by_amount_in: params.by_amount_in,
      price_impact_percentage: priceImpactPct
    };
  }
  /**
   * create swap transaction payload
   * @param params
   * @param gasEstimateArg When the fix input amount is SUI, gasEstimateArg can control whether to recalculate the number of SUI to prevent insufficient gas.
   * If this parameter is not passed, gas estimation is not performed
   * @returns
   */
  async buildSwapTransaction(params, gasEstimateArg) {
    if (this.sdk.senderAddress.length === 0) {
      throw Error("this config sdk senderAddress is empty");
    }
    const allCoinAsset = await this.sdk.Coin.getOwnerCoinAssets(this.sdk.senderAddress);
    if (gasEstimateArg) {
      const { is_adjust_coin_a: isAdjustCoinA, is_adjust_coin_b: isAdjustCoinB } = findAdjustCoin(params);
      if (params.a2b && isAdjustCoinA || !params.a2b && isAdjustCoinB) {
        return TransactionUtil.buildSwapTransactionForGas(
          this.sdk,
          params,
          allCoinAsset,
          gasEstimateArg
        );
      }
    }
    return TransactionUtil.buildSwapTransaction(this.sdk, params, allCoinAsset);
  }
  /**
   * create swap transaction without transfer coins payload
   * @param params
   * @param gasEstimateArg When the fix input amount is SUI, gasEstimateArg can control whether to recalculate the number of SUI to prevent insufficient gas.
   * If this parameter is not passed, gas estimation is not performed
   * @returns tx and coin ABs
   */
  async buildSwapWithoutTransferCoinsTransaction(params, gasEstimateArg) {
    if (this.sdk.senderAddress.length === 0) {
      throw Error("this config sdk senderAddress is empty");
    }
    const allCoinAsset = await this.sdk.Coin.getOwnerCoinAssets(this.sdk.senderAddress);
    if (gasEstimateArg) {
      const { is_adjust_coin_a: isAdjustCoinA, is_adjust_coin_b: isAdjustCoinB } = findAdjustCoin(params);
      if (params.a2b && isAdjustCoinA || !params.a2b && isAdjustCoinB) {
        const res = await TransactionUtil.buildSwapTransactionWithoutTransferCoinsForGas(
          this.sdk,
          params,
          allCoinAsset,
          gasEstimateArg
        );
        return res;
      }
    }
    return TransactionUtil.buildSwapTransactionWithoutTransferCoins(this.sdk, params, allCoinAsset);
  }
};

// src/lib/sui-rpc.ts
import "@mysten/sui/transactions";
import {
  SuiClient
} from "@mysten/sui/client";
import "@mysten/sui/keypairs/ed25519";
import "@mysten/sui/keypairs/secp256k1";
var SuiRpc = class extends SuiClient {
  /**
   * Get all events for a given query criteria
   * @param query
   *
   * ```typescript
   * const events = this.queryAllEvents<{ foo: 'bar' }>({
   *   MoveEventModule: { package: '0x123', module: 'my_module' },
   * });
   *
   * for await (const event of events) {
   *   console.log(event.parsedJson.foo);
   * }
   * ```
   */
  async *queryAllEvents(query) {
    let hasNextPage = true;
    let cursor;
    do {
      const res = await this.queryEvents({ query, cursor });
      for (const event of res.data) {
        yield event;
      }
      cursor = res.nextCursor;
      hasNextPage = res.hasNextPage;
    } while (hasNextPage);
  }
  /**
   * Get all objects owned by an address
   * @param owner
   * @param query
   */
  async *getAllOwnedObjects(owner, query) {
    let hasNextPage = true;
    let cursor;
    do {
      const res = await this.getOwnedObjects({ owner, ...query, cursor });
      for (const obj of res.data) {
        yield obj;
      }
      cursor = res.nextCursor;
      hasNextPage = res.hasNextPage;
    } while (hasNextPage);
  }
  /**
   * Return the list of dynamic field objects owned by an object
   * @param parentId
   */
  async *getAllDynamicFields(parentId) {
    let hasNextPage = true;
    let cursor;
    do {
      const res = await this.getDynamicFields({
        parentId,
        cursor
      });
      for (const field of res.data) {
        yield field;
      }
      hasNextPage = res.hasNextPage;
      cursor = res.nextCursor;
    } while (hasNextPage);
  }
  /**
   * Same as method `multiGetObjects`, auto remove duplicated digests, and turn to batch request when size greater than 50
   * @param ids
   * @param options
   * @returns
   */
  async batchGetObjects(ids, options) {
    const step = 50;
    const objectDataResponses = [];
    ids = [...new Set(ids)];
    for (let i = 0; i < ids.length; i += step) {
      const res = await super.multiGetObjects({ ids: ids.slice(i, i + step), options });
      objectDataResponses.push(...res);
    }
    return objectDataResponses;
  }
  /**
   * Calculates the gas cost of a transaction block.
   * @param {Transaction} tx - The transaction block to calculate gas for.
   * @returns {Promise<number>} - The estimated gas cost of the transaction block.
   * @throws {Error} - Throws an error if the sender is empty.
   */
  async calculateTxGas(tx) {
    const { sender } = tx.getData();
    if (sender === void 0) {
      throw new Error("sdk sender is empty");
    }
    const devResult = await this.devInspectTransactionBlock({
      transactionBlock: tx,
      sender
    });
    const { gasUsed } = devResult.effects;
    const estimateGas = Number(gasUsed.computationCost) + Number(gasUsed.storageCost) - Number(gasUsed.storageRebate);
    return estimateGas;
  }
  /**
   * Sends a transaction block after signing it with the provided keypair.
   *
   * @param {Ed25519Keypair | Secp256k1Keypair} keypair - The keypair used for signing the transaction.
   * @param {Transaction} tx - The transaction block to send.
   * @returns {Promise<SuiTransactionBlockResponse>} - The response of the sent transaction block.
   */
  sendTransaction(keypair, tx) {
    return this.signAndExecuteTransaction({
      transaction: tx,
      signer: keypair,
      options: {
        showEffects: true,
        showEvents: true
      }
    });
  }
  /**
   * Send a simulation transaction.
   * @param tx - The transaction block.
   * @param simulationAccount - The simulation account.
   * @returns A promise that resolves to DevInspectResults.
   */
  async sendSimulationTransaction(tx, simulationAccount) {
    return this.devInspectTransactionBlock({
      transactionBlock: tx,
      sender: simulationAccount
    });
  }
};

// src/lib/coin.ts
import { Transaction as Transaction7 } from "@mysten/sui/transactions";
import { parseStructTag as parseStructTag6 } from "@mysten/sui/utils";
var Coin = class extends BaseLib {
  async getCoins() {
    let coinList = [];
    let start = [];
    const limit = 512;
    while (true) {
      const data = await this.fetchCoins(start, limit);
      coinList = [...coinList, ...data];
      if (data.length < limit) break;
      start = [data[data.length - 1].coin_type];
    }
    return coinList;
  }
  async fetchCoins(starts = [], limit) {
    const { simulationAccount, clmm_pool, facade } = this.sdk.sdkOptions;
    const tx = new Transaction7();
    const startVec = tx.pure.vector("string", starts.length === 0 ? [] : [starts[0]]);
    tx.moveCall({
      target: `${facade.package_id}::fetcher::fetch_coins`,
      arguments: [tx.object(clmm_pool.config.coin_list_id), startVec, tx.pure.u64(limit)]
    });
    const simulateRes = await this.sdk.fullClient.devInspectTransactionBlock({
      transactionBlock: tx,
      sender: simulationAccount.address
    });
    const coinList = [];
    simulateRes.events?.forEach((event) => {
      if (parseStructTag6(event.type).name === "FetchCoinListEvent") {
        event.parsedJson.coins.forEach((coin) => {
          coinList.push(CoinUtil.buildCoinInfo(coin));
        });
      }
    });
    return coinList;
  }
  /**
   * Gets all coin assets for the given owner and coin type.
   *
   * @param suiAddress The address of the owner.
   * @param coinType The type of the coin.
   * @returns an array of coin assets.
   */
  async getOwnerCoinAssets(suiAddress, coinType) {
    const allCoinAsset = [];
    let nextCursor = null;
    while (true) {
      const allCoinObject = await (coinType ? this.sdk.fullClient.getCoins({
        owner: suiAddress,
        coinType,
        cursor: nextCursor
      }) : this.sdk.fullClient.getAllCoins({
        owner: suiAddress,
        cursor: nextCursor
      }));
      allCoinObject.data.forEach((coin) => {
        if (BigInt(coin.balance) > 0) {
          allCoinAsset.push({
            coin_address: CoinUtil.normalizeCoinType(coin.coinType),
            coin_object_id: coin.coinObjectId,
            balance: BigInt(coin.balance)
          });
        }
      });
      nextCursor = allCoinObject.nextCursor;
      if (!allCoinObject.hasNextPage) {
        break;
      }
    }
    return allCoinAsset;
  }
  /**
   * Gets all coin balances for the given owner and coin type.
   *
   * @param suiAddress The address of the owner.
   * @param coinType The type of the coin.
   * @returns an array of coin balances.
   */
  async getOwnerCoinBalances(suiAddress, coinType) {
    let allCoinBalance = [];
    if (coinType) {
      const res = await this.sdk.fullClient.getBalance({
        owner: suiAddress,
        coinType
      });
      allCoinBalance = [res];
    } else {
      const res = await this.sdk.fullClient.getAllBalances({
        owner: suiAddress
      });
      allCoinBalance = [...res];
    }
    return allCoinBalance;
  }
};

// src/lib/split-swap.ts
import BN15 from "bn.js";
var SplitSwap = class {
  minSplitSwapUnit;
  amountArray;
  byAmountIn;
  a2b;
  clmmpool;
  ticks;
  splitSwapResult;
  constructor(amount, unit, clmmpool, a2b, byAmountIn, tickData) {
    this.minSplitSwapUnit = unit;
    this.a2b = a2b;
    this.byAmountIn = byAmountIn;
    this.clmmpool = clmmpool;
    this.ticks = tickData;
    this.amountArray = [];
    this.createSplitSwapParams = this.createSplitSwapParams.bind(this);
    this.createSplitSwapParams(amount, unit);
    this.splitSwapResult = {
      amountInArray: [],
      amountOutArray: [],
      feeAmountArray: [],
      nextSqrtPriceArray: [],
      isExceed: []
    };
    this.computeSwap = this.computeSwap.bind(this);
  }
  createSplitSwapParams(amount, unit) {
    const amountArray = this.createSplitAmountArray(amount, unit);
    this.amountArray = amountArray;
  }
  computeSwap() {
    const pool = PoolUtil.transClmmpoolDataWithoutTicks(this.clmmpool);
    this.splitSwapResult = this.computeSplitSwap(
      this.a2b,
      this.byAmountIn,
      this.amountArray,
      pool,
      this.ticks
    );
    return this.splitSwapResult;
  }
  updateSplitSwapResult(maxIndex, currentIndex, splitSwapResult, stepResult) {
    for (let index = currentIndex; index < maxIndex; index += 1) {
      splitSwapResult.amountInArray[index] = splitSwapResult.amountInArray[index].add(
        stepResult.amount_in
      );
      splitSwapResult.amountOutArray[index] = splitSwapResult.amountOutArray[index].add(
        stepResult.amount_out
      );
      splitSwapResult.feeAmountArray[index] = splitSwapResult.feeAmountArray[index].add(
        stepResult.fee_amount
      );
    }
    return splitSwapResult;
  }
  computeSplitSwap(a2b, byAmountIn, amounts, poolData, swapTicks) {
    let currentLiquidity = new BN15(poolData.liquidity);
    let { current_sqrt_price: currentSqrtPrice } = poolData;
    let splitSwapResult = {
      amountInArray: [],
      amountOutArray: [],
      feeAmountArray: [],
      nextSqrtPriceArray: [],
      isExceed: []
    };
    amounts.forEach(() => {
      splitSwapResult.amountInArray.push(ZERO);
      splitSwapResult.amountOutArray.push(ZERO);
      splitSwapResult.feeAmountArray.push(ZERO);
      splitSwapResult.nextSqrtPriceArray.push(ZERO);
    });
    let targetSqrtPrice;
    let signedLiquidityChange;
    const sqrtPriceLimit = SwapUtil.getDefaultSqrtPriceLimit(a2b);
    const maxIndex = amounts.length;
    let remainerAmount = amounts[1];
    let currentIndex = 1;
    let ticks;
    if (a2b) {
      ticks = swapTicks.sort((a, b) => {
        return b.index - a.index;
      });
    } else {
      ticks = swapTicks.sort((a, b) => {
        return a.index - b.index;
      });
    }
    for (const tick of ticks) {
      if (a2b) {
        if (poolData.current_tick_index < tick.index) {
          continue;
        }
      } else if (poolData.current_tick_index > tick.index) {
        continue;
      }
      if (tick === null) {
        continue;
      }
      if (a2b && sqrtPriceLimit.gt(tick.sqrt_price) || !a2b && sqrtPriceLimit.lt(tick.sqrt_price)) {
        targetSqrtPrice = sqrtPriceLimit;
      } else {
        targetSqrtPrice = tick.sqrt_price;
      }
      let tempStepResult = {
        amount_in: ZERO,
        amount_out: ZERO,
        next_sqrt_price: ZERO,
        fee_amount: ZERO
      };
      const tempSqrtPrice = currentSqrtPrice;
      const tempLiquidity = currentLiquidity;
      let tempRemainerAmount = remainerAmount;
      let currentTempIndex = currentIndex;
      for (let i = currentIndex; i < maxIndex; i += 1) {
        const stepResult = PoolUtil.computeSwapStep(
          currentSqrtPrice,
          targetSqrtPrice,
          currentLiquidity,
          remainerAmount,
          new BN15(poolData.fee_rate),
          byAmountIn
        );
        tempStepResult = stepResult;
        if (!stepResult.amount_in.eq(ZERO)) {
          remainerAmount = byAmountIn ? remainerAmount.sub(stepResult.amount_in.add(stepResult.fee_amount)) : remainerAmount.sub(stepResult.amount_out);
        }
        if (remainerAmount.eq(ZERO)) {
          splitSwapResult.amountInArray[i] = splitSwapResult.amountInArray[i].add(
            stepResult.amount_in
          );
          splitSwapResult.amountOutArray[i] = splitSwapResult.amountOutArray[i].add(
            stepResult.amount_out
          );
          splitSwapResult.feeAmountArray[i] = splitSwapResult.feeAmountArray[i].add(
            stepResult.fee_amount
          );
          if (stepResult.next_sqrt_price.eq(tick.sqrt_price)) {
            signedLiquidityChange = a2b ? tick.liquidity_net.mul(new BN15(-1)) : tick.liquidity_net;
            currentLiquidity = signedLiquidityChange.gt(ZERO) ? currentLiquidity.add(signedLiquidityChange) : currentLiquidity.sub(signedLiquidityChange.abs());
            currentSqrtPrice = tick.sqrt_price;
          } else {
            currentSqrtPrice = stepResult.next_sqrt_price;
          }
          splitSwapResult.amountInArray[i] = splitSwapResult.amountInArray[i].add(
            splitSwapResult.feeAmountArray[i]
          );
          splitSwapResult.nextSqrtPriceArray[i] = currentSqrtPrice;
          currentLiquidity = tempLiquidity;
          currentSqrtPrice = tempSqrtPrice;
          if (i !== maxIndex - 1) {
            remainerAmount = tempRemainerAmount.add(amounts[i + 1].sub(amounts[currentTempIndex]));
          }
          currentIndex += 1;
        } else {
          splitSwapResult = this.updateSplitSwapResult(maxIndex, i, splitSwapResult, stepResult);
          tempRemainerAmount = remainerAmount;
          currentTempIndex = currentIndex;
          break;
        }
      }
      if (currentIndex === maxIndex) {
        break;
      }
      if (tempStepResult.next_sqrt_price.eq(tick.sqrt_price)) {
        signedLiquidityChange = a2b ? tick.liquidity_net.mul(new BN15(-1)) : tick.liquidity_net;
        currentLiquidity = signedLiquidityChange.gt(ZERO) ? currentLiquidity.add(signedLiquidityChange) : currentLiquidity.sub(signedLiquidityChange.abs());
        currentSqrtPrice = tick.sqrt_price;
      } else {
        currentSqrtPrice = tempStepResult.next_sqrt_price;
      }
    }
    if (byAmountIn) {
      amounts.forEach((a, i) => {
        splitSwapResult.isExceed.push(splitSwapResult.amountInArray[i].lt(a));
      });
    } else {
      amounts.forEach((a, i) => {
        splitSwapResult.isExceed.push(splitSwapResult.amountOutArray[i].lt(a));
      });
    }
    return splitSwapResult;
  }
  createSplitArray(minSplitSwapUnit) {
    let unit;
    switch (minSplitSwapUnit) {
      case 5 /* FIVE */:
        unit = 5;
        break;
      case 10 /* TEN */:
        unit = 10;
        break;
      case 20 /* TWENTY */:
        unit = 20;
        break;
      case 25 /* TWENTY_FIVE */:
        unit = 25;
        break;
      case 50 /* FIVETY */:
        unit = 50;
        break;
      case 100 /* HUNDRED */:
        unit = 100;
        break;
      default:
        unit = 1;
    }
    const length = 100 / unit + 1;
    const splitArray = new Array(length);
    for (let i = 0; i < length; i += 1) {
      splitArray[i] = i * unit;
    }
    return splitArray;
  }
  createSplitAmountArray(amount, minSplitSwapUnit) {
    const splitArray = this.createSplitArray(minSplitSwapUnit);
    const splitAmountArray = new Array(splitArray.length);
    for (let i = 0; i < splitArray.length; i += 1) {
      splitAmountArray[i] = amount.muln(splitArray[i]).divn(100);
    }
    return splitAmountArray;
  }
};

// src/lib/rewarder.ts
import BN16 from "bn.js";
import {
  Transaction as Transaction8
} from "@mysten/sui/transactions";
import { isValidSuiAddress as isValidSuiAddress3, parseStructTag as parseStructTag7 } from "@mysten/sui/utils";
var Rewarder = class extends BaseLib {
  /**
   * Gets the emissions for the given pool every day.
   *
   * @param {string} poolID The object ID of the pool.
   * @returns {Promise<Array<{emissions: number, coinAddress: string}>>} A promise that resolves to an array of objects with the emissions and coin address for each rewarder.
   */
  async emissionsEveryDay(poolID) {
    const currentPool = await this.sdk.Pool.getPool(poolID);
    const rewarderInfos = currentPool.rewarder_infos;
    if (!rewarderInfos) {
      return null;
    }
    const emissionsEveryDay = [];
    for (const rewarderInfo of rewarderInfos) {
      const emissionSeconds = MathUtil.fromX64(new BN16(rewarderInfo.emissions_per_second));
      emissionsEveryDay.push({
        emissions: Math.floor(emissionSeconds.toNumber() * 60 * 60 * 24),
        coin_address: rewarderInfo.coin_address
      });
    }
    return emissionsEveryDay;
  }
  /**
   * Fetches the Position reward amount for a given list of addresses.
   * @param {string[]}positionIDs An array of position object ids.
   * @returns {Promise<Record<string, RewarderAmountOwed[]>>} A Promise that resolves with the fetched position reward amount for the specified position object ids.
   */
  async batchFetchPositionRewarders(positionIDs) {
    const posRewardParamsList = [];
    for (const id of positionIDs) {
      const position = await this.sdk.Position.getPositionById(id, false);
      const pool = await this.sdk.Pool.getPool(position.pool);
      posRewardParamsList.push({
        pool_id: pool.pool_id,
        position_id: position.pos_object_id,
        coin_type_a: pool.coin_type_a,
        coin_type_b: pool.coin_type_b,
        rewarder_info: pool.rewarder_infos
      });
    }
    const positionMap = {};
    if (posRewardParamsList.length > 0) {
      const result = await this.fetchPosRewardersAmount(posRewardParamsList);
      for (const posRewarderInfo of result) {
        positionMap[posRewarderInfo.position_id] = posRewarderInfo.rewarder_amount_owed;
      }
      return positionMap;
    }
    return positionMap;
  }
  /**
   * Fetch the position rewards for a given pool.
   * @param {PoolStruct}pool Pool object
   * @param {string}positionId Position object id
   * @returns {Promise<RewarderAmountOwed[]>} A Promise that resolves with the fetched position reward amount for the specified position object id.
   */
  async fetchPositionRewarders(pool, positionId) {
    const param = {
      pool_id: pool.pool_id,
      position_id: positionId,
      coin_type_a: pool.coin_type_a,
      coin_type_b: pool.coin_type_b,
      rewarder_info: pool.rewarder_infos
    };
    const result = await this.fetchPosRewardersAmount([param]);
    return result[0].rewarder_amount_owed;
  }
  /**
   * Fetches the Position fee amount for a given list of addresses.
   * @param positionIDs An array of position object ids.
   * @returns {Promise<Record<string, CollectFeesQuote>>} A Promise that resolves with the fetched position fee amount for the specified position object ids.
   * @deprecated This method is deprecated and may be removed in future versions. Use alternative methods if available.
   */
  async batchFetchPositionFees(positionIDs) {
    const posFeeParamsList = [];
    for (const id of positionIDs) {
      const position = await this.sdk.Position.getPositionById(id, false);
      const pool = await this.sdk.Pool.getPool(position.pool);
      posFeeParamsList.push({
        pool_id: pool.pool_id,
        position_id: position.pos_object_id,
        coin_type_a: pool.coin_type_a,
        coin_type_b: pool.coin_type_b
      });
    }
    const positionMap = {};
    if (posFeeParamsList.length > 0) {
      const result = await this.fetchPosFeeAmount(posFeeParamsList);
      for (const posRewarderInfo of result) {
        positionMap[posRewarderInfo.position_id] = posRewarderInfo;
      }
      return positionMap;
    }
    return positionMap;
  }
  /**
   * Fetches the Position fee amount for a given list of addresses.
   * @param params  An array of FetchPosFeeParams objects containing the target addresses and their corresponding amounts.
   * @returns
   */
  async fetchPosFeeAmount(params) {
    const { clmm_pool, facade, simulationAccount } = this.sdk.sdkOptions;
    const tx = new Transaction8();
    for (const paramItem of params) {
      const typeArguments = [paramItem.coin_type_a, paramItem.coin_type_b];
      const args = [
        tx.object(clmm_pool.config.global_config_id),
        tx.object(paramItem.pool_id),
        tx.pure.address(paramItem.position_id)
      ];
      tx.moveCall({
        target: `${facade.published_at}::${ClmmFetcherModule}::fetch_position_fees`,
        arguments: args,
        typeArguments
      });
    }
    const simulateRes = await this.sdk.fullClient.devInspectTransactionBlock({
      transactionBlock: tx,
      sender: simulationAccount.address
    });
    const valueData = simulateRes.events?.filter((item) => {
      return parseStructTag7(item.type).name === `FetchPositionFeesEvent`;
    });
    if (valueData.length === 0) {
      return [];
    }
    const result = [];
    for (let i = 0; i < valueData.length; i += 1) {
      const { parsedJson } = valueData[i];
      const posRrewarderResult = {
        fee_owed_a: new BN16(parsedJson.fee_owned_a),
        fee_owed_b: new BN16(parsedJson.fee_owned_b),
        position_id: parsedJson.position_id
      };
      result.push(posRrewarderResult);
    }
    return result;
  }
  /**
   * Fetches the Position reward amount for a given list of addresses.
   * @param params  An array of FetchPosRewardParams objects containing the target addresses and their corresponding amounts.
   * @returns
   */
  async fetchPosRewardersAmount(params) {
    const { clmm_pool, facade, simulationAccount } = this.sdk.sdkOptions;
    const tx = new Transaction8();
    for (const paramItem of params) {
      const typeArguments = [paramItem.coin_type_a, paramItem.coin_type_b];
      const args = [
        tx.object(clmm_pool.config.global_config_id),
        tx.object(paramItem.pool_id),
        tx.pure.address(paramItem.position_id),
        tx.object(CLOCK_ADDRESS)
      ];
      tx.moveCall({
        target: `${facade.published_at}::${ClmmFetcherModule}::fetch_position_rewards`,
        arguments: args,
        typeArguments
      });
    }
    const simulateRes = await this.sdk.fullClient.devInspectTransactionBlock({
      transactionBlock: tx,
      sender: simulationAccount.address
    });
    if (simulateRes.error != null) {
      throw new ClmmpoolsError(
        `fetch position rewards error code: ${simulateRes.error ?? "unknown error"}, please check config and params`,
        "InvalidConfig" /* InvalidConfig */
      );
    }
    const valueData = simulateRes.events?.filter((item) => {
      return parseStructTag7(item.type).name === `FetchPositionRewardsEvent`;
    });
    if (valueData.length === 0) {
      return [];
    }
    if (valueData.length !== params.length) {
      throw new ClmmpoolsError("valueData.length !== params.pools.length");
    }
    const result = [];
    for (let i = 0; i < valueData.length; i += 1) {
      const posRrewarderResult = {
        pool_id: params[i].pool_id,
        position_id: params[i].position_id,
        rewarder_amount_owed: []
      };
      for (let j = 0; j < params[i].rewarder_info.length; j += 1) {
        posRrewarderResult.rewarder_amount_owed.push({
          amount_owed: new BN16(valueData[i].parsedJson.data[j]),
          coin_address: params[i].rewarder_info[j].coin_address
        });
      }
      result.push(posRrewarderResult);
    }
    return result;
  }
  /**
   * Fetches the pool reward amount for a given account and pool object id.
   * @param {string} account - The target account.
   * @param {string} poolObjectId - The target pool object id.
   * @returns {Promise<number|null>} - A Promise that resolves with the fetched pool reward amount for the specified account and pool, or null if the fetch is unsuccessful.
   */
  async fetchPoolRewardersAmount(account, poolObjectId) {
    const pool = await this.sdk.Pool.getPool(poolObjectId);
    const positions = await this.sdk.Position.getPositionList(account, [poolObjectId]);
    const params = [];
    for (const position of positions) {
      params.push({
        pool_id: pool.pool_id,
        position_id: position.pos_object_id,
        rewarder_info: pool.rewarder_infos,
        coin_type_a: pool.coin_type_a,
        coin_type_b: pool.coin_type_b
      });
    }
    const result = await this.fetchPosRewardersAmount(params);
    const rewarderAmount = [ZERO, ZERO, ZERO];
    if (result != null) {
      for (const posRewarderInfo of result) {
        for (let j = 0; j < posRewarderInfo.rewarder_amount_owed.length; j += 1) {
          rewarderAmount[j] = rewarderAmount[j].add(
            posRewarderInfo.rewarder_amount_owed[j].amount_owed
          );
        }
      }
    }
    return rewarderAmount;
  }
  /**
   * Collect rewards from Position.
   * @param params
   * @param gasBudget
   * @returns
   */
  async buildCollectRewarderTransaction(params) {
    if (!isValidSuiAddress3(this.sdk.senderAddress)) {
      throw new ClmmpoolsError(
        "this config sdk senderAddress is not set right",
        "InvalidSendAddress" /* InvalidSendAddress */
      );
    }
    const allCoinAsset = await this.sdk.Coin.getOwnerCoinAssets(this.sdk.senderAddress, null);
    let tx = new Transaction8();
    tx = TransactionUtil.buildCollectRewarderAndFeeTransaction(this.sdk, tx, params, allCoinAsset);
    return tx;
  }
  /**
   * batech Collect rewards from Position.
   * @param params
   * @param published_at
   * @param tx
   * @returns
   */
  async buildBatchCollectRewarderTransaction(params, tx, inputCoinA, inputCoinB) {
    if (!isValidSuiAddress3(this.sdk.senderAddress)) {
      throw new ClmmpoolsError(
        "this config sdk senderAddress is not set right",
        "InvalidSendAddress" /* InvalidSendAddress */
      );
    }
    const allCoinAsset = await this.sdk.Coin.getOwnerCoinAssets(this.sdk.senderAddress, null);
    tx = tx || new Transaction8();
    const coinIdMaps = {};
    params.forEach((item) => {
      const coinTypeA = CoinUtil.normalizeCoinType(item.coin_type_a);
      const coinTypeB = CoinUtil.normalizeCoinType(item.coin_type_b);
      if (item.collect_fee) {
        let coinAInput = coinIdMaps[coinTypeA];
        if (coinAInput == null) {
          if (inputCoinA == null) {
            coinAInput = TransactionUtil.buildCoinForAmount(
              tx,
              allCoinAsset,
              BigInt(0),
              coinTypeA,
              false
            );
          } else {
            coinAInput = {
              target_coin: inputCoinA,
              remain_coins: [],
              is_mint_zero_coin: false,
              target_coin_amount: "0"
            };
          }
          coinIdMaps[coinTypeA] = coinAInput;
        }
        let coinBInput = coinIdMaps[coinTypeB];
        if (coinBInput == null) {
          if (inputCoinB == null) {
            coinBInput = TransactionUtil.buildCoinForAmount(
              tx,
              allCoinAsset,
              BigInt(0),
              coinTypeB,
              false
            );
          } else {
            coinBInput = {
              target_coin: inputCoinB,
              remain_coins: [],
              is_mint_zero_coin: false,
              target_coin_amount: "0"
            };
          }
          coinIdMaps[coinTypeB] = coinBInput;
        }
        tx = this.sdk.Position.buildCollectFeeNoSendTransaction(
          {
            pool_id: item.pool_id,
            position_id: item.position_id,
            coin_type_a: item.coin_type_a,
            coin_type_b: item.coin_type_b
          },
          tx,
          coinAInput.target_coin,
          coinBInput.target_coin
        );
      }
      const primaryCoinInputs = [];
      item.rewarder_coin_types.forEach((type) => {
        const coinType = CoinUtil.normalizeCoinType(type);
        let coinInput = coinIdMaps[type];
        if (coinInput === void 0) {
          coinInput = TransactionUtil.buildCoinForAmount(
            tx,
            allCoinAsset,
            BigInt(0),
            coinType,
            false
          );
          coinIdMaps[coinType] = coinInput;
        }
        primaryCoinInputs.push(coinInput.target_coin);
      });
      tx = this.buildCollectRewarderNoSendTransaction(item, tx, primaryCoinInputs);
    });
    Object.keys(coinIdMaps).forEach((key) => {
      const value = coinIdMaps[key];
      if (value.is_mint_zero_coin) {
        TransactionUtil.buildTransferCoin(
          this.sdk,
          tx,
          value.target_coin,
          key,
          this.sdk.senderAddress
        );
      }
    });
    return tx;
  }
  buildCollectRewarderWithCoinTransaction(params, tx, primaryCoinInputs) {
    const { clmm_pool, facade } = this.sdk.sdkOptions;
    const clmmConfigs = clmm_pool.config;
    const typeArguments = [params.coin_type_a, params.coin_type_b];
    params.rewarder_coin_types.forEach((type, index) => {
      if (tx) {
        tx.moveCall({
          target: `${facade.published_at}::${ClmmIntegratePoolModule}::collect_reward`,
          typeArguments: [...typeArguments, type],
          arguments: [
            tx.object(clmmConfigs.global_config_id),
            tx.object(params.pool_id),
            tx.object(params.position_id),
            tx.object(clmmConfigs.global_vault_id),
            primaryCoinInputs[index],
            tx.object(CLOCK_ADDRESS)
          ]
        });
      }
    });
    return tx;
  }
  buildCollectRewarderNoSendTransaction(params, tx, primaryCoinInputs) {
    const { clmm_pool, facade } = this.sdk.sdkOptions;
    const clmmConfigs = clmm_pool.config;
    const typeArguments = [params.coin_type_a, params.coin_type_b];
    params.rewarder_coin_types.forEach((type, index) => {
      if (tx) {
        tx.moveCall({
          target: `${facade.published_at}::${ClmmIntegratePoolModule}::collect_reward_no_send`,
          typeArguments: [...typeArguments, type],
          arguments: [
            tx.object(clmmConfigs.global_config_id),
            tx.object(params.pool_id),
            tx.object(params.position_id),
            tx.object(clmmConfigs.global_vault_id),
            primaryCoinInputs[index],
            tx.object(CLOCK_ADDRESS)
          ]
        });
      }
    });
    return tx;
  }
};

// src/lib/router-v2.ts
import BN17 from "bn.js";
import Decimal7 from "decimal.js";
import { v4 as uuidv4 } from "uuid";
import axios from "axios";
var RouterV2 = class extends BaseLib {
  calculatePrice(currentSqrtPrice, fromDecimals, toDecimals, a2b, label) {
    const decimalA = a2b ? fromDecimals : toDecimals;
    const decimalB = a2b ? toDecimals : fromDecimals;
    if (label === "Parrot") {
      return TickMath.sqrtPriceX64ToPrice(currentSqrtPrice, decimalA, decimalB);
    }
    return new Decimal7(currentSqrtPrice.toString()).div(
      new Decimal7(10).pow(new Decimal7(decimalB + 9 - decimalA))
    );
  }
  parseJsonResult(data) {
    const result = {
      isExceed: data.is_exceed,
      isTimeout: data.is_timeout,
      inputAmount: data.input_amount,
      outputAmount: data.output_amount,
      fromCoin: data.from_coin,
      toCoin: data.to_coin,
      byAmountIn: data.by_amount_in,
      splitPaths: data.split_paths.map((path) => {
        const splitPath = {
          pathIndex: path.path_index,
          lastQuoteOutput: path.last_quote_output,
          percent: path.percent,
          basePaths: path.best_path.map((basePath) => {
            return {
              direction: basePath.direction,
              label: basePath.label,
              poolAddress: basePath.provider,
              fromCoin: basePath.from_coin,
              toCoin: basePath.to_coin,
              outputAmount: basePath.output_amount,
              inputAmount: basePath.input_amount,
              feeRate: basePath.fee_rate,
              currentSqrtPrice: new BN17(basePath.current_sqrt_price.toString()),
              afterSqrtPrice: basePath.label === "Parrot" ? new BN17(basePath.after_sqrt_price.toString()) : ZERO,
              fromDecimal: basePath.from_decimal,
              toDecimal: basePath.to_decimal,
              currentPrice: this.calculatePrice(
                new BN17(basePath.current_sqrt_price.toString()),
                basePath.from_decimal,
                basePath.to_decimal,
                basePath.direction,
                basePath.label
              )
            };
          }),
          inputAmount: path.input_amount,
          outputAmount: path.output_amount
        };
        return splitPath;
      })
    };
    return result;
  }
  async fetchDataWithAxios(apiUrl, _options, timeoutDuration) {
    const config = {
      ..._options,
      timeout: timeoutDuration
    };
    const response = await axios(apiUrl, config);
    if (response.status === 200) {
      return this.parseJsonResult(response.data);
    }
    return null;
  }
  /**
   * Optimal routing method with fallback functionality.
   * This method first attempts to find the optimal route using the routing backend. If the optimal route is available, it will return this route.
   * If the optimal route is not available (for example, due to network issues or API errors), this method will activate a fallback mechanism,
   * and try to find a suboptimal route using the routing algorithm built into the SDK, which only includes clmm pool. This way, even if the optimal route is not available, this method can still provide a usable route.
   * This method uses a fallback strategy to ensure that it can provide the best available route when facing problems, rather than failing completely.
   *
   * @param {string} from Sold `from` coin
   * @param {string} from: get `to` coin
   * @param {number} from: the amount of sold coin
   * @param {boolena} byAmountIn:
   */
  async getBestRouter(from, to, amount, byAmountIn, _senderAddress, swapWithMultiPoolParams, orderSplit = false, externalRouter = false, lpChanges = []) {
    let result = null;
    let version = "v2";
    let options = {};
    let apiUrl = this.sdk.sdkOptions.backendUrl;
    if (lpChanges.length > 0) {
      const url = new URL(apiUrl);
      apiUrl = `${url.protocol}//${url.hostname}/router_with_lp_changes`;
      options = {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        data: JSON.stringify({
          from,
          to,
          amount,
          by_amount_in: byAmountIn,
          order_split: orderSplit,
          external_router: externalRouter,
          sender_address: "None",
          request_id: encodeURIComponent(uuidv4()),
          lp_changes: lpChanges
        })
      };
    } else {
      apiUrl = `
      ${apiUrl}?from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}&amount=${encodeURIComponent(
        amount
      )}&by_amount_in=${encodeURIComponent(byAmountIn)}&order_split=${encodeURIComponent(orderSplit)}&external_router=${encodeURIComponent(
        externalRouter
      )}&sender_address=''&request_id=${encodeURIComponent(uuidv4())}
      `;
    }
    result = await this.fetchDataWithAxios(apiUrl, options, 6e3);
    if (result == null) {
      const priceResult = await this.sdk.Router.priceUseV1(
        from,
        to,
        new BN17(amount),
        byAmountIn,
        swapWithMultiPoolParams
      );
      const splitPaths = [];
      for (const path of priceResult.paths) {
        const basePaths = [];
        if (path.poolAddress.length > 1) {
          const fromDecimal0 = this.sdk.Router.tokenInfo(path.coinType[0]).decimals;
          const toDecimal0 = this.sdk.Router.tokenInfo(path.coinType[1]).decimals;
          const currentPrice = path.a2b[0] ? TickMath.sqrtPriceX64ToPrice(
            new BN17(priceResult.currentSqrtPrice[0]),
            fromDecimal0,
            toDecimal0
          ) : TickMath.sqrtPriceX64ToPrice(
            new BN17(priceResult.currentSqrtPrice[0]),
            toDecimal0,
            fromDecimal0
          );
          const path0 = {
            direction: path.a2b[0],
            label: "Parrot",
            poolAddress: path.poolAddress[0],
            fromCoin: path.coinType[0],
            toCoin: path.coinType[1],
            feeRate: this.sdk.Router.getFeeRate(
              path.coinType[0],
              path.coinType[1],
              path.poolAddress[0]
            ),
            outputAmount: priceResult.byAmountIn ? path.rawAmountLimit[0].toString() : path.rawAmountLimit[1].toString(),
            inputAmount: path.amountIn.toString(),
            currentSqrtPrice: priceResult.currentSqrtPrice[0],
            currentPrice,
            fromDecimal: fromDecimal0,
            toDecimal: toDecimal0
          };
          const fromDecimal1 = this.sdk.Router.tokenInfo(path.coinType[1]).decimals;
          const toDecimal1 = this.sdk.Router.tokenInfo(path.coinType[2]).decimals;
          const currentPrice1 = path.a2b[1] ? TickMath.sqrtPriceX64ToPrice(
            new BN17(priceResult.currentSqrtPrice[1]),
            fromDecimal1,
            toDecimal1
          ) : TickMath.sqrtPriceX64ToPrice(
            new BN17(priceResult.currentSqrtPrice[1]),
            toDecimal1,
            fromDecimal1
          );
          const path1 = {
            direction: path.a2b[1],
            label: "Parrot",
            poolAddress: path.poolAddress[1],
            fromCoin: path.coinType[1],
            toCoin: path.coinType[2],
            feeRate: this.sdk.Router.getFeeRate(
              path.coinType[1],
              path.coinType[2],
              path.poolAddress[1]
            ),
            outputAmount: path.amountOut.toString(),
            inputAmount: priceResult.byAmountIn ? path.rawAmountLimit[0].toString() : path.rawAmountLimit[1].toString(),
            currentSqrtPrice: priceResult.currentSqrtPrice[1],
            currentPrice: currentPrice1,
            fromDecimal: fromDecimal1,
            toDecimal: toDecimal1
          };
          basePaths.push(path0, path1);
        } else {
          const fromDecimal = this.sdk.Router.tokenInfo(path.coinType[0]).decimals;
          const toDecimal = this.sdk.Router.tokenInfo(path.coinType[1]).decimals;
          const currentPrice = path.a2b[0] ? TickMath.sqrtPriceX64ToPrice(
            new BN17(priceResult.currentSqrtPrice[0]),
            fromDecimal,
            toDecimal
          ) : TickMath.sqrtPriceX64ToPrice(
            new BN17(priceResult.currentSqrtPrice[0]),
            toDecimal,
            fromDecimal
          );
          const path0 = {
            direction: path.a2b[0],
            label: "Parrot",
            poolAddress: path.poolAddress[0],
            fromCoin: path.coinType[0],
            toCoin: path.coinType[1],
            feeRate: this.sdk.Router.getFeeRate(
              path.coinType[0],
              path.coinType[1],
              path.poolAddress[0]
            ),
            outputAmount: path.amountOut.toString(),
            inputAmount: path.amountIn.toString(),
            currentSqrtPrice: priceResult.currentSqrtPrice[0],
            currentPrice,
            fromDecimal,
            toDecimal
          };
          basePaths.push(path0);
        }
        const splitPath = {
          percent: Number(path.amountIn) / Number(priceResult.amountIn) * 100,
          inputAmount: Number(path.amountIn.toString()),
          outputAmount: Number(path.amountOut.toString()),
          pathIndex: 0,
          lastQuoteOutput: 0,
          basePaths
        };
        splitPaths.push(splitPath);
      }
      const aggregatorResult = {
        isExceed: priceResult.isExceed,
        isTimeout: true,
        inputAmount: Number(priceResult.amountIn.toString()),
        outputAmount: Number(priceResult.amountOut.toString()),
        fromCoin: priceResult.coinTypeA,
        toCoin: priceResult.coinTypeC != null ? priceResult.coinTypeC : priceResult.coinTypeB,
        byAmountIn: priceResult.byAmountIn,
        splitPaths
      };
      version = "v1";
      result = aggregatorResult;
    }
    return { result, version };
  }
  async getBestRouterByServer(from, to, amount, byAmountIn, _senderAddress, orderSplit = false, externalRouter = false, lpChanges = []) {
    let result = null;
    let options = {};
    let apiUrl = this.sdk.sdkOptions.backendUrl;
    if (lpChanges.length > 0) {
      const url = new URL(apiUrl);
      apiUrl = `${url.protocol}//${url.hostname}/router_with_lp_changes`;
      options = {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        data: JSON.stringify({
          from,
          to,
          amount,
          by_amount_in: byAmountIn,
          order_split: orderSplit,
          external_router: externalRouter,
          sender_address: "None",
          request_id: encodeURIComponent(uuidv4()),
          lp_changes: lpChanges
        })
      };
    } else {
      apiUrl = `
      ${apiUrl}?from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}&amount=${encodeURIComponent(
        amount
      )}&by_amount_in=${encodeURIComponent(byAmountIn)}&order_split=${encodeURIComponent(orderSplit)}&external_router=${encodeURIComponent(
        externalRouter
      )}&sender_address=''&request_id=${encodeURIComponent(uuidv4())}
      `;
    }
    result = await this.fetchDataWithAxios(apiUrl, options, 6e3);
    if (result == null) {
      throw new ClmmpoolsError("Invalid server response", "InvalidServerResponse" /* InvalidServerResponse */);
    }
    return result;
  }
  async getBestRouterByRpc(from, to, amount, byAmountIn, swapWithMultiPoolParams) {
    const priceResult = await this.sdk.Router.priceUseV1(
      from,
      to,
      new BN17(amount),
      byAmountIn,
      swapWithMultiPoolParams
    );
    const splitPaths = [];
    for (const path of priceResult.paths) {
      const basePaths = [];
      if (path.poolAddress.length > 1) {
        const fromDecimal0 = this.sdk.Router.tokenInfo(path.coinType[0]).decimals;
        const toDecimal0 = this.sdk.Router.tokenInfo(path.coinType[1]).decimals;
        const currentPrice = path.a2b[0] ? TickMath.sqrtPriceX64ToPrice(
          new BN17(priceResult.currentSqrtPrice[0]),
          fromDecimal0,
          toDecimal0
        ) : TickMath.sqrtPriceX64ToPrice(
          new BN17(priceResult.currentSqrtPrice[0]),
          toDecimal0,
          fromDecimal0
        );
        const path0 = {
          direction: path.a2b[0],
          label: "Parrot",
          poolAddress: path.poolAddress[0],
          fromCoin: path.coinType[0],
          toCoin: path.coinType[1],
          feeRate: this.sdk.Router.getFeeRate(
            path.coinType[0],
            path.coinType[1],
            path.poolAddress[0]
          ),
          outputAmount: priceResult.byAmountIn ? path.rawAmountLimit[0].toString() : path.rawAmountLimit[1].toString(),
          inputAmount: path.amountIn.toString(),
          currentSqrtPrice: priceResult.currentSqrtPrice[0],
          currentPrice,
          fromDecimal: fromDecimal0,
          toDecimal: toDecimal0
        };
        const fromDecimal1 = this.sdk.Router.tokenInfo(path.coinType[1]).decimals;
        const toDecimal1 = this.sdk.Router.tokenInfo(path.coinType[2]).decimals;
        const currentPrice1 = path.a2b[1] ? TickMath.sqrtPriceX64ToPrice(
          new BN17(priceResult.currentSqrtPrice[1]),
          fromDecimal1,
          toDecimal1
        ) : TickMath.sqrtPriceX64ToPrice(
          new BN17(priceResult.currentSqrtPrice[1]),
          toDecimal1,
          fromDecimal1
        );
        const path1 = {
          direction: path.a2b[1],
          label: "Parrot",
          poolAddress: path.poolAddress[1],
          fromCoin: path.coinType[1],
          toCoin: path.coinType[2],
          feeRate: this.sdk.Router.getFeeRate(
            path.coinType[1],
            path.coinType[2],
            path.poolAddress[1]
          ),
          outputAmount: path.amountOut.toString(),
          inputAmount: priceResult.byAmountIn ? path.rawAmountLimit[0].toString() : path.rawAmountLimit[1].toString(),
          currentSqrtPrice: priceResult.currentSqrtPrice[1],
          currentPrice: currentPrice1,
          fromDecimal: fromDecimal1,
          toDecimal: toDecimal1
        };
        basePaths.push(path0, path1);
      } else {
        const fromDecimal = this.sdk.Router.tokenInfo(path.coinType[0]).decimals;
        const toDecimal = this.sdk.Router.tokenInfo(path.coinType[1]).decimals;
        const currentPrice = path.a2b[0] ? TickMath.sqrtPriceX64ToPrice(
          new BN17(priceResult.currentSqrtPrice[0]),
          fromDecimal,
          toDecimal
        ) : TickMath.sqrtPriceX64ToPrice(
          new BN17(priceResult.currentSqrtPrice[0]),
          toDecimal,
          fromDecimal
        );
        const path0 = {
          direction: path.a2b[0],
          label: "Parrot",
          poolAddress: path.poolAddress[0],
          fromCoin: path.coinType[0],
          toCoin: path.coinType[1],
          feeRate: this.sdk.Router.getFeeRate(
            path.coinType[0],
            path.coinType[1],
            path.poolAddress[0]
          ),
          outputAmount: path.amountOut.toString(),
          inputAmount: path.amountIn.toString(),
          currentSqrtPrice: priceResult.currentSqrtPrice[0],
          currentPrice,
          fromDecimal,
          toDecimal
        };
        basePaths.push(path0);
      }
      const splitPath = {
        percent: Number(path.amountIn) / Number(priceResult.amountIn) * 100,
        inputAmount: Number(path.amountIn.toString()),
        outputAmount: Number(path.amountOut.toString()),
        pathIndex: 0,
        lastQuoteOutput: 0,
        basePaths
      };
      splitPaths.push(splitPath);
    }
    const aggregatorResult = {
      isExceed: priceResult.isExceed,
      isTimeout: true,
      inputAmount: Number(priceResult.amountIn.toString()),
      outputAmount: Number(priceResult.amountOut.toString()),
      fromCoin: priceResult.coinTypeA,
      toCoin: priceResult.coinTypeC != null ? priceResult.coinTypeC : priceResult.coinTypeB,
      byAmountIn: priceResult.byAmountIn,
      splitPaths
    };
    return aggregatorResult;
  }
};

// src/config/mainnet.ts
import { getFullnodeUrl } from "@mysten/sui/client";

// src/sdk.ts
var ParrotClmmSDK = class {
  /**
   * RPC provider on the SUI chain
   */
  _rpcModule;
  /**
   * Provide interact with clmm pools with a pool router interface.
   */
  _pool;
  /**
   * Provide interact with clmm position with a position router interface.
   */
  _position;
  /**
   * Provide interact with a pool swap router interface.
   */
  _swap;
  /**
   * Provide interact  with a position rewarder interface.
   */
  _rewarder;
  /**
   * Provide interact with a pool router interface.
   */
  _router;
  /**
   * Provide interact with a pool routerV2 interface.
   */
  _router_v2;
  _coin;
  /**
   *  Provide sdk options
   */
  _sdkOptions;
  /**
   * After connecting the wallet, set the current wallet address to senderAddress.
   */
  _senderAddress = "";
  constructor(options) {
    this._sdkOptions = options;
    this._rpcModule = new SuiRpc({
      url: options.fullRpcUrl
    });
    this._swap = new Swap(this);
    this._pool = new Pool(this);
    this._position = new Position(this);
    this._rewarder = new Rewarder(this);
    this._router = new Router(this);
    this._router_v2 = new RouterV2(this);
    this._coin = new Coin(this);
    SuiUtil.patchFixSuiObjectId(this._sdkOptions);
  }
  /**
   * Getter for the sender address property.
   * @returns {SuiAddressType} The sender address.
   */
  get senderAddress() {
    return this._senderAddress;
  }
  /**
   * Setter for the sender address property.
   * @param {string} value - The new sender address value.
   */
  set senderAddress(value) {
    this._senderAddress = value;
  }
  /**
   * Getter for the Swap property.
   * @returns {Swap} The Swap property value.
   */
  get Swap() {
    return this._swap;
  }
  /**
   * Getter for the fullClient property.
   * @returns {SuiRpc} The fullClient property value.
   */
  get fullClient() {
    return this._rpcModule;
  }
  /**
   * Getter for the sdkOptions property.
   * @returns {SdkOptions} The sdkOptions property value.
   */
  get sdkOptions() {
    return this._sdkOptions;
  }
  /**
   * Getter for the Pool property.
   * @returns {PoolStruct} The Pool property value.
   */
  get Pool() {
    return this._pool;
  }
  /**
   * Getter for the Position property.
   * @returns {Position} The Position property value.
   */
  get Position() {
    return this._position;
  }
  /**
   * Getter for the Rewarder property.
   * @returns {Rewarder} The Rewarder property value.
   */
  get Rewarder() {
    return this._rewarder;
  }
  /**
   * Getter for the Router property.
   * @returns {Router} The Router property value.
   */
  get Router() {
    return this._router;
  }
  /**
   * Getter for the RouterV2 property.
   * @returns {RouterV2} The RouterV2 property value.
   */
  get RouterV2() {
    return this._router_v2;
  }
  get Coin() {
    return this._coin;
  }
  async getGlobalConfig() {
    const configObject = await this.fullClient.getObject({
      id: this.sdkOptions.clmm_pool.config.global_config_id,
      options: { showContent: true }
    });
    const configObjectFields = SuiUtil.getObjectFields(configObject);
    const feeTiers = [];
    configObjectFields.fee_tiers.fields.contents.forEach((element) => {
      feeTiers.push({
        tick_spacing: element.fields.value.fields.tick_spacing,
        fee_rate: element.fields.value.fields.fee_rate
      });
    });
    const globalConfig = {
      protocol_fee_rate: Number(configObjectFields.protocol_fee_rate),
      fee_tiers: feeTiers,
      package_version: Number(configObjectFields.package_version),
      send_message_fee: Number(configObjectFields.send_message_fee),
      fee_receiver: configObjectFields.fee_receiver
    };
    return globalConfig;
  }
};

// src/config/mainnet.ts
var clmmMainnet = {
  fullRpcUrl: getFullnodeUrl("mainnet"),
  simulationAccount: {
    address: "0x0000000000000000000000000000000000000000000000000000000000000000"
  },
  clmm_pool: {
    package_id: "",
    published_at: "",
    config: {
      pools_id: "",
      global_config_id: "",
      global_vault_id: "",
      admin_cap_id: "",
      coin_list_id: "",
      coin_list_handle_id: "",
      trade_partners_id: "",
      pool_partners_id: ""
    }
  },
  facade: {
    package_id: "",
    published_at: "",
    config: void 0
  },
  backendUrl: ""
};
function initMainnetSDK(fullNodeUrl = getFullnodeUrl("mainnet"), simulationAccount = "0x0000000000000000000000000000000000000000000000000000000000000000") {
  clmmMainnet.fullRpcUrl = fullNodeUrl || clmmMainnet.fullRpcUrl;
  clmmMainnet.simulationAccount.address = simulationAccount || clmmMainnet.simulationAccount.address;
  return new ParrotClmmSDK(clmmMainnet);
}

// src/config/testnet.ts
import { getFullnodeUrl as getFullnodeUrl2 } from "@mysten/sui/client";
var clmmTestnet = {
  fullRpcUrl: getFullnodeUrl2("testnet"),
  simulationAccount: {
    address: "0x0000000000000000000000000000000000000000000000000000000000000000"
  },
  clmm_pool: {
    package_id: "0xfda4d4e6b103f819e6b73c825e82e17cac3ee8384fb8409dd9e9f5e6c192506b",
    published_at: "0xfda4d4e6b103f819e6b73c825e82e17cac3ee8384fb8409dd9e9f5e6c192506b",
    config: {
      pools_id: "0xb846999524eebd9ac329687207e273cb907bf2f40a20f3f60158efab8f3e180e",
      global_config_id: "0xc85cbb029e8ce99e711181dfe8e97fbd6887c4c67940d4100ad0ea847659eeeb",
      global_vault_id: "0x9fc55273fad05d675fa9ca742091c72f635e80b0708a139686c9c4b060b0fa6d",
      admin_cap_id: "0x83436289a28aed12a953fe33304a6bb0aecb3b9f92c2f1a8e0a2af33c9907f1c",
      coin_list_id: "0xe780bde69cb6b93af8a78699fb8b065ccb2fd5d5b9d1d533f58848a3b7262dee",
      coin_list_handle_id: "0xe780bde69cb6b93af8a78699fb8b065ccb2fd5d5b9d1d533f58848a3b7262dee",
      trade_partners_id: "0xb649c497797ed5fa4aefd301371289cbe05bec872357bdc48ed87c02ad1fd4c5",
      pool_partners_id: "0x2a7e947da0235c6bef27f7d41288ea2acfcb2b594b72f4ec1f479d247715eca4"
    }
  },
  facade: {
    package_id: "0x0800e8efbe17fdfe087b38e7ffbc1d8e2def75ef5099078344dcac32a8054262",
    published_at: "0x0800e8efbe17fdfe087b38e7ffbc1d8e2def75ef5099078344dcac32a8054262",
    config: void 0
  },
  backendUrl: ""
};
function initTestnetSDK(fullNodeUrl = getFullnodeUrl2("testnet"), simulationAccount = "0x0000000000000000000000000000000000000000000000000000000000000000") {
  clmmTestnet.fullRpcUrl = fullNodeUrl || clmmTestnet.fullRpcUrl;
  clmmTestnet.simulationAccount.address = simulationAccount || clmmTestnet.simulationAccount.address;
  return new ParrotClmmSDK(clmmTestnet);
}

// src/config/config.ts
import { isValidSuiAddress as isValidSuiAddress4 } from "@mysten/sui/utils";
function initParrotSDK({
  network,
  full_node_url: fullNodeUrl,
  simulation_account: simulationAccount = "0x0000000000000000000000000000000000000000000000000000000000000000"
}) {
  if (!isValidSuiAddress4(simulationAccount)) {
    throw new ClmmpoolsError(
      "simulationAccount is invalid",
      "InvalidSimulateAccount" /* InvalidSimulateAccount */
    );
  }
  return network === "mainnet" ? initMainnetSDK(fullNodeUrl, simulationAccount) : initTestnetSDK(fullNodeUrl, simulationAccount);
}

// src/index.ts
import { default as default2 } from "bn.js";
import { Decimal as Decimal8 } from "decimal.js";
export {
  AMM_SWAP_MODULE,
  AprUtil,
  default2 as BN,
  CLOCK_ADDRESS,
  ClmmExpectSwapModule,
  ClmmFetcherModule,
  ClmmIntegrateCoinUtilsModule,
  ClmmIntegratePoolModule,
  ClmmIntegrateRouterModule,
  ClmmIntegrateRouterWithPartnerModule,
  ClmmPartnerModule,
  ClmmPositionStatus,
  ClmmpoolsError,
  Coin,
  CoinErrorCode,
  CoinInfoAddress,
  CoinStoreAddress,
  CoinUtil,
  ConfigErrorCode,
  DEFAULT_GAS_BUDGET_FOR_MERGE,
  DEFAULT_GAS_BUDGET_FOR_SPLIT,
  DEFAULT_GAS_BUDGET_FOR_STAKE,
  DEFAULT_GAS_BUDGET_FOR_TRANSFER,
  DEFAULT_GAS_BUDGET_FOR_TRANSFER_SUI,
  DEFAULT_NFT_TRANSFER_GAS_FEE,
  Decimal8 as Decimal,
  DeepbookClobV2Moudle,
  DeepbookCustodianV2Moudle,
  DeepbookEndpointsV2Moudle,
  FEE_RATE_DENOMINATOR,
  GAS_SYMBOL,
  GAS_TYPE_ARG,
  GAS_TYPE_ARG_LONG,
  MAX_SQRT_PRICE,
  MAX_TICK_INDEX,
  MIN_SQRT_PRICE,
  MIN_TICK_INDEX,
  MathErrorCode,
  MathUtil,
  ONE,
  POOL_STRUCT,
  ParrotClmmSDK,
  PartnerErrorCode,
  Percentage,
  Pool,
  PoolErrorCode,
  PoolUtil,
  Position,
  PositionErrorCode,
  PositionUtil,
  Rewarder,
  Router,
  RouterErrorCode,
  RouterV2,
  SUI_SYSTEM_STATE_OBJECT_ID,
  SplitSwap,
  SplitSwapUnit,
  SuiRpc,
  SuiUtil,
  Swap,
  SwapDirection,
  SwapErrorCode,
  SwapUtil,
  TICK_ARRAY_SIZE,
  TWO,
  TickMath,
  TickUtil,
  TransactionUtil,
  TypesErrorCode,
  U128,
  U128_MAX,
  U64_MAX,
  UtilsErrorCode,
  ZERO,
  clmmMainnet,
  clmmTestnet,
  findAdjustCoin,
  initMainnetSDK,
  initParrotSDK,
  initTestnetSDK,
  printTransaction
};
//# sourceMappingURL=index.js.map